var Lc = Object.defineProperty;
var Pc = (e, t, n) => t in e ? Lc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Mt = (e, t, n) => (Pc(e, typeof t != "symbol" ? t + "" : t, n), n);
import { getAddress as Qt, getContract as Rs, encodeFunctionData as Oe, pad as ya, getContractAddress as ma, encodeAbiParameters as ga, concat as wa, bytesToHex as _c, numberToBytes as zc, parseAbi as Hc, createPublicClient as Gc, custom as Qc, http as Vc, isAddressEqual as qc, numberToHex as jc, hexToNumber as _i, parseUnits as Mo } from "viem";
const Zc = [
  {
    inputs: [],
    name: "InitializationFailed",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "implementation",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "tokenContract",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "salt",
        type: "uint256"
      }
    ],
    name: "AccountCreated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "implementation",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "tokenContract",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "salt",
        type: "uint256"
      }
    ],
    name: "account",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "implementation",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "tokenContract",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "salt",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "initData",
        type: "bytes"
      }
    ],
    name: "createAccount",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
], Kc = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "TransactionExecuted",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "executeCall",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "nonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "tokenContract",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
], Yc = [
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], Jc = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_from",
        type: "address"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], Xc = [
  {
    type: "event",
    inputs: [
      { name: "owner", type: "address", indexed: !0 },
      { name: "spender", type: "address", indexed: !0 },
      { name: "value", type: "uint256", indexed: !1 }
    ],
    name: "Approval"
  },
  {
    type: "event",
    inputs: [
      { name: "from", type: "address", indexed: !0 },
      { name: "to", type: "address", indexed: !0 },
      { name: "value", type: "uint256", indexed: !1 }
    ],
    name: "Transfer"
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ name: "", type: "bool" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "sender", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ name: "", type: "bool" }]
  }
], Wc = [
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate",
    outputs: [
      { internalType: "uint256", name: "blockNumber", type: "uint256" },
      { internalType: "bytes[]", name: "returnData", type: "bytes[]" }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bool", name: "allowFailure", type: "bool" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call3[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bool", name: "allowFailure", type: "bool" },
          { internalType: "uint256", name: "value", type: "uint256" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call3Value[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3Value",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "blockAndAggregate",
    outputs: [
      { internalType: "uint256", name: "blockNumber", type: "uint256" },
      { internalType: "bytes32", name: "blockHash", type: "bytes32" },
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "getBasefee",
    outputs: [{ internalType: "uint256", name: "basefee", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "blockNumber", type: "uint256" }],
    name: "getBlockHash",
    outputs: [{ internalType: "bytes32", name: "blockHash", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getBlockNumber",
    outputs: [{ internalType: "uint256", name: "blockNumber", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getChainId",
    outputs: [{ internalType: "uint256", name: "chainid", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockCoinbase",
    outputs: [{ internalType: "address", name: "coinbase", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockDifficulty",
    outputs: [{ internalType: "uint256", name: "difficulty", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockGasLimit",
    outputs: [{ internalType: "uint256", name: "gaslimit", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockTimestamp",
    outputs: [{ internalType: "uint256", name: "timestamp", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "getEthBalance",
    outputs: [{ internalType: "uint256", name: "balance", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getLastBlockHash",
    outputs: [{ internalType: "bytes32", name: "blockHash", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bool", name: "requireSuccess", type: "bool" },
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "tryAggregate",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bool", name: "requireSuccess", type: "bool" },
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "tryBlockAndAggregate",
    outputs: [
      { internalType: "uint256", name: "blockNumber", type: "uint256" },
      { internalType: "bytes32", name: "blockHash", type: "bytes32" },
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  }
], $c = [
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [
      { name: "_guardian", internalType: "address", type: "address" },
      { name: "_initialImplementation", internalType: "address", type: "address" }
    ]
  },
  { type: "error", inputs: [], name: "AlreadyInitialized" },
  { type: "error", inputs: [], name: "InvalidImplementation" },
  {
    type: "event",
    anonymous: !1,
    inputs: [
      { name: "previousAdmin", internalType: "address", type: "address", indexed: !1 },
      { name: "newAdmin", internalType: "address", type: "address", indexed: !1 }
    ],
    name: "AdminChanged"
  },
  {
    type: "event",
    anonymous: !1,
    inputs: [{ name: "beacon", internalType: "address", type: "address", indexed: !0 }],
    name: "BeaconUpgraded"
  },
  {
    type: "event",
    anonymous: !1,
    inputs: [
      { name: "implementation", internalType: "address", type: "address", indexed: !0 }
    ],
    name: "Upgraded"
  },
  { stateMutability: "payable", type: "fallback" },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "implementation", internalType: "address", type: "address" }],
    name: "initialize",
    outputs: []
  },
  { stateMutability: "payable", type: "receive" }
], tf = [
  {
    stateMutability: "nonpayable",
    type: "constructor",
    inputs: [
      { name: "entryPoint_", internalType: "address", type: "address" },
      { name: "multicallForwarder", internalType: "address", type: "address" },
      { name: "erc6551Registry", internalType: "address", type: "address" },
      { name: "guardian", internalType: "address", type: "address" }
    ]
  },
  { type: "error", inputs: [], name: "AccountLocked" },
  { type: "error", inputs: [], name: "ContractCreationFailed" },
  { type: "error", inputs: [], name: "ExceedsMaxLockTime" },
  { type: "error", inputs: [], name: "InvalidAccountProof" },
  { type: "error", inputs: [], name: "InvalidERC6551Registry" },
  { type: "error", inputs: [], name: "InvalidEntryPoint" },
  { type: "error", inputs: [], name: "InvalidImplementation" },
  { type: "error", inputs: [], name: "InvalidInput" },
  { type: "error", inputs: [], name: "InvalidMulticallForwarder" },
  { type: "error", inputs: [], name: "InvalidOperation" },
  { type: "error", inputs: [], name: "NotAuthorized" },
  { type: "error", inputs: [], name: "OwnershipCycle" },
  {
    type: "event",
    anonymous: !1,
    inputs: [
      { name: "previousAdmin", internalType: "address", type: "address", indexed: !1 },
      { name: "newAdmin", internalType: "address", type: "address", indexed: !1 }
    ],
    name: "AdminChanged"
  },
  {
    type: "event",
    anonymous: !1,
    inputs: [{ name: "beacon", internalType: "address", type: "address", indexed: !0 }],
    name: "BeaconUpgraded"
  },
  {
    type: "event",
    anonymous: !1,
    inputs: [
      { name: "lockedUntil", internalType: "uint256", type: "uint256", indexed: !1 }
    ],
    name: "LockUpdated"
  },
  {
    type: "event",
    anonymous: !1,
    inputs: [
      { name: "owner", internalType: "address", type: "address", indexed: !1 },
      { name: "selector", internalType: "bytes4", type: "bytes4", indexed: !1 },
      {
        name: "implementation",
        internalType: "address",
        type: "address",
        indexed: !1
      }
    ],
    name: "OverrideUpdated"
  },
  {
    type: "event",
    anonymous: !1,
    inputs: [
      { name: "owner", internalType: "address", type: "address", indexed: !1 },
      { name: "caller", internalType: "address", type: "address", indexed: !1 },
      { name: "hasPermission", internalType: "bool", type: "bool", indexed: !1 }
    ],
    name: "PermissionUpdated"
  },
  {
    type: "event",
    anonymous: !1,
    inputs: [
      { name: "implementation", internalType: "address", type: "address", indexed: !0 }
    ],
    name: "Upgraded"
  },
  { stateMutability: "payable", type: "fallback" },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "entryPoint",
    outputs: [{ name: "", internalType: "contract IEntryPoint", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "erc6551Registry",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "to", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "data", internalType: "bytes", type: "bytes" },
      { name: "operation", internalType: "uint8", type: "uint8" }
    ],
    name: "execute",
    outputs: [{ name: "", internalType: "bytes", type: "bytes" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      {
        name: "operations",
        internalType: "struct BatchExecutor.Operation[]",
        type: "tuple[]",
        components: [
          { name: "to", internalType: "address", type: "address" },
          { name: "value", internalType: "uint256", type: "uint256" },
          { name: "data", internalType: "bytes", type: "bytes" },
          { name: "operation", internalType: "uint8", type: "uint8" }
        ]
      }
    ],
    name: "executeBatch",
    outputs: [{ name: "", internalType: "bytes[]", type: "bytes[]" }]
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "to", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "data", internalType: "bytes", type: "bytes" },
      { name: "operation", internalType: "uint8", type: "uint8" },
      {
        name: "proof",
        internalType: "struct NestedAccountExecutor.ERC6551AccountInfo[]",
        type: "tuple[]",
        components: [
          { name: "salt", internalType: "bytes32", type: "bytes32" },
          { name: "tokenContract", internalType: "address", type: "address" },
          { name: "tokenId", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    name: "executeNested",
    outputs: [{ name: "", internalType: "bytes", type: "bytes" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "to", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    name: "extcall",
    outputs: [{ name: "result", internalType: "bytes", type: "bytes" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "bytecode", internalType: "bytes", type: "bytes" }
    ],
    name: "extcreate",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "salt", internalType: "bytes32", type: "bytes32" },
      { name: "bytecode", internalType: "bytes", type: "bytes" }
    ],
    name: "extcreate2",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "slot", internalType: "bytes32", type: "bytes32" }],
    name: "extsload",
    outputs: [{ name: "value", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "getNonce",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "isLocked",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "forwarder", internalType: "address", type: "address" }],
    name: "isTrustedForwarder",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "hash", internalType: "bytes32", type: "bytes32" },
      { name: "signature", internalType: "bytes", type: "bytes" }
    ],
    name: "isValidSignature",
    outputs: [{ name: "magicValue", internalType: "bytes4", type: "bytes4" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "signer", internalType: "address", type: "address" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    name: "isValidSigner",
    outputs: [{ name: "magicValue", internalType: "bytes4", type: "bytes4" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "_lockedUntil", internalType: "uint256", type: "uint256" }],
    name: "lock",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "lockedUntil",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256[]", type: "uint256[]" },
      { name: "", internalType: "uint256[]", type: "uint256[]" },
      { name: "", internalType: "bytes", type: "bytes" }
    ],
    name: "onERC1155BatchReceived",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "bytes", type: "bytes" }
    ],
    name: "onERC1155Received",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
      { name: "tokenId", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "bytes", type: "bytes" }
    ],
    name: "onERC721Received",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "bytes4", type: "bytes4" }
    ],
    name: "overrides",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" }
    ],
    name: "permissions",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "proxiableUUID",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "selectors", internalType: "bytes4[]", type: "bytes4[]" },
      { name: "implementations", internalType: "address[]", type: "address[]" }
    ],
    name: "setOverrides",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "callers", internalType: "address[]", type: "address[]" },
      { name: "_permissions", internalType: "bool[]", type: "bool[]" }
    ],
    name: "setPermissions",
    outputs: []
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "state",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [{ name: "interfaceId", internalType: "bytes4", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", internalType: "bool", type: "bool" }]
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [],
    name: "token",
    outputs: [
      { name: "chainId", internalType: "uint256", type: "uint256" },
      { name: "tokenContract", internalType: "address", type: "address" },
      { name: "tokenId", internalType: "uint256", type: "uint256" }
    ]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [{ name: "newImplementation", internalType: "address", type: "address" }],
    name: "upgradeTo",
    outputs: []
  },
  {
    stateMutability: "payable",
    type: "function",
    inputs: [
      { name: "newImplementation", internalType: "address", type: "address" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    name: "upgradeToAndCall",
    outputs: []
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      {
        name: "userOp",
        internalType: "struct UserOperation",
        type: "tuple",
        components: [
          { name: "sender", internalType: "address", type: "address" },
          { name: "nonce", internalType: "uint256", type: "uint256" },
          { name: "initCode", internalType: "bytes", type: "bytes" },
          { name: "callData", internalType: "bytes", type: "bytes" },
          { name: "callGasLimit", internalType: "uint256", type: "uint256" },
          { name: "verificationGasLimit", internalType: "uint256", type: "uint256" },
          { name: "preVerificationGas", internalType: "uint256", type: "uint256" },
          { name: "maxFeePerGas", internalType: "uint256", type: "uint256" },
          { name: "maxPriorityFeePerGas", internalType: "uint256", type: "uint256" },
          { name: "paymasterAndData", internalType: "bytes", type: "bytes" },
          { name: "signature", internalType: "bytes", type: "bytes" }
        ]
      },
      { name: "userOpHash", internalType: "bytes32", type: "bytes32" },
      { name: "missingAccountFunds", internalType: "uint256", type: "uint256" }
    ],
    name: "validateUserOp",
    outputs: [{ name: "validationData", internalType: "uint256", type: "uint256" }]
  },
  { stateMutability: "payable", type: "receive" }
], ef = [
  { type: "error", inputs: [], name: "AccountCreationFailed" },
  {
    type: "event",
    anonymous: !1,
    inputs: [
      { name: "account", internalType: "address", type: "address", indexed: !1 },
      { name: "implementation", internalType: "address", type: "address", indexed: !0 },
      { name: "salt", internalType: "bytes32", type: "bytes32", indexed: !1 },
      { name: "chainId", internalType: "uint256", type: "uint256", indexed: !1 },
      { name: "tokenContract", internalType: "address", type: "address", indexed: !0 },
      { name: "tokenId", internalType: "uint256", type: "uint256", indexed: !0 }
    ],
    name: "ERC6551AccountCreated"
  },
  {
    stateMutability: "view",
    type: "function",
    inputs: [
      { name: "implementation", internalType: "address", type: "address" },
      { name: "salt", internalType: "bytes32", type: "bytes32" },
      { name: "chainId", internalType: "uint256", type: "uint256" },
      { name: "tokenContract", internalType: "address", type: "address" },
      { name: "tokenId", internalType: "uint256", type: "uint256" }
    ],
    name: "account",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  },
  {
    stateMutability: "nonpayable",
    type: "function",
    inputs: [
      { name: "implementation", internalType: "address", type: "address" },
      { name: "salt", internalType: "bytes32", type: "bytes32" },
      { name: "chainId", internalType: "uint256", type: "uint256" },
      { name: "tokenContract", internalType: "address", type: "address" },
      { name: "tokenId", internalType: "uint256", type: "uint256" }
    ],
    name: "createAccount",
    outputs: [{ name: "", internalType: "address", type: "address" }]
  }
];
function ba(e) {
  const t = e.slice(2), n = new Uint8Array(t.length / 2);
  for (let r = 0; r < t.length; r += 2)
    n[r / 2] = parseInt(t.substr(r, 2), 16);
  return n;
}
function xe(e) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...e
  };
}
const nf = {
  gasPriceOracle: { address: "0x420000000000000000000000000000000000000F" },
  l1Block: { address: "0x4200000000000000000000000000000000000015" },
  l2CrossDomainMessenger: {
    address: "0x4200000000000000000000000000000000000007"
  },
  l2Erc721Bridge: { address: "0x4200000000000000000000000000000000000014" },
  l2StandardBridge: { address: "0x4200000000000000000000000000000000000010" },
  l2ToL1MessagePasser: {
    address: "0x4200000000000000000000000000000000000016"
  }
}, rf = "2.10.5", sf = () => `viem@${rf}`;
class Rt extends Error {
  constructor(t, n = {}) {
    var s;
    super(), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ViemError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: sf()
    });
    const r = n.cause instanceof Rt ? n.cause.details : (s = n.cause) != null && s.message ? n.cause.message : n.details, i = n.cause instanceof Rt && n.cause.docsPath || n.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...i ? [
        `Docs: https://viem.sh${i}${n.docsSlug ? `#${n.docsSlug}` : ""}`
      ] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: ${this.version}`
    ].join(`
`), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return Aa(this, t);
  }
}
function Aa(e, t) {
  return t != null && t(e) ? e : e && typeof e == "object" && "cause" in e ? Aa(e.cause, t) : t ? null : e;
}
class of extends Rt {
  constructor({ max: t, min: n, signed: r, size: i, value: s }) {
    super(`Number "${s}" is not in safe ${i ? `${i * 8}-bit ${r ? "signed" : "unsigned"} ` : ""}integer range ${t ? `(${n} to ${t})` : `(above ${n})`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntegerOutOfRangeError"
    });
  }
}
class af extends Rt {
  constructor({ givenSize: t, maxSize: n }) {
    super(`Size cannot exceed ${n} bytes. Given size: ${t} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeOverflowError"
    });
  }
}
function Ir(e, { strict: t = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : t ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function mn(e) {
  return Ir(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function Co(e, { dir: t = "left" } = {}) {
  let n = typeof e == "string" ? e.replace("0x", "") : e, r = 0;
  for (let i = 0; i < n.length - 1 && n[t === "left" ? i : n.length - i - 1].toString() === "0"; i++)
    r++;
  return n = t === "left" ? n.slice(r) : n.slice(0, n.length - r), typeof e == "string" ? (n.length === 1 && t === "right" && (n = `${n}0`), `0x${n.length % 2 === 1 ? `0${n}` : n}`) : n;
}
class xa extends Rt {
  constructor({ offset: t, position: n, size: r }) {
    super(`Slice ${n === "start" ? "starting" : "ending"} at offset "${t}" is out-of-bounds (size: ${r}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SliceOffsetOutOfBoundsError"
    });
  }
}
class Ea extends Rt {
  constructor({ size: t, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} size (${t}) exceeds padding size (${n}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeExceedsPaddingSizeError"
    });
  }
}
function or(e, { dir: t, size: n = 32 } = {}) {
  return typeof e == "string" ? uf(e, { dir: t, size: n }) : cf(e, { dir: t, size: n });
}
function uf(e, { dir: t, size: n = 32 } = {}) {
  if (n === null)
    return e;
  const r = e.replace("0x", "");
  if (r.length > n * 2)
    throw new Ea({
      size: Math.ceil(r.length / 2),
      targetSize: n,
      type: "hex"
    });
  return `0x${r[t === "right" ? "padEnd" : "padStart"](n * 2, "0")}`;
}
function cf(e, { dir: t, size: n = 32 } = {}) {
  if (n === null)
    return e;
  if (e.length > n)
    throw new Ea({
      size: e.length,
      targetSize: n,
      type: "bytes"
    });
  const r = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    const s = t === "right";
    r[s ? i : n - i - 1] = e[s ? i : e.length - i - 1];
  }
  return r;
}
const ff = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function wt(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? va(e, t) : typeof e == "string" ? df(e, t) : typeof e == "boolean" ? lf(e, t) : gn(e, t);
}
function lf(e, t = {}) {
  const n = `0x${Number(e)}`;
  return typeof t.size == "number" ? (ar(n, { size: t.size }), or(n, { size: t.size })) : n;
}
function gn(e, t = {}) {
  let n = "";
  for (let i = 0; i < e.length; i++)
    n += ff[e[i]];
  const r = `0x${n}`;
  return typeof t.size == "number" ? (ar(r, { size: t.size }), or(r, { dir: "right", size: t.size })) : r;
}
function va(e, t = {}) {
  const { signed: n, size: r } = t, i = BigInt(e);
  let s;
  r ? n ? s = (1n << BigInt(r) * 8n - 1n) - 1n : s = 2n ** (BigInt(r) * 8n) - 1n : typeof e == "number" && (s = BigInt(Number.MAX_SAFE_INTEGER));
  const o = typeof s == "bigint" && n ? -s - 1n : 0;
  if (s && i > s || i < o) {
    const d = typeof e == "bigint" ? "n" : "";
    throw new of({
      max: s ? `${s}${d}` : void 0,
      min: `${o}${d}`,
      signed: n,
      size: r,
      value: `${e}${d}`
    });
  }
  const u = `0x${(n && i < 0 ? (1n << BigInt(r * 8)) + BigInt(i) : i).toString(16)}`;
  return r ? or(u, { size: r }) : u;
}
const hf = /* @__PURE__ */ new TextEncoder();
function df(e, t = {}) {
  const n = hf.encode(e);
  return gn(n, t);
}
const pf = /* @__PURE__ */ new TextEncoder();
function Ba(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? mf(e, t) : typeof e == "boolean" ? yf(e, t) : Ir(e) ? Tn(e, t) : Ia(e, t);
}
function yf(e, t = {}) {
  const n = new Uint8Array(1);
  return n[0] = Number(e), typeof t.size == "number" ? (ar(n, { size: t.size }), or(n, { size: t.size })) : n;
}
const We = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function To(e) {
  if (e >= We.zero && e <= We.nine)
    return e - We.zero;
  if (e >= We.A && e <= We.F)
    return e - (We.A - 10);
  if (e >= We.a && e <= We.f)
    return e - (We.a - 10);
}
function Tn(e, t = {}) {
  let n = e;
  t.size && (ar(n, { size: t.size }), n = or(n, { dir: "right", size: t.size }));
  let r = n.slice(2);
  r.length % 2 && (r = `0${r}`);
  const i = r.length / 2, s = new Uint8Array(i);
  for (let o = 0, u = 0; o < i; o++) {
    const d = To(r.charCodeAt(u++)), m = To(r.charCodeAt(u++));
    if (d === void 0 || m === void 0)
      throw new Rt(`Invalid byte sequence ("${r[u - 2]}${r[u - 1]}" in "${r}").`);
    s[o] = d * 16 + m;
  }
  return s;
}
function mf(e, t) {
  const n = va(e, t);
  return Tn(n);
}
function Ia(e, t = {}) {
  const n = pf.encode(e);
  return typeof t.size == "number" ? (ar(n, { size: t.size }), or(n, { dir: "right", size: t.size })) : n;
}
function ar(e, { size: t }) {
  if (mn(e) > t)
    throw new af({
      givenSize: mn(e),
      maxSize: t
    });
}
function zn(e, t = {}) {
  const { signed: n } = t;
  t.size && ar(e, { size: t.size });
  const r = BigInt(e);
  if (!n)
    return r;
  const i = (e.length - 2) / 2, s = (1n << BigInt(i) * 8n - 1n) - 1n;
  return r <= s ? r : r - BigInt(`0x${"f".padStart(i * 2, "f")}`) - 1n;
}
function qr(e, t = {}) {
  return Number(zn(e, t));
}
function Ns(e, t) {
  return ({ exclude: n, format: r }) => ({
    exclude: n,
    format: (i) => {
      const s = t(i);
      if (n)
        for (const o of n)
          delete s[o];
      return {
        ...s,
        ...r(i)
      };
    },
    type: e
  });
}
const Ma = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844"
};
function Ds(e) {
  const t = {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    chainId: e.chainId ? qr(e.chainId) : void 0,
    gas: e.gas ? BigInt(e.gas) : void 0,
    gasPrice: e.gasPrice ? BigInt(e.gasPrice) : void 0,
    maxFeePerBlobGas: e.maxFeePerBlobGas ? BigInt(e.maxFeePerBlobGas) : void 0,
    maxFeePerGas: e.maxFeePerGas ? BigInt(e.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: e.maxPriorityFeePerGas ? BigInt(e.maxPriorityFeePerGas) : void 0,
    nonce: e.nonce ? qr(e.nonce) : void 0,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    type: e.type ? Ma[e.type] : void 0,
    typeHex: e.type ? e.type : void 0,
    value: e.value ? BigInt(e.value) : void 0,
    v: e.v ? BigInt(e.v) : void 0
  };
  return t.yParity = (() => {
    if (e.yParity)
      return Number(e.yParity);
    if (typeof t.v == "bigint") {
      if (t.v === 0n || t.v === 27n)
        return 0;
      if (t.v === 1n || t.v === 28n)
        return 1;
      if (t.v >= 35n)
        return t.v % 2n === 0n ? 1 : 0;
    }
  })(), t.type === "legacy" && (delete t.accessList, delete t.maxFeePerBlobGas, delete t.maxFeePerGas, delete t.maxPriorityFeePerGas, delete t.yParity), t.type === "eip2930" && (delete t.maxFeePerBlobGas, delete t.maxFeePerGas, delete t.maxPriorityFeePerGas), t.type === "eip1559" && delete t.maxFeePerBlobGas, t;
}
const gf = /* @__PURE__ */ Ns("transaction", Ds);
function wf(e) {
  var n;
  const t = (n = e.transactions) == null ? void 0 : n.map((r) => typeof r == "string" ? r : Ds(r));
  return {
    ...e,
    baseFeePerGas: e.baseFeePerGas ? BigInt(e.baseFeePerGas) : null,
    blobGasUsed: e.blobGasUsed ? BigInt(e.blobGasUsed) : void 0,
    difficulty: e.difficulty ? BigInt(e.difficulty) : void 0,
    excessBlobGas: e.excessBlobGas ? BigInt(e.excessBlobGas) : void 0,
    gasLimit: e.gasLimit ? BigInt(e.gasLimit) : void 0,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : void 0,
    hash: e.hash ? e.hash : null,
    logsBloom: e.logsBloom ? e.logsBloom : null,
    nonce: e.nonce ? e.nonce : null,
    number: e.number ? BigInt(e.number) : null,
    size: e.size ? BigInt(e.size) : void 0,
    timestamp: e.timestamp ? BigInt(e.timestamp) : void 0,
    transactions: t,
    totalDifficulty: e.totalDifficulty ? BigInt(e.totalDifficulty) : null
  };
}
const bf = /* @__PURE__ */ Ns("block", wf);
function Af(e, { args: t, eventName: n } = {}) {
  return {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    logIndex: e.logIndex ? Number(e.logIndex) : null,
    transactionHash: e.transactionHash ? e.transactionHash : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    ...n ? { args: t, eventName: n } : {}
  };
}
const xf = {
  "0x0": "reverted",
  "0x1": "success"
};
function Ef(e) {
  const t = {
    ...e,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    contractAddress: e.contractAddress ? e.contractAddress : null,
    cumulativeGasUsed: e.cumulativeGasUsed ? BigInt(e.cumulativeGasUsed) : null,
    effectiveGasPrice: e.effectiveGasPrice ? BigInt(e.effectiveGasPrice) : null,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : null,
    logs: e.logs ? e.logs.map((n) => Af(n)) : null,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? qr(e.transactionIndex) : null,
    status: e.status ? xf[e.status] : null,
    type: e.type ? Ma[e.type] || e.type : null
  };
  return e.blobGasPrice && (t.blobGasPrice = BigInt(e.blobGasPrice)), e.blobGasUsed && (t.blobGasUsed = BigInt(e.blobGasUsed)), t;
}
const vf = /* @__PURE__ */ Ns("transactionReceipt", Ef), Bf = {
  block: /* @__PURE__ */ bf({
    format(e) {
      var n;
      return {
        transactions: (n = e.transactions) == null ? void 0 : n.map((r) => {
          if (typeof r == "string")
            return r;
          const i = Ds(r);
          return i.typeHex === "0x7e" && (i.isSystemTx = r.isSystemTx, i.mint = r.mint ? zn(r.mint) : void 0, i.sourceHash = r.sourceHash, i.type = "deposit"), i;
        }),
        stateRoot: e.stateRoot
      };
    }
  }),
  transaction: /* @__PURE__ */ gf({
    format(e) {
      const t = {};
      return e.type === "0x7e" && (t.isSystemTx = e.isSystemTx, t.mint = e.mint ? zn(e.mint) : void 0, t.sourceHash = e.sourceHash, t.type = "deposit"), t;
    }
  }),
  transactionReceipt: /* @__PURE__ */ vf({
    format(e) {
      return {
        l1GasPrice: e.l1GasPrice ? zn(e.l1GasPrice) : null,
        l1GasUsed: e.l1GasUsed ? zn(e.l1GasUsed) : null,
        l1Fee: e.l1Fee ? zn(e.l1Fee) : null,
        l1FeeScalar: e.l1FeeScalar ? Number(e.l1FeeScalar) : null
      };
    }
  })
};
class Yn extends Rt {
  constructor({ address: t }) {
    super(`Address "${t}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAddressError"
    });
  }
}
class Ca extends Map {
  constructor(t) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = t;
  }
  set(t, n) {
    return super.set(t, n), this.maxSize && this.size > this.maxSize && this.delete(this.keys().next().value), this;
  }
}
function So(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function Ta(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function jr(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function Sa(e, t) {
  Ta(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const Rr = /* @__PURE__ */ BigInt(2 ** 32 - 1), Uo = /* @__PURE__ */ BigInt(32);
function If(e, t = !1) {
  return t ? { h: Number(e & Rr), l: Number(e >> Uo & Rr) } : { h: Number(e >> Uo & Rr) | 0, l: Number(e & Rr) | 0 };
}
function Mf(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: s, l: o } = If(e[i], t);
    [n[i], r[i]] = [s, o];
  }
  return [n, r];
}
const Cf = (e, t, n) => e << n | t >>> 32 - n, Tf = (e, t, n) => t << n | e >>> 32 - n, Sf = (e, t, n) => t << n - 32 | e >>> 64 - n, Uf = (e, t, n) => e << n - 32 | t >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Rf = (e) => e instanceof Uint8Array, Nf = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), zi = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), Ve = (e, t) => e << 32 - t | e >>> t, Df = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!Df)
  throw new Error("Non little-endian hardware is not supported");
function kf(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function ks(e) {
  if (typeof e == "string" && (e = kf(e)), !Rf(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
let Ua = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function Ra(e) {
  const t = (r) => e().update(ks(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
const [Na, Da, ka] = [[], [], []], Of = /* @__PURE__ */ BigInt(0), hr = /* @__PURE__ */ BigInt(1), Ff = /* @__PURE__ */ BigInt(2), Lf = /* @__PURE__ */ BigInt(7), Pf = /* @__PURE__ */ BigInt(256), _f = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = hr, n = 1, r = 0; e < 24; e++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], Na.push(2 * (5 * r + n)), Da.push((e + 1) * (e + 2) / 2 % 64);
  let i = Of;
  for (let s = 0; s < 7; s++)
    t = (t << hr ^ (t >> Lf) * _f) % Pf, t & Ff && (i ^= hr << (hr << /* @__PURE__ */ BigInt(s)) - hr);
  ka.push(i);
}
const [zf, Hf] = /* @__PURE__ */ Mf(ka, !0), Ro = (e, t, n) => n > 32 ? Sf(e, t, n) : Cf(e, t, n), No = (e, t, n) => n > 32 ? Uf(e, t, n) : Tf(e, t, n);
function Gf(e, t = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let o = 0; o < 10; o++)
      n[o] = e[o] ^ e[o + 10] ^ e[o + 20] ^ e[o + 30] ^ e[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const u = (o + 8) % 10, d = (o + 2) % 10, m = n[d], w = n[d + 1], B = Ro(m, w, 1) ^ n[u], S = No(m, w, 1) ^ n[u + 1];
      for (let T = 0; T < 50; T += 10)
        e[o + T] ^= B, e[o + T + 1] ^= S;
    }
    let i = e[2], s = e[3];
    for (let o = 0; o < 24; o++) {
      const u = Da[o], d = Ro(i, s, u), m = No(i, s, u), w = Na[o];
      i = e[w], s = e[w + 1], e[w] = d, e[w + 1] = m;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let u = 0; u < 10; u++)
        n[u] = e[o + u];
      for (let u = 0; u < 10; u++)
        e[o + u] ^= ~n[(u + 2) % 10] & n[(u + 4) % 10];
    }
    e[0] ^= zf[r], e[1] ^= Hf[r];
  }
  n.fill(0);
}
class Os extends Ua {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, r, i = !1, s = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, So(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Nf(this.state);
  }
  keccak() {
    Gf(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    jr(this);
    const { blockLen: n, state: r } = this;
    t = ks(t);
    const i = t.length;
    for (let s = 0; s < i; ) {
      const o = Math.min(n - this.pos, i - s);
      for (let u = 0; u < o; u++)
        r[this.pos++] ^= t[s++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: r, blockLen: i } = this;
    t[r] ^= n, n & 128 && r === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    jr(this, !1), Ta(t), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, s = t.length; i < s; ) {
      this.posOut >= r && this.keccak();
      const o = Math.min(r - this.posOut, s - i);
      t.set(n.subarray(this.posOut, this.posOut + o), i), this.posOut += o, i += o;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return So(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (Sa(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: s, enableXOF: o } = this;
    return t || (t = new Os(n, r, i, o, s)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = s, t.suffix = r, t.outputLen = i, t.enableXOF = o, t.destroyed = this.destroyed, t;
  }
}
const Qf = (e, t, n) => Ra(() => new Os(t, e, n)), Vf = /* @__PURE__ */ Qf(1, 136, 256 / 8);
function qf(e, t) {
  const n = t || "hex", r = Vf(Ir(e, { strict: !1 }) ? Ba(e) : e);
  return n === "bytes" ? r : wt(r);
}
const Hi = /* @__PURE__ */ new Ca(8192);
function jf(e, t) {
  if (Hi.has(`${e}.${t}`))
    return Hi.get(`${e}.${t}`);
  const n = t ? `${t}${e.toLowerCase()}` : e.substring(2).toLowerCase(), r = qf(Ia(n), "bytes"), i = (t ? n.substring(`${t}0x`.length) : n).split("");
  for (let o = 0; o < 40; o += 2)
    r[o >> 1] >> 4 >= 8 && i[o] && (i[o] = i[o].toUpperCase()), (r[o >> 1] & 15) >= 8 && i[o + 1] && (i[o + 1] = i[o + 1].toUpperCase());
  const s = `0x${i.join("")}`;
  return Hi.set(`${e}.${t}`, s), s;
}
const Zf = /^0x[a-fA-F0-9]{40}$/, Gi = /* @__PURE__ */ new Ca(8192);
function Jn(e, t) {
  const { strict: n = !0 } = t ?? {};
  if (Gi.has(e))
    return Gi.get(e);
  const r = (() => Zf.test(e) ? e.toLowerCase() === e ? !0 : n ? jf(e) === e : !0 : !1)();
  return Gi.set(e, r), r;
}
function oi(e) {
  return `0x${e.reduce((t, n) => t + n.replace("0x", ""), "")}`;
}
class Do extends Rt {
  constructor({ offset: t }) {
    super(`Offset \`${t}\` cannot be negative.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NegativeOffsetError"
    });
  }
}
class Kf extends Rt {
  constructor({ length: t, position: n }) {
    super(`Position \`${n}\` is out of bounds (\`0 < position < ${t}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PositionOutOfBoundsError"
    });
  }
}
class Yf extends Rt {
  constructor({ count: t, limit: n }) {
    super(`Recursive read limit of \`${n}\` exceeded (recursive read count: \`${t}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RecursiveReadLimitExceededError"
    });
  }
}
const Jf = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: 1 / 0,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new Yf({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(e) {
    if (e < 0 || e > this.bytes.length - 1)
      throw new Kf({
        length: this.bytes.length,
        position: e
      });
  },
  decrementPosition(e) {
    if (e < 0)
      throw new Do({ offset: e });
    const t = this.position - e;
    this.assertPosition(t), this.position = t;
  },
  getReadCount(e) {
    return this.positionReadCount.get(e || this.position) || 0;
  },
  incrementPosition(e) {
    if (e < 0)
      throw new Do({ offset: e });
    const t = this.position + e;
    this.assertPosition(t), this.position = t;
  },
  inspectByte(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectBytes(e, t) {
    const n = t ?? this.position;
    return this.assertPosition(n + e - 1), this.bytes.subarray(n, n + e);
  },
  inspectUint8(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectUint16(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 1), this.dataView.getUint16(t);
  },
  inspectUint24(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 2), (this.dataView.getUint16(t) << 8) + this.dataView.getUint8(t + 2);
  },
  inspectUint32(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 3), this.dataView.getUint32(t);
  },
  pushByte(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushBytes(e) {
    this.assertPosition(this.position + e.length - 1), this.bytes.set(e, this.position), this.position += e.length;
  },
  pushUint8(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushUint16(e) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, e), this.position += 2;
  },
  pushUint24(e) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, e >> 8), this.dataView.setUint8(this.position + 2, e & 255), this.position += 3;
  },
  pushUint32(e) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, e), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectByte();
    return this.position++, e;
  },
  readBytes(e, t) {
    this.assertReadLimit(), this._touch();
    const n = this.inspectBytes(e);
    return this.position += t ?? e, n;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint8();
    return this.position += 1, e;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint16();
    return this.position += 2, e;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint24();
    return this.position += 3, e;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint32();
    return this.position += 4, e;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(e) {
    const t = this.position;
    return this.assertPosition(e), this.position = e, () => this.position = t;
  },
  _touch() {
    if (this.recursiveReadLimit === 1 / 0)
      return;
    const e = this.getReadCount();
    this.positionReadCount.set(this.position, e + 1), e > 0 && this.recursiveReadCount++;
  }
};
function Oa(e, { recursiveReadLimit: t = 8192 } = {}) {
  const n = Object.create(Jf);
  return n.bytes = e, n.dataView = new DataView(e.buffer, e.byteOffset, e.byteLength), n.positionReadCount = /* @__PURE__ */ new Map(), n.recursiveReadLimit = t, n;
}
function Xn(e, t = "hex") {
  const n = Fa(e), r = Oa(new Uint8Array(n.length));
  return n.encode(r), t === "hex" ? gn(r.bytes) : r.bytes;
}
function Fa(e) {
  return Array.isArray(e) ? Xf(e.map((t) => Fa(t))) : Wf(e);
}
function Xf(e) {
  const t = e.reduce((i, s) => i + s.length, 0), n = La(t);
  return {
    length: (() => t <= 55 ? 1 + t : 1 + n + t)(),
    encode(i) {
      t <= 55 ? i.pushByte(192 + t) : (i.pushByte(192 + 55 + n), n === 1 ? i.pushUint8(t) : n === 2 ? i.pushUint16(t) : n === 3 ? i.pushUint24(t) : i.pushUint32(t));
      for (const { encode: s } of e)
        s(i);
    }
  };
}
function Wf(e) {
  const t = typeof e == "string" ? Tn(e) : e, n = La(t.length);
  return {
    length: (() => t.length === 1 && t[0] < 128 ? 1 : t.length <= 55 ? 1 + t.length : 1 + n + t.length)(),
    encode(i) {
      t.length === 1 && t[0] < 128 ? i.pushBytes(t) : t.length <= 55 ? (i.pushByte(128 + t.length), i.pushBytes(t)) : (i.pushByte(128 + 55 + n), n === 1 ? i.pushUint8(t.length) : n === 2 ? i.pushUint16(t.length) : n === 3 ? i.pushUint24(t.length) : i.pushUint32(t.length), i.pushBytes(t));
    }
  };
}
function La(e) {
  if (e < 2 ** 8)
    return 1;
  if (e < 2 ** 16)
    return 2;
  if (e < 2 ** 24)
    return 3;
  if (e < 2 ** 32)
    return 4;
  throw new Rt("Length is too large.");
}
const $f = {
  ether: -9,
  wei: 9
};
function tl(e, t) {
  let n = e.toString();
  const r = n.startsWith("-");
  r && (n = n.slice(1)), n = n.padStart(t, "0");
  let [i, s] = [
    n.slice(0, n.length - t),
    n.slice(n.length - t)
  ];
  return s = s.replace(/(0+)$/, ""), `${r ? "-" : ""}${i || "0"}${s ? `.${s}` : ""}`;
}
function ls(e, t = "wei") {
  return tl(e, $f[t]);
}
function el(e) {
  const t = Object.entries(e).map(([r, i]) => i === void 0 || i === !1 ? null : [r, i]).filter(Boolean), n = t.reduce((r, [i]) => Math.max(r, i.length), 0);
  return t.map(([r, i]) => `  ${`${r}:`.padEnd(n + 1)}  ${i}`).join(`
`);
}
class nl extends Rt {
  constructor({ v: t }) {
    super(`Invalid \`v\` value "${t}". Expected 27 or 28.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidLegacyVError"
    });
  }
}
class rl extends Rt {
  constructor({ transaction: t }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        el(t),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- a Legacy Transaction with `gasPrice`"
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSerializableTransactionError"
    });
  }
}
class il extends Rt {
  constructor({ storageKey: t }) {
    super(`Size for storage key "${t}" is invalid. Expected 32 bytes. Got ${Math.floor((t.length - 2) / 2)} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStorageKeySizeError"
    });
  }
}
function Pa(e) {
  const { kzg: t } = e, n = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), r = typeof e.blobs[0] == "string" ? e.blobs.map((s) => Tn(s)) : e.blobs, i = [];
  for (const s of r)
    i.push(Uint8Array.from(t.blobToKzgCommitment(s)));
  return n === "bytes" ? i : i.map((s) => gn(s));
}
function _a(e) {
  const { kzg: t } = e, n = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), r = typeof e.blobs[0] == "string" ? e.blobs.map((o) => Tn(o)) : e.blobs, i = typeof e.commitments[0] == "string" ? e.commitments.map((o) => Tn(o)) : e.commitments, s = [];
  for (let o = 0; o < r.length; o++) {
    const u = r[o], d = i[o];
    s.push(Uint8Array.from(t.computeBlobKzgProof(u, d)));
  }
  return n === "bytes" ? s : s.map((o) => gn(o));
}
function sl(e, t, n, r) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, n, r);
  const i = BigInt(32), s = BigInt(4294967295), o = Number(n >> i & s), u = Number(n & s), d = r ? 4 : 0, m = r ? 0 : 4;
  e.setUint32(t + d, o, r), e.setUint32(t + m, u, r);
}
class ol extends Ua {
  constructor(t, n, r, i) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = zi(this.buffer);
  }
  update(t) {
    jr(this);
    const { view: n, buffer: r, blockLen: i } = this;
    t = ks(t);
    const s = t.length;
    for (let o = 0; o < s; ) {
      const u = Math.min(i - this.pos, s - o);
      if (u === i) {
        const d = zi(t);
        for (; i <= s - o; o += i)
          this.process(d, o);
        continue;
      }
      r.set(t.subarray(o, o + u), this.pos), this.pos += u, o += u, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    jr(this), Sa(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: s } = this;
    let { pos: o } = this;
    n[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > i - o && (this.process(r, 0), o = 0);
    for (let B = o; B < i; B++)
      n[B] = 0;
    sl(r, i - 8, BigInt(this.length * 8), s), this.process(r, 0);
    const u = zi(t), d = this.outputLen;
    if (d % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const m = d / 4, w = this.get();
    if (m > w.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let B = 0; B < m; B++)
      u.setUint32(4 * B, w[B], s);
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: s, destroyed: o, pos: u } = this;
    return t.length = i, t.pos = u, t.finished = s, t.destroyed = o, i % n && t.buffer.set(r), t;
  }
}
const al = (e, t, n) => e & t ^ ~e & n, ul = (e, t, n) => e & t ^ e & n ^ t & n, cl = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), on = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), an = /* @__PURE__ */ new Uint32Array(64);
let fl = class extends ol {
  constructor() {
    super(64, 32, 8, !1), this.A = on[0] | 0, this.B = on[1] | 0, this.C = on[2] | 0, this.D = on[3] | 0, this.E = on[4] | 0, this.F = on[5] | 0, this.G = on[6] | 0, this.H = on[7] | 0;
  }
  get() {
    const { A: t, B: n, C: r, D: i, E: s, F: o, G: u, H: d } = this;
    return [t, n, r, i, s, o, u, d];
  }
  // prettier-ignore
  set(t, n, r, i, s, o, u, d) {
    this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = s | 0, this.F = o | 0, this.G = u | 0, this.H = d | 0;
  }
  process(t, n) {
    for (let B = 0; B < 16; B++, n += 4)
      an[B] = t.getUint32(n, !1);
    for (let B = 16; B < 64; B++) {
      const S = an[B - 15], T = an[B - 2], O = Ve(S, 7) ^ Ve(S, 18) ^ S >>> 3, U = Ve(T, 17) ^ Ve(T, 19) ^ T >>> 10;
      an[B] = U + an[B - 7] + O + an[B - 16] | 0;
    }
    let { A: r, B: i, C: s, D: o, E: u, F: d, G: m, H: w } = this;
    for (let B = 0; B < 64; B++) {
      const S = Ve(u, 6) ^ Ve(u, 11) ^ Ve(u, 25), T = w + S + al(u, d, m) + cl[B] + an[B] | 0, U = (Ve(r, 2) ^ Ve(r, 13) ^ Ve(r, 22)) + ul(r, i, s) | 0;
      w = m, m = d, d = u, u = o + T | 0, o = s, s = i, i = r, r = T + U | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, s = s + this.C | 0, o = o + this.D | 0, u = u + this.E | 0, d = d + this.F | 0, m = m + this.G | 0, w = w + this.H | 0, this.set(r, i, s, o, u, d, m, w);
  }
  roundClean() {
    an.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const ll = /* @__PURE__ */ Ra(() => new fl());
function hl(e, t) {
  const n = t || "hex", r = ll(Ir(e, { strict: !1 }) ? Ba(e) : e);
  return n === "bytes" ? r : wt(r);
}
function dl(e) {
  const { commitment: t, version: n = 1 } = e, r = e.to ?? (typeof t == "string" ? "hex" : "bytes"), i = hl(t, "bytes");
  return i.set([n], 0), r === "bytes" ? i : gn(i);
}
function pl(e) {
  const { commitments: t, version: n } = e, r = e.to ?? (typeof t[0] == "string" ? "hex" : "bytes"), i = [];
  for (const s of t)
    i.push(dl({
      commitment: s,
      to: r,
      version: n
    }));
  return i;
}
const ko = 6, za = 32, Fs = 4096, Ha = za * Fs, Oo = Ha * ko - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * Fs * ko, Ga = 1;
class yl extends Rt {
  constructor({ maxSize: t, size: n }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${t} bytes`, `Given: ${n} bytes`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BlobSizeTooLargeError"
    });
  }
}
class Qa extends Rt {
  constructor() {
    super("Blob data must not be empty."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EmptyBlobError"
    });
  }
}
class ml extends Rt {
  constructor({ hash: t, size: n }) {
    super(`Versioned hash "${t}" size is invalid.`, {
      metaMessages: ["Expected: 32", `Received: ${n}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidVersionedHashSizeError"
    });
  }
}
class gl extends Rt {
  constructor({ hash: t, version: n }) {
    super(`Versioned hash "${t}" version is invalid.`, {
      metaMessages: [
        `Expected: ${Ga}`,
        `Received: ${n}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidVersionedHashVersionError"
    });
  }
}
function wl(e) {
  const t = e.to ?? (typeof e.data == "string" ? "hex" : "bytes"), n = typeof e.data == "string" ? Tn(e.data) : e.data, r = mn(n);
  if (!r)
    throw new Qa();
  if (r > Oo)
    throw new yl({
      maxSize: Oo,
      size: r
    });
  const i = [];
  let s = !0, o = 0;
  for (; s; ) {
    const u = Oa(new Uint8Array(Ha));
    let d = 0;
    for (; d < Fs; ) {
      const m = n.slice(o, o + (za - 1));
      if (u.pushByte(0), u.pushBytes(m), m.length < 31) {
        u.pushByte(128), s = !1;
        break;
      }
      d++, o += 31;
    }
    i.push(u);
  }
  return t === "bytes" ? i.map((u) => u.bytes) : i.map((u) => gn(u.bytes));
}
function bl(e) {
  const { data: t, kzg: n, to: r } = e, i = e.blobs ?? wl({ data: t, to: r }), s = e.commitments ?? Pa({ blobs: i, kzg: n, to: r }), o = e.proofs ?? _a({ blobs: i, commitments: s, kzg: n, to: r }), u = [];
  for (let d = 0; d < i.length; d++)
    u.push({
      blob: i[d],
      commitment: s[d],
      proof: o[d]
    });
  return u;
}
class Ls extends Rt {
  constructor({ chainId: t }) {
    super(typeof t == "number" ? `Chain ID "${t}" is invalid.` : "Chain ID is invalid."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidChainIdError"
    });
  }
}
class ai extends Rt {
  constructor({ cause: t, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${ls(n)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooHigh"
    });
  }
}
Object.defineProperty(ai, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class Va extends Rt {
  constructor({ cause: t, maxPriorityFeePerGas: n, maxFeePerGas: r } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${n ? ` = ${ls(n)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${r ? ` = ${ls(r)} gwei` : ""}).`
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(Va, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
function Al(e, t, n, { strict: r } = {}) {
  return Ir(e, { strict: !1 }) ? El(e, t, n, {
    strict: r
  }) : xl(e, t, n, {
    strict: r
  });
}
function qa(e, t) {
  if (typeof t == "number" && t > 0 && t > mn(e) - 1)
    throw new xa({
      offset: t,
      position: "start",
      size: mn(e)
    });
}
function ja(e, t, n) {
  if (typeof t == "number" && typeof n == "number" && mn(e) !== n - t)
    throw new xa({
      offset: n,
      position: "end",
      size: mn(e)
    });
}
function xl(e, t, n, { strict: r } = {}) {
  qa(e, t);
  const i = e.slice(t, n);
  return r && ja(i, t, n), i;
}
function El(e, t, n, { strict: r } = {}) {
  qa(e, t);
  const i = `0x${e.replace("0x", "").slice((t ?? 0) * 2, (n ?? e.length) * 2)}`;
  return r && ja(i, t, n), i;
}
function vl(e) {
  const { blobVersionedHashes: t } = e;
  if (t) {
    if (t.length === 0)
      throw new Qa();
    for (const n of t) {
      const r = mn(n), i = qr(Al(n, 0, 1));
      if (r !== 32)
        throw new ml({ hash: n, size: r });
      if (i !== Ga)
        throw new gl({
          hash: n,
          version: i
        });
    }
  }
  Za(e);
}
function Za(e) {
  const { chainId: t, maxPriorityFeePerGas: n, maxFeePerGas: r, to: i } = e;
  if (t <= 0)
    throw new Ls({ chainId: t });
  if (i && !Jn(i))
    throw new Yn({ address: i });
  if (r && r > 2n ** 256n - 1n)
    throw new ai({ maxFeePerGas: r });
  if (n && r && n > r)
    throw new Va({ maxFeePerGas: r, maxPriorityFeePerGas: n });
}
function Bl(e) {
  const { chainId: t, maxPriorityFeePerGas: n, gasPrice: r, maxFeePerGas: i, to: s } = e;
  if (t <= 0)
    throw new Ls({ chainId: t });
  if (s && !Jn(s))
    throw new Yn({ address: s });
  if (n || i)
    throw new Rt("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
  if (r && r > 2n ** 256n - 1n)
    throw new ai({ maxFeePerGas: r });
}
function Il(e) {
  const { chainId: t, maxPriorityFeePerGas: n, gasPrice: r, maxFeePerGas: i, to: s, accessList: o } = e;
  if (s && !Jn(s))
    throw new Yn({ address: s });
  if (typeof t < "u" && t <= 0)
    throw new Ls({ chainId: t });
  if (n || i)
    throw new Rt("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
  if (r && r > 2n ** 256n - 1n)
    throw new ai({ maxFeePerGas: r });
  if (o)
    throw new Rt("`accessList` is not a valid Legacy Transaction attribute.");
}
function Ml(e) {
  if (e.type)
    return e.type;
  if (typeof e.blobs < "u" || typeof e.blobVersionedHashes < "u" || typeof e.maxFeePerBlobGas < "u" || typeof e.sidecars < "u")
    return "eip4844";
  if (typeof e.maxFeePerGas < "u" || typeof e.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof e.gasPrice < "u")
    return typeof e.accessList < "u" ? "eip2930" : "legacy";
  throw new rl({ transaction: e });
}
function Ps(e) {
  if (!e || e.length === 0)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const { address: r, storageKeys: i } = e[n];
    for (let s = 0; s < i.length; s++)
      if (i[s].length - 2 !== 64)
        throw new il({ storageKey: i[s] });
    if (!Jn(r, { strict: !1 }))
      throw new Yn({ address: r });
    t.push([r, i]);
  }
  return t;
}
function Cl(e, t) {
  const n = Ml(e);
  return n === "eip1559" ? Sl(e, t) : n === "eip2930" ? Ul(e, t) : n === "eip4844" ? Tl(e, t) : Rl(e, t);
}
function Tl(e, t) {
  const { chainId: n, gas: r, nonce: i, to: s, value: o, maxFeePerBlobGas: u, maxFeePerGas: d, maxPriorityFeePerGas: m, accessList: w, data: B } = e;
  vl(e);
  let S = e.blobVersionedHashes, T = e.sidecars;
  if (e.blobs && (typeof S > "u" || typeof T > "u")) {
    const L = typeof e.blobs[0] == "string" ? e.blobs : e.blobs.map((z) => gn(z)), Z = e.kzg, _ = Pa({
      blobs: L,
      kzg: Z
    });
    if (typeof S > "u" && (S = pl({
      commitments: _
    })), typeof T > "u") {
      const z = _a({ blobs: L, commitments: _, kzg: Z });
      T = bl({ blobs: L, commitments: _, proofs: z });
    }
  }
  const O = Ps(w), U = [
    wt(n),
    i ? wt(i) : "0x",
    m ? wt(m) : "0x",
    d ? wt(d) : "0x",
    r ? wt(r) : "0x",
    s ?? "0x",
    o ? wt(o) : "0x",
    B ?? "0x",
    O,
    u ? wt(u) : "0x",
    S ?? [],
    ..._s(e, t)
  ], R = [], P = [], G = [];
  if (T)
    for (let L = 0; L < T.length; L++) {
      const { blob: Z, commitment: _, proof: z } = T[L];
      R.push(Z), P.push(_), G.push(z);
    }
  return oi([
    "0x03",
    // If sidecars are enabled, envelope turns into a "wrapper":
    Xn(T ? [U, R, P, G] : U)
  ]);
}
function Sl(e, t) {
  const { chainId: n, gas: r, nonce: i, to: s, value: o, maxFeePerGas: u, maxPriorityFeePerGas: d, accessList: m, data: w } = e;
  Za(e);
  const B = Ps(m), S = [
    wt(n),
    i ? wt(i) : "0x",
    d ? wt(d) : "0x",
    u ? wt(u) : "0x",
    r ? wt(r) : "0x",
    s ?? "0x",
    o ? wt(o) : "0x",
    w ?? "0x",
    B,
    ..._s(e, t)
  ];
  return oi([
    "0x02",
    Xn(S)
  ]);
}
function Ul(e, t) {
  const { chainId: n, gas: r, data: i, nonce: s, to: o, value: u, accessList: d, gasPrice: m } = e;
  Bl(e);
  const w = Ps(d), B = [
    wt(n),
    s ? wt(s) : "0x",
    m ? wt(m) : "0x",
    r ? wt(r) : "0x",
    o ?? "0x",
    u ? wt(u) : "0x",
    i ?? "0x",
    w,
    ..._s(e, t)
  ];
  return oi([
    "0x01",
    Xn(B)
  ]);
}
function Rl(e, t) {
  const { chainId: n = 0, gas: r, data: i, nonce: s, to: o, value: u, gasPrice: d } = e;
  Il(e);
  let m = [
    s ? wt(s) : "0x",
    d ? wt(d) : "0x",
    r ? wt(r) : "0x",
    o ?? "0x",
    u ? wt(u) : "0x",
    i ?? "0x"
  ];
  if (t) {
    const w = (() => {
      if (t.v >= 35n)
        return (t.v - 35n) / 2n > 0 ? t.v : 27n + (t.v === 35n ? 0n : 1n);
      if (n > 0)
        return BigInt(n * 2) + BigInt(35n + t.v - 27n);
      const B = 27n + (t.v === 27n ? 0n : 1n);
      if (t.v !== B)
        throw new nl({ v: t.v });
      return B;
    })();
    m = [
      ...m,
      wt(w),
      t.r,
      t.s
    ];
  } else
    n > 0 && (m = [
      ...m,
      wt(n),
      "0x",
      "0x"
    ]);
  return Xn(m);
}
function _s(e, t) {
  const { r: n, s: r, v: i, yParity: s } = t ?? e;
  return typeof n > "u" ? [] : typeof r > "u" ? [] : typeof i > "u" && typeof s > "u" ? [] : [(() => typeof s == "number" ? s ? wt(1) : "0x" : i === 0n ? "0x" : i === 1n ? wt(1) : i === 27n ? "0x" : wt(1))(), Co(n), Co(r)];
}
function Nl(e, t) {
  return Ol(e) ? kl(e) : Cl(e, t);
}
const Dl = {
  transaction: Nl
};
function kl(e) {
  Fl(e);
  const { sourceHash: t, data: n, from: r, gas: i, isSystemTx: s, mint: o, to: u, value: d } = e, m = [
    t,
    r,
    u ?? "0x",
    o ? wt(o) : "0x",
    d ? wt(d) : "0x",
    i ? wt(i) : "0x",
    s ? "0x1" : "0x",
    n ?? "0x"
  ];
  return oi([
    "0x7e",
    Xn(m)
  ]);
}
function Ol(e) {
  return e.type === "deposit" || typeof e.sourceHash < "u";
}
function Fl(e) {
  const { from: t, to: n } = e;
  if (t && !Jn(t))
    throw new Yn({ address: t });
  if (n && !Jn(n))
    throw new Yn({ address: n });
}
const Me = {
  contracts: nf,
  formatters: Bf,
  serializers: Dl
}, Ll = /* @__PURE__ */ xe({
  id: 42161,
  name: "Arbitrum One",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://arb1.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://arbiscan.io",
      apiUrl: "https://api.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7654707
    }
  }
}), Nr = 1, Pl = /* @__PURE__ */ xe({
  ...Me,
  id: 8453,
  name: "Base",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://basescan.org",
      apiUrl: "https://api.basescan.org/api"
    }
  },
  contracts: {
    ...Me.contracts,
    l2OutputOracle: {
      [Nr]: {
        address: "0x56315b90c40730925ec5485cf004d835058518A0"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 5022
    },
    portal: {
      [Nr]: {
        address: "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e",
        blockCreated: 17482143
      }
    },
    l1StandardBridge: {
      [Nr]: {
        address: "0x3154Cf16ccdb4C6d922629664174b904d80F2C35",
        blockCreated: 17482143
      }
    }
  },
  sourceId: Nr
}), Dr = 5, _l = /* @__PURE__ */ xe({
  ...Me,
  id: 84531,
  name: "Base Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://goerli.base.org"] }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://goerli.basescan.org",
      apiUrl: "https://goerli.basescan.org/api"
    }
  },
  contracts: {
    ...Me.contracts,
    l2OutputOracle: {
      [Dr]: {
        address: "0x2A35891ff30313CcFa6CE88dcf3858bb075A2298"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1376988
    },
    portal: {
      [Dr]: {
        address: "0xe93c8cD0D409341205A592f8c4Ac1A5fe5585cfA"
      }
    },
    l1StandardBridge: {
      [Dr]: {
        address: "0xfA6D8Ee5BE770F84FC001D098C4bD604Fe01284a"
      }
    }
  },
  testnet: !0,
  sourceId: Dr
}), kr = 11155111, zl = /* @__PURE__ */ xe({
  ...Me,
  id: 84532,
  network: "base-sepolia",
  name: "Base Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://sepolia.basescan.org",
      apiUrl: "https://api-sepolia.basescan.org/api"
    }
  },
  contracts: {
    ...Me.contracts,
    l2OutputOracle: {
      [kr]: {
        address: "0x84457ca9D0163FbC4bbfe4Dfbb20ba46e48DF254"
      }
    },
    portal: {
      [kr]: {
        address: "0x49f53e41452c74589e85ca1677426ba426459e85",
        blockCreated: 4446677
      }
    },
    l1StandardBridge: {
      [kr]: {
        address: "0xfd0Bf71F60660E2f608ed56e1659C450eB113120",
        blockCreated: 4446677
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1059647
    }
  },
  testnet: !0,
  sourceId: kr
}), Hl = /* @__PURE__ */ xe({
  id: 5,
  name: "Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.ankr.com/eth_goerli"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://goerli.etherscan.io",
      apiUrl: "https://api-goerli.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xfc4AC75C46C914aF5892d6d3eFFcebD7917293F1",
      blockCreated: 10339206
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 6507670
    }
  },
  testnet: !0
}), Gl = /* @__PURE__ */ xe({
  id: 100,
  name: "Gnosis",
  nativeCurrency: {
    decimals: 18,
    name: "Gnosis",
    symbol: "xDAI"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.gnosischain.com"],
      webSocket: ["wss://rpc.gnosischain.com/wss"]
    }
  },
  blockExplorers: {
    default: {
      name: "Gnosisscan",
      url: "https://gnosisscan.io",
      apiUrl: "https://api.gnosisscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 21022491
    }
  }
}), Ql = /* @__PURE__ */ xe({
  id: 59144,
  name: "Linea Mainnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.linea.build"],
      webSocket: ["wss://rpc.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://lineascan.build",
      apiUrl: "https://api.lineascan.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 42
    }
  },
  testnet: !1
}), Vl = /* @__PURE__ */ xe({
  id: 59140,
  name: "Linea Goerli Testnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.goerli.linea.build"],
      webSocket: ["wss://rpc.goerli.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://goerli.lineascan.build",
      apiUrl: "https://goerli.lineascan.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 498623
    }
  },
  testnet: !0
}), ql = /* @__PURE__ */ xe({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), Or = 1, jl = /* @__PURE__ */ xe({
  ...Me,
  id: 10,
  name: "OP Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Optimism Explorer",
      url: "https://optimistic.etherscan.io",
      apiUrl: "https://api-optimistic.etherscan.io/api"
    }
  },
  contracts: {
    ...Me.contracts,
    l2OutputOracle: {
      [Or]: {
        address: "0xdfe97868233d1aa22e815a266982f2cf17685a27"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 4286263
    },
    portal: {
      [Or]: {
        address: "0xbEb5Fc579115071764c7423A4f12eDde41f106Ed"
      }
    },
    l1StandardBridge: {
      [Or]: {
        address: "0x99C9fc46f92E8a1c0deC1b1747d010903E884bE1"
      }
    }
  },
  sourceId: Or
}), Fr = 5, Zl = /* @__PURE__ */ xe({
  ...Me,
  id: 420,
  name: "Optimism Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://goerli.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://goerli-optimism.etherscan.io",
      apiUrl: "https://goerli-optimism.etherscan.io/api"
    }
  },
  contracts: {
    ...Me.contracts,
    l2OutputOracle: {
      [Fr]: {
        address: "0xE6Dfba0953616Bacab0c9A8ecb3a9BBa77FC15c0"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 49461
    },
    portal: {
      [Fr]: {
        address: "0x5b47E1A08Ea6d985D6649300584e6722Ec4B1383"
      }
    },
    l1StandardBridge: {
      [Fr]: {
        address: "0x636Af16bf2f682dD3109e60102b8E1A089FedAa8"
      }
    }
  },
  testnet: !0,
  sourceId: Fr
}), Kl = /* @__PURE__ */ xe({
  id: 137,
  name: "Polygon",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://polygon-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://polygonscan.com",
      apiUrl: "https://api.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  }
}), Yl = /* @__PURE__ */ xe({
  id: 80001,
  name: "Polygon Mumbai",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.ankr.com/polygon_mumbai"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://mumbai.polygonscan.com",
      apiUrl: "https://api-testnet.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  },
  testnet: !0
}), Jl = /* @__PURE__ */ xe({
  id: 11155111,
  name: "Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.sepolia.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io",
      apiUrl: "https://api-sepolia.etherscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 751532
    },
    ensRegistry: { address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e" },
    ensUniversalResolver: {
      address: "0xc8Af999e38273D658BE1b921b88A9Ddf005769cC",
      blockCreated: 5317080
    }
  },
  testnet: !0
}), Lr = 1, Xl = /* @__PURE__ */ xe({
  ...Me,
  id: 7777777,
  name: "Zora",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.zora.energy"],
      webSocket: ["wss://rpc.zora.energy"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://explorer.zora.energy",
      apiUrl: "https://explorer.zora.energy/api"
    }
  },
  contracts: {
    ...Me.contracts,
    l2OutputOracle: {
      [Lr]: {
        address: "0x9E6204F750cD866b299594e2aC9eA824E2e5f95c"
      }
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 5882
    },
    portal: {
      [Lr]: {
        address: "0x1a0ad011913A150f69f6A19DF447A0CfD9551054"
      }
    },
    l1StandardBridge: {
      [Lr]: {
        address: "0x3e2Ea9B92B7E48A52296fD261dc26fd995284631"
      }
    }
  },
  sourceId: Lr
}), Fo = 5, Wl = /* @__PURE__ */ xe({
  ...Me,
  id: 999,
  name: "Zora Goerli Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Zora Goerli",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.rpc.zora.energy"],
      webSocket: ["wss://testnet.rpc.zora.energy"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://testnet.explorer.zora.energy",
      apiUrl: "https://testnet.explorer.zora.energy/api"
    }
  },
  contracts: {
    ...Me.contracts,
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 189123
    },
    portal: {
      [Fo]: {
        address: "0xDb9F51790365e7dc196e7D072728df39Be958ACe"
      }
    }
  },
  sourceId: Fo,
  testnet: !0
}), $l = {
  mainnet: ql,
  goerli: Hl,
  optimismGoerli: Zl,
  polygon: Kl,
  polygonMumbai: Yl,
  sepolia: Jl,
  optimism: jl,
  arbitrum: Ll,
  base: Pl,
  gnosis: Gl,
  baseGoerli: _l,
  baseSepolia: zl,
  lineaTestnet: Vl,
  linea: Ql,
  zora: Xl,
  zoraTestnet: Wl
};
function t0(e) {
  for (const t of Object.values($l))
    if (t.id === e)
      return t;
  throw new Error(`Chain with id ${e} not found`);
}
const Ae = {
  IMPLEMENTATION: {
    ADDRESS: Qt("0x2d25602551487c3f3354dd80d76d54383a243358"),
    ABI: Kc
  },
  REGISTRY: {
    ADDRESS: Qt("0x02101dfB77FDE026414827Fdc604ddAF224F0921"),
    ABI: Zc
  }
}, fe = {
  ACCOUNT_PROXY: {
    ADDRESS: Qt("0x55266d75D1a14E4572138116aF39863Ed6596E7F"),
    // Proxy for the upgradeable implementation, initialization lives here
    ABI: $c
  },
  IMPLEMENTATION: {
    ADDRESS: Qt("0x41C8f39463A868d3A88af00cd0fe7102F30E44eC"),
    // Upgradeable
    ABI: tf
  },
  REGISTRY: {
    ADDRESS: Qt("0x000000006551c19487814612e58FE06813775758"),
    ABI: ef
  }
}, e0 = "0x5af43d82803e903d91602b57fd5bf3", n0 = Qt(
  "0xcA1167915584462449EE5b4Ea51c37fE81eCDCCD"
), Ln = "0xEF7B07Db21d449C50b00De4563FfFe4C9dd33f1f", Pn = "0x0F220412Bf22E05EBcC5070D60fd7136A08aF22C", r0 = {
  // ethereum
  1: Pn,
  // polygon
  137: Pn,
  // optimism
  10: Pn,
  // base
  8453: Pn,
  // linea
  59144: Pn,
  // arbitrum
  42161: Pn
}, i0 = {
  // sepolia
  11155111: Ln,
  // mumbai
  80001: Ln,
  // op sepolia
  11155420: Ln,
  // base sepolia
  84532: Ln,
  // linea testnet
  59140: Ln,
  // arbitrum sepolia
  421614: Ln
}, s0 = {
  ...i0,
  ...r0
}, o0 = {
  // ethereum
  1: 30101,
  // polygon
  137: 30109,
  // optimism
  10: 30111,
  // base
  8453: 30184,
  // linea
  59144: 30183,
  // arbitrum
  42161: 30110
}, a0 = {
  // sepolia
  11155111: 40161,
  // mumbai
  80001: 40109,
  // op sepolia
  11155420: 40232,
  // base sepolia
  84532: 40245,
  // linea testnet
  59140: 40157,
  // arbitrum sepolia
  421614: 40231
}, u0 = {
  ...a0,
  ...o0
};
function c0(e) {
  switch (e) {
    case Ae.IMPLEMENTATION.ADDRESS:
      return "Implementation: Default V1";
    case fe.ACCOUNT_PROXY.ADDRESS:
    case void 0:
      return "Implementation: Default V3";
    default:
      return `Custom Implementation: ${e}`;
  }
}
function f0(e) {
  return Array.isArray(e) || typeof e == "string" || "length" in e && !("byteLength" in e);
}
function l0(e) {
  return typeof e == "string" || e instanceof Uint8Array;
}
function h0(e) {
  return typeof e == "string" || "raw" in e;
}
function d0(e) {
  return typeof e == "string" || e instanceof Uint8Array ? e : new Uint8Array(Array.from(e));
}
var p0 = "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";
const Lo = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]), Po = 4;
function y0(e) {
  let t = 0;
  function n() {
    return e[t++] << 8 | e[t++];
  }
  let r = n(), i = 1, s = [0, 1];
  for (let _ = 1; _ < r; _++)
    s.push(i += n());
  let o = n(), u = t;
  t += o;
  let d = 0, m = 0;
  function w() {
    return d == 0 && (m = m << 8 | e[t++], d = 8), m >> --d & 1;
  }
  const B = 31, S = 2 ** B, T = S >>> 1, O = T >> 1, U = S - 1;
  let R = 0;
  for (let _ = 0; _ < B; _++)
    R = R << 1 | w();
  let P = [], G = 0, L = S;
  for (; ; ) {
    let _ = Math.floor(((R - G + 1) * i - 1) / L), z = 0, K = r;
    for (; K - z > 1; ) {
      let ut = z + K >>> 1;
      _ < s[ut] ? K = ut : z = ut;
    }
    if (z == 0)
      break;
    P.push(z);
    let Y = G + Math.floor(L * s[z] / i), dt = G + Math.floor(L * s[z + 1] / i) - 1;
    for (; !((Y ^ dt) & T); )
      R = R << 1 & U | w(), Y = Y << 1 & U, dt = dt << 1 & U | 1;
    for (; Y & ~dt & O; )
      R = R & T | R << 1 & U >>> 1 | w(), Y = Y << 1 ^ T, dt = (dt ^ T) << 1 | T | 1;
    G = Y, L = 1 + dt - Y;
  }
  let Z = r - 4;
  return P.map((_) => {
    switch (_ - Z) {
      case 3:
        return Z + 65792 + (e[u++] << 16 | e[u++] << 8 | e[u++]);
      case 2:
        return Z + 256 + (e[u++] << 8 | e[u++]);
      case 1:
        return Z + e[u++];
      default:
        return _ - 1;
    }
  });
}
function m0(e) {
  let t = 0;
  return () => e[t++];
}
function Ka(e) {
  return m0(y0(g0(e)));
}
function g0(e) {
  let t = [];
  [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((i, s) => t[i.charCodeAt(0)] = s);
  let n = e.length, r = new Uint8Array(6 * n >> 3);
  for (let i = 0, s = 0, o = 0, u = 0; i < n; i++)
    u = u << 6 | t[e.charCodeAt(i)], o += 6, o >= 8 && (r[s++] = u >> (o -= 8));
  return r;
}
function w0(e) {
  return e & 1 ? ~e >> 1 : e >> 1;
}
function b0(e, t) {
  let n = Array(e);
  for (let r = 0, i = 0; r < e; r++)
    n[r] = i += w0(t());
  return n;
}
function gr(e, t = 0) {
  let n = [];
  for (; ; ) {
    let r = e(), i = e();
    if (!i)
      break;
    t += r;
    for (let s = 0; s < i; s++)
      n.push(t + s);
    t += i + 1;
  }
  return n;
}
function Ya(e) {
  return wr(() => {
    let t = gr(e);
    if (t.length)
      return t;
  });
}
function Ja(e) {
  let t = [];
  for (; ; ) {
    let n = e();
    if (n == 0)
      break;
    t.push(A0(n, e));
  }
  for (; ; ) {
    let n = e() - 1;
    if (n < 0)
      break;
    t.push(x0(n, e));
  }
  return t.flat();
}
function wr(e) {
  let t = [];
  for (; ; ) {
    let n = e(t.length);
    if (!n)
      break;
    t.push(n);
  }
  return t;
}
function Xa(e, t, n) {
  let r = Array(e).fill().map(() => []);
  for (let i = 0; i < t; i++)
    b0(e, n).forEach((s, o) => r[o].push(s));
  return r;
}
function A0(e, t) {
  let n = 1 + t(), r = t(), i = wr(t);
  return Xa(i.length, 1 + e, t).flatMap((o, u) => {
    let [d, ...m] = o;
    return Array(i[u]).fill().map((w, B) => {
      let S = B * r;
      return [d + B * n, m.map((T) => T + S)];
    });
  });
}
function x0(e, t) {
  let n = 1 + t();
  return Xa(n, 1 + e, t).map((i) => [i[0], i.slice(1)]);
}
function E0(e) {
  let t = [], n = gr(e);
  return i(r([]), []), t;
  function r(s) {
    let o = e(), u = wr(() => {
      let d = gr(e).map((m) => n[m]);
      if (d.length)
        return r(d);
    });
    return { S: o, B: u, Q: s };
  }
  function i({ S: s, B: o }, u, d) {
    if (!(s & 4 && d === u[u.length - 1])) {
      s & 2 && (d = u[u.length - 1]), s & 1 && t.push(u);
      for (let m of o)
        for (let w of m.Q)
          i(m, [...u, w], d);
    }
  }
}
function v0(e) {
  return e.toString(16).toUpperCase().padStart(2, "0");
}
function Wa(e) {
  return `{${v0(e)}}`;
}
function B0(e) {
  let t = [];
  for (let n = 0, r = e.length; n < r; ) {
    let i = e.codePointAt(n);
    n += i < 65536 ? 1 : 2, t.push(i);
  }
  return t;
}
function Wn(e) {
  let n = e.length;
  if (n < 4096)
    return String.fromCodePoint(...e);
  let r = [];
  for (let i = 0; i < n; )
    r.push(String.fromCodePoint(...e.slice(i, i += 4096)));
  return r.join("");
}
function I0(e, t) {
  let n = e.length, r = n - t.length;
  for (let i = 0; r == 0 && i < n; i++)
    r = e[i] - t[i];
  return r;
}
var M0 = "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";
const br = 44032, Zr = 4352, Kr = 4449, Yr = 4519, $a = 19, tu = 21, $n = 28, Jr = tu * $n, C0 = $a * Jr, T0 = br + C0, S0 = Zr + $a, U0 = Kr + tu, R0 = Yr + $n;
function yr(e) {
  return e >> 24 & 255;
}
function eu(e) {
  return e & 16777215;
}
let hs, _o, ds, Gr;
function N0() {
  let e = Ka(M0);
  hs = new Map(Ya(e).flatMap((t, n) => t.map((r) => [r, n + 1 << 24]))), _o = new Set(gr(e)), ds = /* @__PURE__ */ new Map(), Gr = /* @__PURE__ */ new Map();
  for (let [t, n] of Ja(e)) {
    if (!_o.has(t) && n.length == 2) {
      let [r, i] = n, s = Gr.get(r);
      s || (s = /* @__PURE__ */ new Map(), Gr.set(r, s)), s.set(i, t);
    }
    ds.set(t, n.reverse());
  }
}
function nu(e) {
  return e >= br && e < T0;
}
function D0(e, t) {
  if (e >= Zr && e < S0 && t >= Kr && t < U0)
    return br + (e - Zr) * Jr + (t - Kr) * $n;
  if (nu(e) && t > Yr && t < R0 && (e - br) % $n == 0)
    return e + (t - Yr);
  {
    let n = Gr.get(e);
    return n && (n = n.get(t), n) ? n : -1;
  }
}
function ru(e) {
  hs || N0();
  let t = [], n = [], r = !1;
  function i(s) {
    let o = hs.get(s);
    o && (r = !0, s |= o), t.push(s);
  }
  for (let s of e)
    for (; ; ) {
      if (s < 128)
        t.push(s);
      else if (nu(s)) {
        let o = s - br, u = o / Jr | 0, d = o % Jr / $n | 0, m = o % $n;
        i(Zr + u), i(Kr + d), m > 0 && i(Yr + m);
      } else {
        let o = ds.get(s);
        o ? n.push(...o) : i(s);
      }
      if (!n.length)
        break;
      s = n.pop();
    }
  if (r && t.length > 1) {
    let s = yr(t[0]);
    for (let o = 1; o < t.length; o++) {
      let u = yr(t[o]);
      if (u == 0 || s <= u) {
        s = u;
        continue;
      }
      let d = o - 1;
      for (; ; ) {
        let m = t[d + 1];
        if (t[d + 1] = t[d], t[d] = m, !d || (s = yr(t[--d]), s <= u))
          break;
      }
      s = yr(t[o]);
    }
  }
  return t;
}
function k0(e) {
  let t = [], n = [], r = -1, i = 0;
  for (let s of e) {
    let o = yr(s), u = eu(s);
    if (r == -1)
      o == 0 ? r = u : t.push(u);
    else if (i > 0 && i >= o)
      o == 0 ? (t.push(r, ...n), n.length = 0, r = u) : n.push(u), i = o;
    else {
      let d = D0(r, u);
      d >= 0 ? r = d : i == 0 && o == 0 ? (t.push(r), r = u) : (n.push(u), i = o);
    }
  }
  return r >= 0 && t.push(r, ...n), t;
}
function iu(e) {
  return ru(e).map(eu);
}
function O0(e) {
  return k0(ru(e));
}
const zo = 45, su = ".", ou = 65039, au = 1, Vn = (e) => Array.from(e);
function Ar(e, t) {
  return e.P.has(t) || e.Q.has(t);
}
class F0 extends Array {
  get is_emoji() {
    return !0;
  }
  // free tagging system
}
let ps, uu, En, ys, cu, jn, Qi, Hn, fu, Ho, ms;
function zs() {
  if (ps)
    return;
  let e = Ka(p0);
  const t = () => gr(e), n = () => new Set(t());
  ps = new Map(Ja(e)), uu = n(), En = t(), ys = new Set(t().map((w) => En[w])), En = new Set(En), cu = n(), n();
  let r = Ya(e), i = e();
  const s = () => new Set(t().flatMap((w) => r[w]).concat(t()));
  jn = wr((w) => {
    let B = wr(e).map((S) => S + 96);
    if (B.length) {
      let S = w >= i;
      B[0] -= 32, B = Wn(B), S && (B = `Restricted[${B}]`);
      let T = s(), O = s(), U = !e();
      return { N: B, P: T, Q: O, M: U, R: S };
    }
  }), Qi = n(), Hn = /* @__PURE__ */ new Map();
  let o = t().concat(Vn(Qi)).sort((w, B) => w - B);
  o.forEach((w, B) => {
    let S = e(), T = o[B] = S ? o[B - S] : { V: [], M: /* @__PURE__ */ new Map() };
    T.V.push(w), Qi.has(w) || Hn.set(w, T);
  });
  for (let { V: w, M: B } of new Set(Hn.values())) {
    let S = [];
    for (let O of w) {
      let U = jn.filter((P) => Ar(P, O)), R = S.find(({ G: P }) => U.some((G) => P.has(G)));
      R || (R = { G: /* @__PURE__ */ new Set(), V: [] }, S.push(R)), R.V.push(O), U.forEach((P) => R.G.add(P));
    }
    let T = S.flatMap((O) => Vn(O.G));
    for (let { G: O, V: U } of S) {
      let R = new Set(T.filter((P) => !O.has(P)));
      for (let P of U)
        B.set(P, R);
    }
  }
  let u = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set();
  const m = (w) => u.has(w) ? d.add(w) : u.add(w);
  for (let w of jn) {
    for (let B of w.P)
      m(B);
    for (let B of w.Q)
      m(B);
  }
  for (let w of u)
    !Hn.has(w) && !d.has(w) && Hn.set(w, au);
  fu = new Set(Vn(u).concat(Vn(iu(u)))), Ho = E0(e).map((w) => F0.from(w)).sort(I0), ms = /* @__PURE__ */ new Map();
  for (let w of Ho) {
    let B = [ms];
    for (let S of w) {
      let T = B.map((O) => {
        let U = O.get(S);
        return U || (U = /* @__PURE__ */ new Map(), O.set(S, U)), U;
      });
      S === ou ? B.push(...T) : B = T;
    }
    for (let S of B)
      S.V = w;
  }
}
function Hs(e) {
  return (lu(e) ? "" : `${Gs(ui([e]))} `) + Wa(e);
}
function Gs(e) {
  return `"${e}"‎`;
}
function L0(e) {
  if (e.length >= 4 && e[2] == zo && e[3] == zo)
    throw new Error(`invalid label extension: "${Wn(e.slice(0, 4))}"`);
}
function P0(e) {
  for (let n = e.lastIndexOf(95); n > 0; )
    if (e[--n] !== 95)
      throw new Error("underscore allowed only at start");
}
function _0(e) {
  let t = e[0], n = Lo.get(t);
  if (n)
    throw mr(`leading ${n}`);
  let r = e.length, i = -1;
  for (let s = 1; s < r; s++) {
    t = e[s];
    let o = Lo.get(t);
    if (o) {
      if (i == s)
        throw mr(`${n} + ${o}`);
      i = s + 1, n = o;
    }
  }
  if (i == r)
    throw mr(`trailing ${n}`);
}
function ui(e, t = Wa) {
  let n = [];
  z0(e[0]) && n.push("◌");
  let r = 0, i = e.length;
  for (let s = 0; s < i; s++) {
    let o = e[s];
    lu(o) && (n.push(Wn(e.slice(r, s))), n.push(t(o)), r = s + 1);
  }
  return n.push(Wn(e.slice(r, i))), n.join("");
}
function z0(e) {
  return zs(), En.has(e);
}
function lu(e) {
  return zs(), cu.has(e);
}
function H0(e) {
  return q0(G0(e, O0, K0));
}
function G0(e, t, n) {
  if (!e)
    return [];
  zs();
  let r = 0;
  return e.split(su).map((i) => {
    let s = B0(i), o = {
      input: s,
      offset: r
      // codepoint, not substring!
    };
    r += s.length + 1;
    try {
      let u = o.tokens = Z0(s, t, n), d = u.length, m;
      if (!d)
        throw new Error("empty label");
      let w = o.output = u.flat();
      if (P0(w), !(o.emoji = d > 1 || u[0].is_emoji) && w.every((S) => S < 128))
        L0(w), m = "ASCII";
      else {
        let S = u.flatMap((T) => T.is_emoji ? [] : T);
        if (!S.length)
          m = "Emoji";
        else {
          if (En.has(w[0]))
            throw mr("leading combining mark");
          for (let U = 1; U < d; U++) {
            let R = u[U];
            if (!R.is_emoji && En.has(R[0]))
              throw mr(`emoji + combining mark: "${Wn(u[U - 1])} + ${ui([R[0]])}"`);
          }
          _0(w);
          let T = Vn(new Set(S)), [O] = V0(T);
          j0(O, S), Q0(O, T), m = O.N;
        }
      }
      o.type = m;
    } catch (u) {
      o.error = u;
    }
    return o;
  });
}
function Q0(e, t) {
  let n, r = [];
  for (let i of t) {
    let s = Hn.get(i);
    if (s === au)
      return;
    if (s) {
      let o = s.M.get(i);
      if (n = n ? n.filter((u) => o.has(u)) : Vn(o), !n.length)
        return;
    } else
      r.push(i);
  }
  if (n) {
    for (let i of n)
      if (r.every((s) => Ar(i, s)))
        throw new Error(`whole-script confusable: ${e.N}/${i.N}`);
  }
}
function V0(e) {
  let t = jn;
  for (let n of e) {
    let r = t.filter((i) => Ar(i, n));
    if (!r.length)
      throw jn.some((i) => Ar(i, n)) ? du(t[0], n) : hu(n);
    if (t = r, r.length == 1)
      break;
  }
  return t;
}
function q0(e) {
  return e.map(({ input: t, error: n, output: r }) => {
    if (n) {
      let i = n.message;
      throw new Error(e.length == 1 ? i : `Invalid label ${Gs(ui(t))}: ${i}`);
    }
    return Wn(r);
  }).join(su);
}
function hu(e) {
  return new Error(`disallowed character: ${Hs(e)}`);
}
function du(e, t) {
  let n = Hs(t), r = jn.find((i) => i.P.has(t));
  return r && (n = `${r.N} ${n}`), new Error(`illegal mixture: ${e.N} + ${n}`);
}
function mr(e) {
  return new Error(`illegal placement: ${e}`);
}
function j0(e, t) {
  for (let n of t)
    if (!Ar(e, n))
      throw du(e, n);
  if (e.M) {
    let n = iu(t);
    for (let r = 1, i = n.length; r < i; r++)
      if (ys.has(n[r])) {
        let s = r + 1;
        for (let o; s < i && ys.has(o = n[s]); s++)
          for (let u = r; u < s; u++)
            if (n[u] == o)
              throw new Error(`duplicate non-spacing marks: ${Hs(o)}`);
        if (s - r > Po)
          throw new Error(`excessive non-spacing marks: ${Gs(ui(n.slice(r - 1, s)))} (${s - r}/${Po})`);
        r = s;
      }
  }
}
function Z0(e, t, n) {
  let r = [], i = [];
  for (e = e.slice().reverse(); e.length; ) {
    let s = Y0(e);
    if (s)
      i.length && (r.push(t(i)), i = []), r.push(n(s));
    else {
      let o = e.pop();
      if (fu.has(o))
        i.push(o);
      else {
        let u = ps.get(o);
        if (u)
          i.push(...u);
        else if (!uu.has(o))
          throw hu(o);
      }
    }
  }
  return i.length && r.push(t(i)), r;
}
function K0(e) {
  return e.filter((t) => t != ou);
}
function Y0(e, t) {
  let n = ms, r, i = e.length;
  for (; i && (n = n.get(e[--i]), !!n); ) {
    let { V: s } = n;
    s && (r = s, t && t.push(...e.slice(i).reverse()), e.length = i);
  }
  return r;
}
function J0(e) {
  return H0(e);
}
async function Vi(e, t) {
  const r = t.endsWith(".eth") ? await e.getEnsAddress({
    name: J0(t)
  }) : Qt(t);
  if (!r)
    throw new Error("Failed to resolve ENS address");
  return r;
}
function X0(e, ...t) {
  let n = 0;
  const r = [], i = e.startsWith("0x") ? e.substring(2) : e;
  for (const s of t)
    r.push(i.substr(n, s * 2)), n += s * 2;
  return r;
}
async function iy(e, t, n, r, i) {
  const s = i ? Qt(i) : Ae.REGISTRY.ADDRESS, o = Rs({
    address: s,
    abi: Ae.REGISTRY.ABI,
    client: {
      public: n
    }
  }), u = await n.getChainId();
  return await o.read.account([
    r ? Qt(r) : Ae.IMPLEMENTATION.ADDRESS,
    u,
    e,
    t,
    0
  ]);
}
async function W0(e, t, n, r, i, s) {
  s = s ?? 0;
  const o = r ? Qt(r) : Ae.IMPLEMENTATION.ADDRESS, u = i ? Qt(i) : Ae.REGISTRY.ADDRESS, d = Oe({
    abi: [
      {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
      }
    ],
    functionName: "initialize"
  });
  return {
    to: u,
    value: BigInt(0),
    data: Oe({
      abi: Ae.REGISTRY.ABI,
      functionName: "createAccount",
      args: [o, n, e, t, s, d]
    })
  };
}
async function $0(e, t, n, r, i, s, o) {
  s = s ?? 0;
  const u = r ? Qt(r) : Ae.IMPLEMENTATION.ADDRESS, d = i ? Qt(i) : Ae.REGISTRY.ADDRESS, m = Rs({
    address: d,
    abi: Ae.REGISTRY.ABI,
    client: {
      wallet: n
    }
  }), w = o || await n.getChainId(), B = Oe({
    abi: [
      {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
      }
    ],
    functionName: "initialize"
  });
  return m.write.createAccount([
    u,
    w,
    e,
    t,
    s,
    B
  ]);
}
async function th(e, t, n, r) {
  return {
    to: e,
    value: 0n,
    data: Oe({
      abi: Ae.IMPLEMENTATION.ABI,
      functionName: "executeCall",
      args: [t, n, r]
    })
  };
}
async function sy(e, t, n, r, i) {
  return Rs({
    address: e,
    abi: Ae.IMPLEMENTATION.ABI,
    client: {
      wallet: i
    }
  }).write.executeCall([t, n, r]);
}
function qi(e, t, n, r, i, s) {
  s = s ?? 0;
  const o = r ? Qt(r) : Ae.IMPLEMENTATION.ADDRESS, u = i ? Qt(i) : Ae.REGISTRY.ADDRESS, d = eh(
    o,
    n,
    e,
    t,
    s.toString()
  ), m = BigInt(s).toString(16), w = ya(m, { size: 32 });
  return ma({
    bytecode: d,
    from: u,
    opcode: "CREATE2",
    salt: w
  });
}
function eh(e, t, n, r, i) {
  const s = [
    { type: "uint256" },
    { type: "uint256" },
    { type: "address" },
    { type: "uint256" }
  ], o = [i, BigInt(t), n, r], u = ga(s, o), m = wa([
    "0x3d60ad80600a3d3981f3363d3d373d3d3d363d73",
    e,
    "0x5af43d82803e903d91602b57fd5bf3",
    u
  ]);
  return ba(m);
}
async function nh(e, t, n, r, i, s) {
  s = s ?? 0;
  const o = r ?? fe.ACCOUNT_PROXY.ADDRESS, u = i ?? fe.REGISTRY.ADDRESS;
  return {
    to: Qt(u),
    value: BigInt(0),
    data: Oe({
      abi: fe.REGISTRY.ABI,
      functionName: "createAccount",
      args: [
        Qt(o),
        _c(zc(s, { size: 32 })),
        n,
        e,
        t
      ]
    })
  };
}
function ji(e, t, n, r, i, s) {
  s = s ?? 0;
  const o = r ?? fe.ACCOUNT_PROXY.ADDRESS, u = i ?? fe.REGISTRY.ADDRESS, d = [
    { type: "uint256" },
    // salt
    { type: "uint256" },
    // chainId
    { type: "address" },
    // tokenContract
    { type: "uint256" }
    // tokenId
  ], m = [
    s.toString(),
    BigInt(n),
    e,
    t
  ], w = ga(d, m), B = wa([
    "0x3d60ad80600a3d3981f3363d3d373d3d3d363d73",
    Qt(o),
    e0,
    w
  ]), S = ba(B), T = BigInt(s).toString(16), O = ya(T, { size: 32 });
  return ma({
    bytecode: S,
    from: Qt(u),
    opcode: "CREATE2",
    salt: O
  });
}
const rh = "logger/5.7.0";
let Go = !1, Qo = !1;
const Qr = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let Vo = Qr.default, Zi = null;
function ih() {
  try {
    const e = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((t) => {
      try {
        if ("test".normalize(t) !== "test")
          throw new Error("bad normalize");
      } catch {
        e.push(t);
      }
    }), e.length)
      throw new Error("missing " + e.join(", "));
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769))
      throw new Error("broken implementation");
  } catch (e) {
    return e.message;
  }
  return null;
}
const qo = ih();
var gs;
(function(e) {
  e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})(gs || (gs = {}));
var _e;
(function(e) {
  e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})(_e || (_e = {}));
const jo = "0123456789abcdef";
class Bt {
  constructor(t) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }
  _log(t, n) {
    const r = t.toLowerCase();
    Qr[r] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !(Vo > Qr[r]) && console.log.apply(console, n);
  }
  debug(...t) {
    this._log(Bt.levels.DEBUG, t);
  }
  info(...t) {
    this._log(Bt.levels.INFO, t);
  }
  warn(...t) {
    this._log(Bt.levels.WARNING, t);
  }
  makeError(t, n, r) {
    if (Qo)
      return this.makeError("censored error", n, {});
    n || (n = Bt.errors.UNKNOWN_ERROR), r || (r = {});
    const i = [];
    Object.keys(r).forEach((d) => {
      const m = r[d];
      try {
        if (m instanceof Uint8Array) {
          let w = "";
          for (let B = 0; B < m.length; B++)
            w += jo[m[B] >> 4], w += jo[m[B] & 15];
          i.push(d + "=Uint8Array(0x" + w + ")");
        } else
          i.push(d + "=" + JSON.stringify(m));
      } catch {
        i.push(d + "=" + JSON.stringify(r[d].toString()));
      }
    }), i.push(`code=${n}`), i.push(`version=${this.version}`);
    const s = t;
    let o = "";
    switch (n) {
      case _e.NUMERIC_FAULT: {
        o = "NUMERIC_FAULT";
        const d = t;
        switch (d) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            o += "-" + d;
            break;
          case "negative-power":
          case "negative-width":
            o += "-unsupported";
            break;
          case "unbound-bitwise-result":
            o += "-unbound-result";
            break;
        }
        break;
      }
      case _e.CALL_EXCEPTION:
      case _e.INSUFFICIENT_FUNDS:
      case _e.MISSING_NEW:
      case _e.NONCE_EXPIRED:
      case _e.REPLACEMENT_UNDERPRICED:
      case _e.TRANSACTION_REPLACED:
      case _e.UNPREDICTABLE_GAS_LIMIT:
        o = n;
        break;
    }
    o && (t += " [ See: https://links.ethers.org/v5-errors-" + o + " ]"), i.length && (t += " (" + i.join(", ") + ")");
    const u = new Error(t);
    return u.reason = s, u.code = n, Object.keys(r).forEach(function(d) {
      u[d] = r[d];
    }), u;
  }
  throwError(t, n, r) {
    throw this.makeError(t, n, r);
  }
  throwArgumentError(t, n, r) {
    return this.throwError(t, Bt.errors.INVALID_ARGUMENT, {
      argument: n,
      value: r
    });
  }
  assert(t, n, r, i) {
    t || this.throwError(n, r, i);
  }
  assertArgument(t, n, r, i) {
    t || this.throwArgumentError(n, r, i);
  }
  checkNormalize(t) {
    qo && this.throwError("platform missing String.prototype.normalize", Bt.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: qo
    });
  }
  checkSafeUint53(t, n) {
    typeof t == "number" && (n == null && (n = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(n, Bt.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: t
    }), t % 1 && this.throwError(n, Bt.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: t
    }));
  }
  checkArgumentCount(t, n, r) {
    r ? r = ": " + r : r = "", t < n && this.throwError("missing argument" + r, Bt.errors.MISSING_ARGUMENT, {
      count: t,
      expectedCount: n
    }), t > n && this.throwError("too many arguments" + r, Bt.errors.UNEXPECTED_ARGUMENT, {
      count: t,
      expectedCount: n
    });
  }
  checkNew(t, n) {
    (t === Object || t == null) && this.throwError("missing new", Bt.errors.MISSING_NEW, { name: n.name });
  }
  checkAbstract(t, n) {
    t === n ? this.throwError("cannot instantiate abstract class " + JSON.stringify(n.name) + " directly; use a sub-class", Bt.errors.UNSUPPORTED_OPERATION, { name: t.name, operation: "new" }) : (t === Object || t == null) && this.throwError("missing new", Bt.errors.MISSING_NEW, { name: n.name });
  }
  static globalLogger() {
    return Zi || (Zi = new Bt(rh)), Zi;
  }
  static setCensorship(t, n) {
    if (!t && n && this.globalLogger().throwError("cannot permanently disable censorship", Bt.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), Go) {
      if (!t)
        return;
      this.globalLogger().throwError("error censorship permanent", Bt.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    Qo = !!t, Go = !!n;
  }
  static setLogLevel(t) {
    const n = Qr[t.toLowerCase()];
    if (n == null) {
      Bt.globalLogger().warn("invalid log level - " + t);
      return;
    }
    Vo = n;
  }
  static from(t) {
    return new Bt(t);
  }
}
Bt.errors = _e;
Bt.levels = gs;
const sh = "bytes/5.7.0", rn = new Bt(sh);
function pu(e) {
  return !!e.toHexString;
}
function Zn(e) {
  return e.slice || (e.slice = function() {
    const t = Array.prototype.slice.call(arguments);
    return Zn(new Uint8Array(Array.prototype.slice.apply(e, t)));
  }), e;
}
function Zo(e) {
  return typeof e == "number" && e == e && e % 1 === 0;
}
function Qs(e) {
  if (e == null)
    return !1;
  if (e.constructor === Uint8Array)
    return !0;
  if (typeof e == "string" || !Zo(e.length) || e.length < 0)
    return !1;
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (!Zo(n) || n < 0 || n >= 256)
      return !1;
  }
  return !0;
}
function je(e, t) {
  if (t || (t = {}), typeof e == "number") {
    rn.checkSafeUint53(e, "invalid arrayify value");
    const n = [];
    for (; e; )
      n.unshift(e & 255), e = parseInt(String(e / 256));
    return n.length === 0 && n.push(0), Zn(new Uint8Array(n));
  }
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), pu(e) && (e = e.toHexString()), xr(e)) {
    let n = e.substring(2);
    n.length % 2 && (t.hexPad === "left" ? n = "0" + n : t.hexPad === "right" ? n += "0" : rn.throwArgumentError("hex data is odd-length", "value", e));
    const r = [];
    for (let i = 0; i < n.length; i += 2)
      r.push(parseInt(n.substring(i, i + 2), 16));
    return Zn(new Uint8Array(r));
  }
  return Qs(e) ? Zn(new Uint8Array(e)) : rn.throwArgumentError("invalid arrayify value", "value", e);
}
function yu(e) {
  const t = e.map((i) => je(i)), n = t.reduce((i, s) => i + s.length, 0), r = new Uint8Array(n);
  return t.reduce((i, s) => (r.set(s, i), i + s.length), 0), Zn(r);
}
function Ki(e, t) {
  e = je(e), e.length > t && rn.throwArgumentError("value out of range", "value", arguments[0]);
  const n = new Uint8Array(t);
  return n.set(e, t - e.length), Zn(n);
}
function xr(e, t) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
}
const Yi = "0123456789abcdef";
function vn(e, t) {
  if (t || (t = {}), typeof e == "number") {
    rn.checkSafeUint53(e, "invalid hexlify value");
    let n = "";
    for (; e; )
      n = Yi[e & 15] + n, e = Math.floor(e / 16);
    return n.length ? (n.length % 2 && (n = "0" + n), "0x" + n) : "0x00";
  }
  if (typeof e == "bigint")
    return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), pu(e))
    return e.toHexString();
  if (xr(e))
    return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : rn.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
  if (Qs(e)) {
    let n = "0x";
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      n += Yi[(i & 240) >> 4] + Yi[i & 15];
    }
    return n;
  }
  return rn.throwArgumentError("invalid hexlify value", "value", e);
}
function oh(e, t) {
  for (typeof e != "string" ? e = vn(e) : xr(e) || rn.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && rn.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2; )
    e = "0x0" + e.substring(2);
  return e;
}
var He = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function mu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Vs(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var qs = { exports: {} };
const ah = {}, uh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ah
}, Symbol.toStringTag, { value: "Module" })), ch = /* @__PURE__ */ Vs(uh);
qs.exports;
(function(e) {
  (function(t, n) {
    function r(I, a) {
      if (!I)
        throw new Error(a || "Assertion failed");
    }
    function i(I, a) {
      I.super_ = a;
      var h = function() {
      };
      h.prototype = a.prototype, I.prototype = new h(), I.prototype.constructor = I;
    }
    function s(I, a, h) {
      if (s.isBN(I))
        return I;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, I !== null && ((a === "le" || a === "be") && (h = a, a = 10), this._init(I || 0, a || 10, h || "be"));
    }
    typeof t == "object" ? t.exports = s : n.BN = s, s.BN = s, s.wordSize = 26;
    var o;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? o = window.Buffer : o = ch.Buffer;
    } catch {
    }
    s.isBN = function(a) {
      return a instanceof s ? !0 : a !== null && typeof a == "object" && a.constructor.wordSize === s.wordSize && Array.isArray(a.words);
    }, s.max = function(a, h) {
      return a.cmp(h) > 0 ? a : h;
    }, s.min = function(a, h) {
      return a.cmp(h) < 0 ? a : h;
    }, s.prototype._init = function(a, h, y) {
      if (typeof a == "number")
        return this._initNumber(a, h, y);
      if (typeof a == "object")
        return this._initArray(a, h, y);
      h === "hex" && (h = 16), r(h === (h | 0) && h >= 2 && h <= 36), a = a.toString().replace(/\s+/g, "");
      var E = 0;
      a[0] === "-" && (E++, this.negative = 1), E < a.length && (h === 16 ? this._parseHex(a, E, y) : (this._parseBase(a, h, E), y === "le" && this._initArray(this.toArray(), h, y)));
    }, s.prototype._initNumber = function(a, h, y) {
      a < 0 && (this.negative = 1, a = -a), a < 67108864 ? (this.words = [a & 67108863], this.length = 1) : a < 4503599627370496 ? (this.words = [
        a & 67108863,
        a / 67108864 & 67108863
      ], this.length = 2) : (r(a < 9007199254740992), this.words = [
        a & 67108863,
        a / 67108864 & 67108863,
        1
      ], this.length = 3), y === "le" && this._initArray(this.toArray(), h, y);
    }, s.prototype._initArray = function(a, h, y) {
      if (r(typeof a.length == "number"), a.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(a.length / 3), this.words = new Array(this.length);
      for (var E = 0; E < this.length; E++)
        this.words[E] = 0;
      var b, x, M = 0;
      if (y === "be")
        for (E = a.length - 1, b = 0; E >= 0; E -= 3)
          x = a[E] | a[E - 1] << 8 | a[E - 2] << 16, this.words[b] |= x << M & 67108863, this.words[b + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, b++);
      else if (y === "le")
        for (E = 0, b = 0; E < a.length; E += 3)
          x = a[E] | a[E + 1] << 8 | a[E + 2] << 16, this.words[b] |= x << M & 67108863, this.words[b + 1] = x >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, b++);
      return this._strip();
    };
    function u(I, a) {
      var h = I.charCodeAt(a);
      if (h >= 48 && h <= 57)
        return h - 48;
      if (h >= 65 && h <= 70)
        return h - 55;
      if (h >= 97 && h <= 102)
        return h - 87;
      r(!1, "Invalid character in " + I);
    }
    function d(I, a, h) {
      var y = u(I, h);
      return h - 1 >= a && (y |= u(I, h - 1) << 4), y;
    }
    s.prototype._parseHex = function(a, h, y) {
      this.length = Math.ceil((a.length - h) / 6), this.words = new Array(this.length);
      for (var E = 0; E < this.length; E++)
        this.words[E] = 0;
      var b = 0, x = 0, M;
      if (y === "be")
        for (E = a.length - 1; E >= h; E -= 2)
          M = d(a, h, E) << b, this.words[x] |= M & 67108863, b >= 18 ? (b -= 18, x += 1, this.words[x] |= M >>> 26) : b += 8;
      else {
        var g = a.length - h;
        for (E = g % 2 === 0 ? h + 1 : h; E < a.length; E += 2)
          M = d(a, h, E) << b, this.words[x] |= M & 67108863, b >= 18 ? (b -= 18, x += 1, this.words[x] |= M >>> 26) : b += 8;
      }
      this._strip();
    };
    function m(I, a, h, y) {
      for (var E = 0, b = 0, x = Math.min(I.length, h), M = a; M < x; M++) {
        var g = I.charCodeAt(M) - 48;
        E *= y, g >= 49 ? b = g - 49 + 10 : g >= 17 ? b = g - 17 + 10 : b = g, r(g >= 0 && b < y, "Invalid character"), E += b;
      }
      return E;
    }
    s.prototype._parseBase = function(a, h, y) {
      this.words = [0], this.length = 1;
      for (var E = 0, b = 1; b <= 67108863; b *= h)
        E++;
      E--, b = b / h | 0;
      for (var x = a.length - y, M = x % E, g = Math.min(x, x - M) + y, f = 0, v = y; v < g; v += E)
        f = m(a, v, v + E, h), this.imuln(b), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
      if (M !== 0) {
        var Q = 1;
        for (f = m(a, v, a.length, h), v = 0; v < M; v++)
          Q *= h;
        this.imuln(Q), this.words[0] + f < 67108864 ? this.words[0] += f : this._iaddn(f);
      }
      this._strip();
    }, s.prototype.copy = function(a) {
      a.words = new Array(this.length);
      for (var h = 0; h < this.length; h++)
        a.words[h] = this.words[h];
      a.length = this.length, a.negative = this.negative, a.red = this.red;
    };
    function w(I, a) {
      I.words = a.words, I.length = a.length, I.negative = a.negative, I.red = a.red;
    }
    if (s.prototype._move = function(a) {
      w(a, this);
    }, s.prototype.clone = function() {
      var a = new s(null);
      return this.copy(a), a;
    }, s.prototype._expand = function(a) {
      for (; this.length < a; )
        this.words[this.length++] = 0;
      return this;
    }, s.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, s.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = B;
      } catch {
        s.prototype.inspect = B;
      }
    else
      s.prototype.inspect = B;
    function B() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var S = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], T = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], O = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    s.prototype.toString = function(a, h) {
      a = a || 10, h = h | 0 || 1;
      var y;
      if (a === 16 || a === "hex") {
        y = "";
        for (var E = 0, b = 0, x = 0; x < this.length; x++) {
          var M = this.words[x], g = ((M << E | b) & 16777215).toString(16);
          b = M >>> 24 - E & 16777215, E += 2, E >= 26 && (E -= 26, x--), b !== 0 || x !== this.length - 1 ? y = S[6 - g.length] + g + y : y = g + y;
        }
        for (b !== 0 && (y = b.toString(16) + y); y.length % h !== 0; )
          y = "0" + y;
        return this.negative !== 0 && (y = "-" + y), y;
      }
      if (a === (a | 0) && a >= 2 && a <= 36) {
        var f = T[a], v = O[a];
        y = "";
        var Q = this.clone();
        for (Q.negative = 0; !Q.isZero(); ) {
          var V = Q.modrn(v).toString(a);
          Q = Q.idivn(v), Q.isZero() ? y = V + y : y = S[f - V.length] + V + y;
        }
        for (this.isZero() && (y = "0" + y); y.length % h !== 0; )
          y = "0" + y;
        return this.negative !== 0 && (y = "-" + y), y;
      }
      r(!1, "Base should be between 2 and 36");
    }, s.prototype.toNumber = function() {
      var a = this.words[0];
      return this.length === 2 ? a += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? a += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -a : a;
    }, s.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, o && (s.prototype.toBuffer = function(a, h) {
      return this.toArrayLike(o, a, h);
    }), s.prototype.toArray = function(a, h) {
      return this.toArrayLike(Array, a, h);
    };
    var U = function(a, h) {
      return a.allocUnsafe ? a.allocUnsafe(h) : new a(h);
    };
    s.prototype.toArrayLike = function(a, h, y) {
      this._strip();
      var E = this.byteLength(), b = y || Math.max(1, E);
      r(E <= b, "byte array longer than desired length"), r(b > 0, "Requested array length <= 0");
      var x = U(a, b), M = h === "le" ? "LE" : "BE";
      return this["_toArrayLike" + M](x, E), x;
    }, s.prototype._toArrayLikeLE = function(a, h) {
      for (var y = 0, E = 0, b = 0, x = 0; b < this.length; b++) {
        var M = this.words[b] << x | E;
        a[y++] = M & 255, y < a.length && (a[y++] = M >> 8 & 255), y < a.length && (a[y++] = M >> 16 & 255), x === 6 ? (y < a.length && (a[y++] = M >> 24 & 255), E = 0, x = 0) : (E = M >>> 24, x += 2);
      }
      if (y < a.length)
        for (a[y++] = E; y < a.length; )
          a[y++] = 0;
    }, s.prototype._toArrayLikeBE = function(a, h) {
      for (var y = a.length - 1, E = 0, b = 0, x = 0; b < this.length; b++) {
        var M = this.words[b] << x | E;
        a[y--] = M & 255, y >= 0 && (a[y--] = M >> 8 & 255), y >= 0 && (a[y--] = M >> 16 & 255), x === 6 ? (y >= 0 && (a[y--] = M >> 24 & 255), E = 0, x = 0) : (E = M >>> 24, x += 2);
      }
      if (y >= 0)
        for (a[y--] = E; y >= 0; )
          a[y--] = 0;
    }, Math.clz32 ? s.prototype._countBits = function(a) {
      return 32 - Math.clz32(a);
    } : s.prototype._countBits = function(a) {
      var h = a, y = 0;
      return h >= 4096 && (y += 13, h >>>= 13), h >= 64 && (y += 7, h >>>= 7), h >= 8 && (y += 4, h >>>= 4), h >= 2 && (y += 2, h >>>= 2), y + h;
    }, s.prototype._zeroBits = function(a) {
      if (a === 0)
        return 26;
      var h = a, y = 0;
      return h & 8191 || (y += 13, h >>>= 13), h & 127 || (y += 7, h >>>= 7), h & 15 || (y += 4, h >>>= 4), h & 3 || (y += 2, h >>>= 2), h & 1 || y++, y;
    }, s.prototype.bitLength = function() {
      var a = this.words[this.length - 1], h = this._countBits(a);
      return (this.length - 1) * 26 + h;
    };
    function R(I) {
      for (var a = new Array(I.bitLength()), h = 0; h < a.length; h++) {
        var y = h / 26 | 0, E = h % 26;
        a[h] = I.words[y] >>> E & 1;
      }
      return a;
    }
    s.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var a = 0, h = 0; h < this.length; h++) {
        var y = this._zeroBits(this.words[h]);
        if (a += y, y !== 26)
          break;
      }
      return a;
    }, s.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, s.prototype.toTwos = function(a) {
      return this.negative !== 0 ? this.abs().inotn(a).iaddn(1) : this.clone();
    }, s.prototype.fromTwos = function(a) {
      return this.testn(a - 1) ? this.notn(a).iaddn(1).ineg() : this.clone();
    }, s.prototype.isNeg = function() {
      return this.negative !== 0;
    }, s.prototype.neg = function() {
      return this.clone().ineg();
    }, s.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, s.prototype.iuor = function(a) {
      for (; this.length < a.length; )
        this.words[this.length++] = 0;
      for (var h = 0; h < a.length; h++)
        this.words[h] = this.words[h] | a.words[h];
      return this._strip();
    }, s.prototype.ior = function(a) {
      return r((this.negative | a.negative) === 0), this.iuor(a);
    }, s.prototype.or = function(a) {
      return this.length > a.length ? this.clone().ior(a) : a.clone().ior(this);
    }, s.prototype.uor = function(a) {
      return this.length > a.length ? this.clone().iuor(a) : a.clone().iuor(this);
    }, s.prototype.iuand = function(a) {
      var h;
      this.length > a.length ? h = a : h = this;
      for (var y = 0; y < h.length; y++)
        this.words[y] = this.words[y] & a.words[y];
      return this.length = h.length, this._strip();
    }, s.prototype.iand = function(a) {
      return r((this.negative | a.negative) === 0), this.iuand(a);
    }, s.prototype.and = function(a) {
      return this.length > a.length ? this.clone().iand(a) : a.clone().iand(this);
    }, s.prototype.uand = function(a) {
      return this.length > a.length ? this.clone().iuand(a) : a.clone().iuand(this);
    }, s.prototype.iuxor = function(a) {
      var h, y;
      this.length > a.length ? (h = this, y = a) : (h = a, y = this);
      for (var E = 0; E < y.length; E++)
        this.words[E] = h.words[E] ^ y.words[E];
      if (this !== h)
        for (; E < h.length; E++)
          this.words[E] = h.words[E];
      return this.length = h.length, this._strip();
    }, s.prototype.ixor = function(a) {
      return r((this.negative | a.negative) === 0), this.iuxor(a);
    }, s.prototype.xor = function(a) {
      return this.length > a.length ? this.clone().ixor(a) : a.clone().ixor(this);
    }, s.prototype.uxor = function(a) {
      return this.length > a.length ? this.clone().iuxor(a) : a.clone().iuxor(this);
    }, s.prototype.inotn = function(a) {
      r(typeof a == "number" && a >= 0);
      var h = Math.ceil(a / 26) | 0, y = a % 26;
      this._expand(h), y > 0 && h--;
      for (var E = 0; E < h; E++)
        this.words[E] = ~this.words[E] & 67108863;
      return y > 0 && (this.words[E] = ~this.words[E] & 67108863 >> 26 - y), this._strip();
    }, s.prototype.notn = function(a) {
      return this.clone().inotn(a);
    }, s.prototype.setn = function(a, h) {
      r(typeof a == "number" && a >= 0);
      var y = a / 26 | 0, E = a % 26;
      return this._expand(y + 1), h ? this.words[y] = this.words[y] | 1 << E : this.words[y] = this.words[y] & ~(1 << E), this._strip();
    }, s.prototype.iadd = function(a) {
      var h;
      if (this.negative !== 0 && a.negative === 0)
        return this.negative = 0, h = this.isub(a), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && a.negative !== 0)
        return a.negative = 0, h = this.isub(a), a.negative = 1, h._normSign();
      var y, E;
      this.length > a.length ? (y = this, E = a) : (y = a, E = this);
      for (var b = 0, x = 0; x < E.length; x++)
        h = (y.words[x] | 0) + (E.words[x] | 0) + b, this.words[x] = h & 67108863, b = h >>> 26;
      for (; b !== 0 && x < y.length; x++)
        h = (y.words[x] | 0) + b, this.words[x] = h & 67108863, b = h >>> 26;
      if (this.length = y.length, b !== 0)
        this.words[this.length] = b, this.length++;
      else if (y !== this)
        for (; x < y.length; x++)
          this.words[x] = y.words[x];
      return this;
    }, s.prototype.add = function(a) {
      var h;
      return a.negative !== 0 && this.negative === 0 ? (a.negative = 0, h = this.sub(a), a.negative ^= 1, h) : a.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = a.sub(this), this.negative = 1, h) : this.length > a.length ? this.clone().iadd(a) : a.clone().iadd(this);
    }, s.prototype.isub = function(a) {
      if (a.negative !== 0) {
        a.negative = 0;
        var h = this.iadd(a);
        return a.negative = 1, h._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(a), this.negative = 1, this._normSign();
      var y = this.cmp(a);
      if (y === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var E, b;
      y > 0 ? (E = this, b = a) : (E = a, b = this);
      for (var x = 0, M = 0; M < b.length; M++)
        h = (E.words[M] | 0) - (b.words[M] | 0) + x, x = h >> 26, this.words[M] = h & 67108863;
      for (; x !== 0 && M < E.length; M++)
        h = (E.words[M] | 0) + x, x = h >> 26, this.words[M] = h & 67108863;
      if (x === 0 && M < E.length && E !== this)
        for (; M < E.length; M++)
          this.words[M] = E.words[M];
      return this.length = Math.max(this.length, M), E !== this && (this.negative = 1), this._strip();
    }, s.prototype.sub = function(a) {
      return this.clone().isub(a);
    };
    function P(I, a, h) {
      h.negative = a.negative ^ I.negative;
      var y = I.length + a.length | 0;
      h.length = y, y = y - 1 | 0;
      var E = I.words[0] | 0, b = a.words[0] | 0, x = E * b, M = x & 67108863, g = x / 67108864 | 0;
      h.words[0] = M;
      for (var f = 1; f < y; f++) {
        for (var v = g >>> 26, Q = g & 67108863, V = Math.min(f, a.length - 1), q = Math.max(0, f - I.length + 1); q <= V; q++) {
          var nt = f - q | 0;
          E = I.words[nt] | 0, b = a.words[q] | 0, x = E * b + Q, v += x / 67108864 | 0, Q = x & 67108863;
        }
        h.words[f] = Q | 0, g = v | 0;
      }
      return g !== 0 ? h.words[f] = g | 0 : h.length--, h._strip();
    }
    var G = function(a, h, y) {
      var E = a.words, b = h.words, x = y.words, M = 0, g, f, v, Q = E[0] | 0, V = Q & 8191, q = Q >>> 13, nt = E[1] | 0, $ = nt & 8191, rt = nt >>> 13, Pt = E[2] | 0, ft = Pt & 8191, ht = Pt >>> 13, At = E[3] | 0, pt = At & 8191, vt = At >>> 13, Qe = E[4] | 0, Ct = Qe & 8191, Ft = Qe >>> 13, Fn = E[5] | 0, Dt = Fn & 8191, Tt = Fn >>> 13, ye = E[6] | 0, St = ye & 8191, Ut = ye >>> 13, ve = E[7] | 0, kt = ve & 8191, p = ve >>> 13, c = E[8] | 0, l = c & 8191, A = c >>> 13, C = E[9] | 0, N = C & 8191, F = C >>> 13, ct = b[0] | 0, at = ct & 8191, ot = ct >>> 13, Ot = b[1] | 0, st = Ot & 8191, Vt = Ot >>> 13, wo = b[2] | 0, qt = wo & 8191, jt = wo >>> 13, bo = b[3] | 0, Zt = bo & 8191, Kt = bo >>> 13, Ao = b[4] | 0, Yt = Ao & 8191, Jt = Ao >>> 13, xo = b[5] | 0, Xt = xo & 8191, Wt = xo >>> 13, Eo = b[6] | 0, $t = Eo & 8191, te = Eo >>> 13, vo = b[7] | 0, ee = vo & 8191, ne = vo >>> 13, Bo = b[8] | 0, re = Bo & 8191, ie = Bo >>> 13, Io = b[9] | 0, se = Io & 8191, oe = Io >>> 13;
      y.negative = a.negative ^ h.negative, y.length = 19, g = Math.imul(V, at), f = Math.imul(V, ot), f = f + Math.imul(q, at) | 0, v = Math.imul(q, ot);
      var Ai = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, g = Math.imul($, at), f = Math.imul($, ot), f = f + Math.imul(rt, at) | 0, v = Math.imul(rt, ot), g = g + Math.imul(V, st) | 0, f = f + Math.imul(V, Vt) | 0, f = f + Math.imul(q, st) | 0, v = v + Math.imul(q, Vt) | 0;
      var xi = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (xi >>> 26) | 0, xi &= 67108863, g = Math.imul(ft, at), f = Math.imul(ft, ot), f = f + Math.imul(ht, at) | 0, v = Math.imul(ht, ot), g = g + Math.imul($, st) | 0, f = f + Math.imul($, Vt) | 0, f = f + Math.imul(rt, st) | 0, v = v + Math.imul(rt, Vt) | 0, g = g + Math.imul(V, qt) | 0, f = f + Math.imul(V, jt) | 0, f = f + Math.imul(q, qt) | 0, v = v + Math.imul(q, jt) | 0;
      var Ei = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Ei >>> 26) | 0, Ei &= 67108863, g = Math.imul(pt, at), f = Math.imul(pt, ot), f = f + Math.imul(vt, at) | 0, v = Math.imul(vt, ot), g = g + Math.imul(ft, st) | 0, f = f + Math.imul(ft, Vt) | 0, f = f + Math.imul(ht, st) | 0, v = v + Math.imul(ht, Vt) | 0, g = g + Math.imul($, qt) | 0, f = f + Math.imul($, jt) | 0, f = f + Math.imul(rt, qt) | 0, v = v + Math.imul(rt, jt) | 0, g = g + Math.imul(V, Zt) | 0, f = f + Math.imul(V, Kt) | 0, f = f + Math.imul(q, Zt) | 0, v = v + Math.imul(q, Kt) | 0;
      var vi = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (vi >>> 26) | 0, vi &= 67108863, g = Math.imul(Ct, at), f = Math.imul(Ct, ot), f = f + Math.imul(Ft, at) | 0, v = Math.imul(Ft, ot), g = g + Math.imul(pt, st) | 0, f = f + Math.imul(pt, Vt) | 0, f = f + Math.imul(vt, st) | 0, v = v + Math.imul(vt, Vt) | 0, g = g + Math.imul(ft, qt) | 0, f = f + Math.imul(ft, jt) | 0, f = f + Math.imul(ht, qt) | 0, v = v + Math.imul(ht, jt) | 0, g = g + Math.imul($, Zt) | 0, f = f + Math.imul($, Kt) | 0, f = f + Math.imul(rt, Zt) | 0, v = v + Math.imul(rt, Kt) | 0, g = g + Math.imul(V, Yt) | 0, f = f + Math.imul(V, Jt) | 0, f = f + Math.imul(q, Yt) | 0, v = v + Math.imul(q, Jt) | 0;
      var Bi = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Bi >>> 26) | 0, Bi &= 67108863, g = Math.imul(Dt, at), f = Math.imul(Dt, ot), f = f + Math.imul(Tt, at) | 0, v = Math.imul(Tt, ot), g = g + Math.imul(Ct, st) | 0, f = f + Math.imul(Ct, Vt) | 0, f = f + Math.imul(Ft, st) | 0, v = v + Math.imul(Ft, Vt) | 0, g = g + Math.imul(pt, qt) | 0, f = f + Math.imul(pt, jt) | 0, f = f + Math.imul(vt, qt) | 0, v = v + Math.imul(vt, jt) | 0, g = g + Math.imul(ft, Zt) | 0, f = f + Math.imul(ft, Kt) | 0, f = f + Math.imul(ht, Zt) | 0, v = v + Math.imul(ht, Kt) | 0, g = g + Math.imul($, Yt) | 0, f = f + Math.imul($, Jt) | 0, f = f + Math.imul(rt, Yt) | 0, v = v + Math.imul(rt, Jt) | 0, g = g + Math.imul(V, Xt) | 0, f = f + Math.imul(V, Wt) | 0, f = f + Math.imul(q, Xt) | 0, v = v + Math.imul(q, Wt) | 0;
      var Ii = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Ii >>> 26) | 0, Ii &= 67108863, g = Math.imul(St, at), f = Math.imul(St, ot), f = f + Math.imul(Ut, at) | 0, v = Math.imul(Ut, ot), g = g + Math.imul(Dt, st) | 0, f = f + Math.imul(Dt, Vt) | 0, f = f + Math.imul(Tt, st) | 0, v = v + Math.imul(Tt, Vt) | 0, g = g + Math.imul(Ct, qt) | 0, f = f + Math.imul(Ct, jt) | 0, f = f + Math.imul(Ft, qt) | 0, v = v + Math.imul(Ft, jt) | 0, g = g + Math.imul(pt, Zt) | 0, f = f + Math.imul(pt, Kt) | 0, f = f + Math.imul(vt, Zt) | 0, v = v + Math.imul(vt, Kt) | 0, g = g + Math.imul(ft, Yt) | 0, f = f + Math.imul(ft, Jt) | 0, f = f + Math.imul(ht, Yt) | 0, v = v + Math.imul(ht, Jt) | 0, g = g + Math.imul($, Xt) | 0, f = f + Math.imul($, Wt) | 0, f = f + Math.imul(rt, Xt) | 0, v = v + Math.imul(rt, Wt) | 0, g = g + Math.imul(V, $t) | 0, f = f + Math.imul(V, te) | 0, f = f + Math.imul(q, $t) | 0, v = v + Math.imul(q, te) | 0;
      var Mi = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Mi >>> 26) | 0, Mi &= 67108863, g = Math.imul(kt, at), f = Math.imul(kt, ot), f = f + Math.imul(p, at) | 0, v = Math.imul(p, ot), g = g + Math.imul(St, st) | 0, f = f + Math.imul(St, Vt) | 0, f = f + Math.imul(Ut, st) | 0, v = v + Math.imul(Ut, Vt) | 0, g = g + Math.imul(Dt, qt) | 0, f = f + Math.imul(Dt, jt) | 0, f = f + Math.imul(Tt, qt) | 0, v = v + Math.imul(Tt, jt) | 0, g = g + Math.imul(Ct, Zt) | 0, f = f + Math.imul(Ct, Kt) | 0, f = f + Math.imul(Ft, Zt) | 0, v = v + Math.imul(Ft, Kt) | 0, g = g + Math.imul(pt, Yt) | 0, f = f + Math.imul(pt, Jt) | 0, f = f + Math.imul(vt, Yt) | 0, v = v + Math.imul(vt, Jt) | 0, g = g + Math.imul(ft, Xt) | 0, f = f + Math.imul(ft, Wt) | 0, f = f + Math.imul(ht, Xt) | 0, v = v + Math.imul(ht, Wt) | 0, g = g + Math.imul($, $t) | 0, f = f + Math.imul($, te) | 0, f = f + Math.imul(rt, $t) | 0, v = v + Math.imul(rt, te) | 0, g = g + Math.imul(V, ee) | 0, f = f + Math.imul(V, ne) | 0, f = f + Math.imul(q, ee) | 0, v = v + Math.imul(q, ne) | 0;
      var Ci = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, g = Math.imul(l, at), f = Math.imul(l, ot), f = f + Math.imul(A, at) | 0, v = Math.imul(A, ot), g = g + Math.imul(kt, st) | 0, f = f + Math.imul(kt, Vt) | 0, f = f + Math.imul(p, st) | 0, v = v + Math.imul(p, Vt) | 0, g = g + Math.imul(St, qt) | 0, f = f + Math.imul(St, jt) | 0, f = f + Math.imul(Ut, qt) | 0, v = v + Math.imul(Ut, jt) | 0, g = g + Math.imul(Dt, Zt) | 0, f = f + Math.imul(Dt, Kt) | 0, f = f + Math.imul(Tt, Zt) | 0, v = v + Math.imul(Tt, Kt) | 0, g = g + Math.imul(Ct, Yt) | 0, f = f + Math.imul(Ct, Jt) | 0, f = f + Math.imul(Ft, Yt) | 0, v = v + Math.imul(Ft, Jt) | 0, g = g + Math.imul(pt, Xt) | 0, f = f + Math.imul(pt, Wt) | 0, f = f + Math.imul(vt, Xt) | 0, v = v + Math.imul(vt, Wt) | 0, g = g + Math.imul(ft, $t) | 0, f = f + Math.imul(ft, te) | 0, f = f + Math.imul(ht, $t) | 0, v = v + Math.imul(ht, te) | 0, g = g + Math.imul($, ee) | 0, f = f + Math.imul($, ne) | 0, f = f + Math.imul(rt, ee) | 0, v = v + Math.imul(rt, ne) | 0, g = g + Math.imul(V, re) | 0, f = f + Math.imul(V, ie) | 0, f = f + Math.imul(q, re) | 0, v = v + Math.imul(q, ie) | 0;
      var Ti = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Ti >>> 26) | 0, Ti &= 67108863, g = Math.imul(N, at), f = Math.imul(N, ot), f = f + Math.imul(F, at) | 0, v = Math.imul(F, ot), g = g + Math.imul(l, st) | 0, f = f + Math.imul(l, Vt) | 0, f = f + Math.imul(A, st) | 0, v = v + Math.imul(A, Vt) | 0, g = g + Math.imul(kt, qt) | 0, f = f + Math.imul(kt, jt) | 0, f = f + Math.imul(p, qt) | 0, v = v + Math.imul(p, jt) | 0, g = g + Math.imul(St, Zt) | 0, f = f + Math.imul(St, Kt) | 0, f = f + Math.imul(Ut, Zt) | 0, v = v + Math.imul(Ut, Kt) | 0, g = g + Math.imul(Dt, Yt) | 0, f = f + Math.imul(Dt, Jt) | 0, f = f + Math.imul(Tt, Yt) | 0, v = v + Math.imul(Tt, Jt) | 0, g = g + Math.imul(Ct, Xt) | 0, f = f + Math.imul(Ct, Wt) | 0, f = f + Math.imul(Ft, Xt) | 0, v = v + Math.imul(Ft, Wt) | 0, g = g + Math.imul(pt, $t) | 0, f = f + Math.imul(pt, te) | 0, f = f + Math.imul(vt, $t) | 0, v = v + Math.imul(vt, te) | 0, g = g + Math.imul(ft, ee) | 0, f = f + Math.imul(ft, ne) | 0, f = f + Math.imul(ht, ee) | 0, v = v + Math.imul(ht, ne) | 0, g = g + Math.imul($, re) | 0, f = f + Math.imul($, ie) | 0, f = f + Math.imul(rt, re) | 0, v = v + Math.imul(rt, ie) | 0, g = g + Math.imul(V, se) | 0, f = f + Math.imul(V, oe) | 0, f = f + Math.imul(q, se) | 0, v = v + Math.imul(q, oe) | 0;
      var Si = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Si >>> 26) | 0, Si &= 67108863, g = Math.imul(N, st), f = Math.imul(N, Vt), f = f + Math.imul(F, st) | 0, v = Math.imul(F, Vt), g = g + Math.imul(l, qt) | 0, f = f + Math.imul(l, jt) | 0, f = f + Math.imul(A, qt) | 0, v = v + Math.imul(A, jt) | 0, g = g + Math.imul(kt, Zt) | 0, f = f + Math.imul(kt, Kt) | 0, f = f + Math.imul(p, Zt) | 0, v = v + Math.imul(p, Kt) | 0, g = g + Math.imul(St, Yt) | 0, f = f + Math.imul(St, Jt) | 0, f = f + Math.imul(Ut, Yt) | 0, v = v + Math.imul(Ut, Jt) | 0, g = g + Math.imul(Dt, Xt) | 0, f = f + Math.imul(Dt, Wt) | 0, f = f + Math.imul(Tt, Xt) | 0, v = v + Math.imul(Tt, Wt) | 0, g = g + Math.imul(Ct, $t) | 0, f = f + Math.imul(Ct, te) | 0, f = f + Math.imul(Ft, $t) | 0, v = v + Math.imul(Ft, te) | 0, g = g + Math.imul(pt, ee) | 0, f = f + Math.imul(pt, ne) | 0, f = f + Math.imul(vt, ee) | 0, v = v + Math.imul(vt, ne) | 0, g = g + Math.imul(ft, re) | 0, f = f + Math.imul(ft, ie) | 0, f = f + Math.imul(ht, re) | 0, v = v + Math.imul(ht, ie) | 0, g = g + Math.imul($, se) | 0, f = f + Math.imul($, oe) | 0, f = f + Math.imul(rt, se) | 0, v = v + Math.imul(rt, oe) | 0;
      var Ui = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Ui >>> 26) | 0, Ui &= 67108863, g = Math.imul(N, qt), f = Math.imul(N, jt), f = f + Math.imul(F, qt) | 0, v = Math.imul(F, jt), g = g + Math.imul(l, Zt) | 0, f = f + Math.imul(l, Kt) | 0, f = f + Math.imul(A, Zt) | 0, v = v + Math.imul(A, Kt) | 0, g = g + Math.imul(kt, Yt) | 0, f = f + Math.imul(kt, Jt) | 0, f = f + Math.imul(p, Yt) | 0, v = v + Math.imul(p, Jt) | 0, g = g + Math.imul(St, Xt) | 0, f = f + Math.imul(St, Wt) | 0, f = f + Math.imul(Ut, Xt) | 0, v = v + Math.imul(Ut, Wt) | 0, g = g + Math.imul(Dt, $t) | 0, f = f + Math.imul(Dt, te) | 0, f = f + Math.imul(Tt, $t) | 0, v = v + Math.imul(Tt, te) | 0, g = g + Math.imul(Ct, ee) | 0, f = f + Math.imul(Ct, ne) | 0, f = f + Math.imul(Ft, ee) | 0, v = v + Math.imul(Ft, ne) | 0, g = g + Math.imul(pt, re) | 0, f = f + Math.imul(pt, ie) | 0, f = f + Math.imul(vt, re) | 0, v = v + Math.imul(vt, ie) | 0, g = g + Math.imul(ft, se) | 0, f = f + Math.imul(ft, oe) | 0, f = f + Math.imul(ht, se) | 0, v = v + Math.imul(ht, oe) | 0;
      var Ri = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Ri >>> 26) | 0, Ri &= 67108863, g = Math.imul(N, Zt), f = Math.imul(N, Kt), f = f + Math.imul(F, Zt) | 0, v = Math.imul(F, Kt), g = g + Math.imul(l, Yt) | 0, f = f + Math.imul(l, Jt) | 0, f = f + Math.imul(A, Yt) | 0, v = v + Math.imul(A, Jt) | 0, g = g + Math.imul(kt, Xt) | 0, f = f + Math.imul(kt, Wt) | 0, f = f + Math.imul(p, Xt) | 0, v = v + Math.imul(p, Wt) | 0, g = g + Math.imul(St, $t) | 0, f = f + Math.imul(St, te) | 0, f = f + Math.imul(Ut, $t) | 0, v = v + Math.imul(Ut, te) | 0, g = g + Math.imul(Dt, ee) | 0, f = f + Math.imul(Dt, ne) | 0, f = f + Math.imul(Tt, ee) | 0, v = v + Math.imul(Tt, ne) | 0, g = g + Math.imul(Ct, re) | 0, f = f + Math.imul(Ct, ie) | 0, f = f + Math.imul(Ft, re) | 0, v = v + Math.imul(Ft, ie) | 0, g = g + Math.imul(pt, se) | 0, f = f + Math.imul(pt, oe) | 0, f = f + Math.imul(vt, se) | 0, v = v + Math.imul(vt, oe) | 0;
      var Ni = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Ni >>> 26) | 0, Ni &= 67108863, g = Math.imul(N, Yt), f = Math.imul(N, Jt), f = f + Math.imul(F, Yt) | 0, v = Math.imul(F, Jt), g = g + Math.imul(l, Xt) | 0, f = f + Math.imul(l, Wt) | 0, f = f + Math.imul(A, Xt) | 0, v = v + Math.imul(A, Wt) | 0, g = g + Math.imul(kt, $t) | 0, f = f + Math.imul(kt, te) | 0, f = f + Math.imul(p, $t) | 0, v = v + Math.imul(p, te) | 0, g = g + Math.imul(St, ee) | 0, f = f + Math.imul(St, ne) | 0, f = f + Math.imul(Ut, ee) | 0, v = v + Math.imul(Ut, ne) | 0, g = g + Math.imul(Dt, re) | 0, f = f + Math.imul(Dt, ie) | 0, f = f + Math.imul(Tt, re) | 0, v = v + Math.imul(Tt, ie) | 0, g = g + Math.imul(Ct, se) | 0, f = f + Math.imul(Ct, oe) | 0, f = f + Math.imul(Ft, se) | 0, v = v + Math.imul(Ft, oe) | 0;
      var Di = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Di >>> 26) | 0, Di &= 67108863, g = Math.imul(N, Xt), f = Math.imul(N, Wt), f = f + Math.imul(F, Xt) | 0, v = Math.imul(F, Wt), g = g + Math.imul(l, $t) | 0, f = f + Math.imul(l, te) | 0, f = f + Math.imul(A, $t) | 0, v = v + Math.imul(A, te) | 0, g = g + Math.imul(kt, ee) | 0, f = f + Math.imul(kt, ne) | 0, f = f + Math.imul(p, ee) | 0, v = v + Math.imul(p, ne) | 0, g = g + Math.imul(St, re) | 0, f = f + Math.imul(St, ie) | 0, f = f + Math.imul(Ut, re) | 0, v = v + Math.imul(Ut, ie) | 0, g = g + Math.imul(Dt, se) | 0, f = f + Math.imul(Dt, oe) | 0, f = f + Math.imul(Tt, se) | 0, v = v + Math.imul(Tt, oe) | 0;
      var ki = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (ki >>> 26) | 0, ki &= 67108863, g = Math.imul(N, $t), f = Math.imul(N, te), f = f + Math.imul(F, $t) | 0, v = Math.imul(F, te), g = g + Math.imul(l, ee) | 0, f = f + Math.imul(l, ne) | 0, f = f + Math.imul(A, ee) | 0, v = v + Math.imul(A, ne) | 0, g = g + Math.imul(kt, re) | 0, f = f + Math.imul(kt, ie) | 0, f = f + Math.imul(p, re) | 0, v = v + Math.imul(p, ie) | 0, g = g + Math.imul(St, se) | 0, f = f + Math.imul(St, oe) | 0, f = f + Math.imul(Ut, se) | 0, v = v + Math.imul(Ut, oe) | 0;
      var Oi = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Oi >>> 26) | 0, Oi &= 67108863, g = Math.imul(N, ee), f = Math.imul(N, ne), f = f + Math.imul(F, ee) | 0, v = Math.imul(F, ne), g = g + Math.imul(l, re) | 0, f = f + Math.imul(l, ie) | 0, f = f + Math.imul(A, re) | 0, v = v + Math.imul(A, ie) | 0, g = g + Math.imul(kt, se) | 0, f = f + Math.imul(kt, oe) | 0, f = f + Math.imul(p, se) | 0, v = v + Math.imul(p, oe) | 0;
      var Fi = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Fi >>> 26) | 0, Fi &= 67108863, g = Math.imul(N, re), f = Math.imul(N, ie), f = f + Math.imul(F, re) | 0, v = Math.imul(F, ie), g = g + Math.imul(l, se) | 0, f = f + Math.imul(l, oe) | 0, f = f + Math.imul(A, se) | 0, v = v + Math.imul(A, oe) | 0;
      var Li = (M + g | 0) + ((f & 8191) << 13) | 0;
      M = (v + (f >>> 13) | 0) + (Li >>> 26) | 0, Li &= 67108863, g = Math.imul(N, se), f = Math.imul(N, oe), f = f + Math.imul(F, se) | 0, v = Math.imul(F, oe);
      var Pi = (M + g | 0) + ((f & 8191) << 13) | 0;
      return M = (v + (f >>> 13) | 0) + (Pi >>> 26) | 0, Pi &= 67108863, x[0] = Ai, x[1] = xi, x[2] = Ei, x[3] = vi, x[4] = Bi, x[5] = Ii, x[6] = Mi, x[7] = Ci, x[8] = Ti, x[9] = Si, x[10] = Ui, x[11] = Ri, x[12] = Ni, x[13] = Di, x[14] = ki, x[15] = Oi, x[16] = Fi, x[17] = Li, x[18] = Pi, M !== 0 && (x[19] = M, y.length++), y;
    };
    Math.imul || (G = P);
    function L(I, a, h) {
      h.negative = a.negative ^ I.negative, h.length = I.length + a.length;
      for (var y = 0, E = 0, b = 0; b < h.length - 1; b++) {
        var x = E;
        E = 0;
        for (var M = y & 67108863, g = Math.min(b, a.length - 1), f = Math.max(0, b - I.length + 1); f <= g; f++) {
          var v = b - f, Q = I.words[v] | 0, V = a.words[f] | 0, q = Q * V, nt = q & 67108863;
          x = x + (q / 67108864 | 0) | 0, nt = nt + M | 0, M = nt & 67108863, x = x + (nt >>> 26) | 0, E += x >>> 26, x &= 67108863;
        }
        h.words[b] = M, y = x, x = E;
      }
      return y !== 0 ? h.words[b] = y : h.length--, h._strip();
    }
    function Z(I, a, h) {
      return L(I, a, h);
    }
    s.prototype.mulTo = function(a, h) {
      var y, E = this.length + a.length;
      return this.length === 10 && a.length === 10 ? y = G(this, a, h) : E < 63 ? y = P(this, a, h) : E < 1024 ? y = L(this, a, h) : y = Z(this, a, h), y;
    }, s.prototype.mul = function(a) {
      var h = new s(null);
      return h.words = new Array(this.length + a.length), this.mulTo(a, h);
    }, s.prototype.mulf = function(a) {
      var h = new s(null);
      return h.words = new Array(this.length + a.length), Z(this, a, h);
    }, s.prototype.imul = function(a) {
      return this.clone().mulTo(a, this);
    }, s.prototype.imuln = function(a) {
      var h = a < 0;
      h && (a = -a), r(typeof a == "number"), r(a < 67108864);
      for (var y = 0, E = 0; E < this.length; E++) {
        var b = (this.words[E] | 0) * a, x = (b & 67108863) + (y & 67108863);
        y >>= 26, y += b / 67108864 | 0, y += x >>> 26, this.words[E] = x & 67108863;
      }
      return y !== 0 && (this.words[E] = y, this.length++), h ? this.ineg() : this;
    }, s.prototype.muln = function(a) {
      return this.clone().imuln(a);
    }, s.prototype.sqr = function() {
      return this.mul(this);
    }, s.prototype.isqr = function() {
      return this.imul(this.clone());
    }, s.prototype.pow = function(a) {
      var h = R(a);
      if (h.length === 0)
        return new s(1);
      for (var y = this, E = 0; E < h.length && h[E] === 0; E++, y = y.sqr())
        ;
      if (++E < h.length)
        for (var b = y.sqr(); E < h.length; E++, b = b.sqr())
          h[E] !== 0 && (y = y.mul(b));
      return y;
    }, s.prototype.iushln = function(a) {
      r(typeof a == "number" && a >= 0);
      var h = a % 26, y = (a - h) / 26, E = 67108863 >>> 26 - h << 26 - h, b;
      if (h !== 0) {
        var x = 0;
        for (b = 0; b < this.length; b++) {
          var M = this.words[b] & E, g = (this.words[b] | 0) - M << h;
          this.words[b] = g | x, x = M >>> 26 - h;
        }
        x && (this.words[b] = x, this.length++);
      }
      if (y !== 0) {
        for (b = this.length - 1; b >= 0; b--)
          this.words[b + y] = this.words[b];
        for (b = 0; b < y; b++)
          this.words[b] = 0;
        this.length += y;
      }
      return this._strip();
    }, s.prototype.ishln = function(a) {
      return r(this.negative === 0), this.iushln(a);
    }, s.prototype.iushrn = function(a, h, y) {
      r(typeof a == "number" && a >= 0);
      var E;
      h ? E = (h - h % 26) / 26 : E = 0;
      var b = a % 26, x = Math.min((a - b) / 26, this.length), M = 67108863 ^ 67108863 >>> b << b, g = y;
      if (E -= x, E = Math.max(0, E), g) {
        for (var f = 0; f < x; f++)
          g.words[f] = this.words[f];
        g.length = x;
      }
      if (x !== 0)
        if (this.length > x)
          for (this.length -= x, f = 0; f < this.length; f++)
            this.words[f] = this.words[f + x];
        else
          this.words[0] = 0, this.length = 1;
      var v = 0;
      for (f = this.length - 1; f >= 0 && (v !== 0 || f >= E); f--) {
        var Q = this.words[f] | 0;
        this.words[f] = v << 26 - b | Q >>> b, v = Q & M;
      }
      return g && v !== 0 && (g.words[g.length++] = v), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, s.prototype.ishrn = function(a, h, y) {
      return r(this.negative === 0), this.iushrn(a, h, y);
    }, s.prototype.shln = function(a) {
      return this.clone().ishln(a);
    }, s.prototype.ushln = function(a) {
      return this.clone().iushln(a);
    }, s.prototype.shrn = function(a) {
      return this.clone().ishrn(a);
    }, s.prototype.ushrn = function(a) {
      return this.clone().iushrn(a);
    }, s.prototype.testn = function(a) {
      r(typeof a == "number" && a >= 0);
      var h = a % 26, y = (a - h) / 26, E = 1 << h;
      if (this.length <= y)
        return !1;
      var b = this.words[y];
      return !!(b & E);
    }, s.prototype.imaskn = function(a) {
      r(typeof a == "number" && a >= 0);
      var h = a % 26, y = (a - h) / 26;
      if (r(this.negative === 0, "imaskn works only with positive numbers"), this.length <= y)
        return this;
      if (h !== 0 && y++, this.length = Math.min(y, this.length), h !== 0) {
        var E = 67108863 ^ 67108863 >>> h << h;
        this.words[this.length - 1] &= E;
      }
      return this._strip();
    }, s.prototype.maskn = function(a) {
      return this.clone().imaskn(a);
    }, s.prototype.iaddn = function(a) {
      return r(typeof a == "number"), r(a < 67108864), a < 0 ? this.isubn(-a) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= a ? (this.words[0] = a - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(a), this.negative = 1, this) : this._iaddn(a);
    }, s.prototype._iaddn = function(a) {
      this.words[0] += a;
      for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
        this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
      return this.length = Math.max(this.length, h + 1), this;
    }, s.prototype.isubn = function(a) {
      if (r(typeof a == "number"), r(a < 67108864), a < 0)
        return this.iaddn(-a);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(a), this.negative = 1, this;
      if (this.words[0] -= a, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var h = 0; h < this.length && this.words[h] < 0; h++)
          this.words[h] += 67108864, this.words[h + 1] -= 1;
      return this._strip();
    }, s.prototype.addn = function(a) {
      return this.clone().iaddn(a);
    }, s.prototype.subn = function(a) {
      return this.clone().isubn(a);
    }, s.prototype.iabs = function() {
      return this.negative = 0, this;
    }, s.prototype.abs = function() {
      return this.clone().iabs();
    }, s.prototype._ishlnsubmul = function(a, h, y) {
      var E = a.length + y, b;
      this._expand(E);
      var x, M = 0;
      for (b = 0; b < a.length; b++) {
        x = (this.words[b + y] | 0) + M;
        var g = (a.words[b] | 0) * h;
        x -= g & 67108863, M = (x >> 26) - (g / 67108864 | 0), this.words[b + y] = x & 67108863;
      }
      for (; b < this.length - y; b++)
        x = (this.words[b + y] | 0) + M, M = x >> 26, this.words[b + y] = x & 67108863;
      if (M === 0)
        return this._strip();
      for (r(M === -1), M = 0, b = 0; b < this.length; b++)
        x = -(this.words[b] | 0) + M, M = x >> 26, this.words[b] = x & 67108863;
      return this.negative = 1, this._strip();
    }, s.prototype._wordDiv = function(a, h) {
      var y = this.length - a.length, E = this.clone(), b = a, x = b.words[b.length - 1] | 0, M = this._countBits(x);
      y = 26 - M, y !== 0 && (b = b.ushln(y), E.iushln(y), x = b.words[b.length - 1] | 0);
      var g = E.length - b.length, f;
      if (h !== "mod") {
        f = new s(null), f.length = g + 1, f.words = new Array(f.length);
        for (var v = 0; v < f.length; v++)
          f.words[v] = 0;
      }
      var Q = E.clone()._ishlnsubmul(b, 1, g);
      Q.negative === 0 && (E = Q, f && (f.words[g] = 1));
      for (var V = g - 1; V >= 0; V--) {
        var q = (E.words[b.length + V] | 0) * 67108864 + (E.words[b.length + V - 1] | 0);
        for (q = Math.min(q / x | 0, 67108863), E._ishlnsubmul(b, q, V); E.negative !== 0; )
          q--, E.negative = 0, E._ishlnsubmul(b, 1, V), E.isZero() || (E.negative ^= 1);
        f && (f.words[V] = q);
      }
      return f && f._strip(), E._strip(), h !== "div" && y !== 0 && E.iushrn(y), {
        div: f || null,
        mod: E
      };
    }, s.prototype.divmod = function(a, h, y) {
      if (r(!a.isZero()), this.isZero())
        return {
          div: new s(0),
          mod: new s(0)
        };
      var E, b, x;
      return this.negative !== 0 && a.negative === 0 ? (x = this.neg().divmod(a, h), h !== "mod" && (E = x.div.neg()), h !== "div" && (b = x.mod.neg(), y && b.negative !== 0 && b.iadd(a)), {
        div: E,
        mod: b
      }) : this.negative === 0 && a.negative !== 0 ? (x = this.divmod(a.neg(), h), h !== "mod" && (E = x.div.neg()), {
        div: E,
        mod: x.mod
      }) : this.negative & a.negative ? (x = this.neg().divmod(a.neg(), h), h !== "div" && (b = x.mod.neg(), y && b.negative !== 0 && b.isub(a)), {
        div: x.div,
        mod: b
      }) : a.length > this.length || this.cmp(a) < 0 ? {
        div: new s(0),
        mod: this
      } : a.length === 1 ? h === "div" ? {
        div: this.divn(a.words[0]),
        mod: null
      } : h === "mod" ? {
        div: null,
        mod: new s(this.modrn(a.words[0]))
      } : {
        div: this.divn(a.words[0]),
        mod: new s(this.modrn(a.words[0]))
      } : this._wordDiv(a, h);
    }, s.prototype.div = function(a) {
      return this.divmod(a, "div", !1).div;
    }, s.prototype.mod = function(a) {
      return this.divmod(a, "mod", !1).mod;
    }, s.prototype.umod = function(a) {
      return this.divmod(a, "mod", !0).mod;
    }, s.prototype.divRound = function(a) {
      var h = this.divmod(a);
      if (h.mod.isZero())
        return h.div;
      var y = h.div.negative !== 0 ? h.mod.isub(a) : h.mod, E = a.ushrn(1), b = a.andln(1), x = y.cmp(E);
      return x < 0 || b === 1 && x === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
    }, s.prototype.modrn = function(a) {
      var h = a < 0;
      h && (a = -a), r(a <= 67108863);
      for (var y = (1 << 26) % a, E = 0, b = this.length - 1; b >= 0; b--)
        E = (y * E + (this.words[b] | 0)) % a;
      return h ? -E : E;
    }, s.prototype.modn = function(a) {
      return this.modrn(a);
    }, s.prototype.idivn = function(a) {
      var h = a < 0;
      h && (a = -a), r(a <= 67108863);
      for (var y = 0, E = this.length - 1; E >= 0; E--) {
        var b = (this.words[E] | 0) + y * 67108864;
        this.words[E] = b / a | 0, y = b % a;
      }
      return this._strip(), h ? this.ineg() : this;
    }, s.prototype.divn = function(a) {
      return this.clone().idivn(a);
    }, s.prototype.egcd = function(a) {
      r(a.negative === 0), r(!a.isZero());
      var h = this, y = a.clone();
      h.negative !== 0 ? h = h.umod(a) : h = h.clone();
      for (var E = new s(1), b = new s(0), x = new s(0), M = new s(1), g = 0; h.isEven() && y.isEven(); )
        h.iushrn(1), y.iushrn(1), ++g;
      for (var f = y.clone(), v = h.clone(); !h.isZero(); ) {
        for (var Q = 0, V = 1; !(h.words[0] & V) && Q < 26; ++Q, V <<= 1)
          ;
        if (Q > 0)
          for (h.iushrn(Q); Q-- > 0; )
            (E.isOdd() || b.isOdd()) && (E.iadd(f), b.isub(v)), E.iushrn(1), b.iushrn(1);
        for (var q = 0, nt = 1; !(y.words[0] & nt) && q < 26; ++q, nt <<= 1)
          ;
        if (q > 0)
          for (y.iushrn(q); q-- > 0; )
            (x.isOdd() || M.isOdd()) && (x.iadd(f), M.isub(v)), x.iushrn(1), M.iushrn(1);
        h.cmp(y) >= 0 ? (h.isub(y), E.isub(x), b.isub(M)) : (y.isub(h), x.isub(E), M.isub(b));
      }
      return {
        a: x,
        b: M,
        gcd: y.iushln(g)
      };
    }, s.prototype._invmp = function(a) {
      r(a.negative === 0), r(!a.isZero());
      var h = this, y = a.clone();
      h.negative !== 0 ? h = h.umod(a) : h = h.clone();
      for (var E = new s(1), b = new s(0), x = y.clone(); h.cmpn(1) > 0 && y.cmpn(1) > 0; ) {
        for (var M = 0, g = 1; !(h.words[0] & g) && M < 26; ++M, g <<= 1)
          ;
        if (M > 0)
          for (h.iushrn(M); M-- > 0; )
            E.isOdd() && E.iadd(x), E.iushrn(1);
        for (var f = 0, v = 1; !(y.words[0] & v) && f < 26; ++f, v <<= 1)
          ;
        if (f > 0)
          for (y.iushrn(f); f-- > 0; )
            b.isOdd() && b.iadd(x), b.iushrn(1);
        h.cmp(y) >= 0 ? (h.isub(y), E.isub(b)) : (y.isub(h), b.isub(E));
      }
      var Q;
      return h.cmpn(1) === 0 ? Q = E : Q = b, Q.cmpn(0) < 0 && Q.iadd(a), Q;
    }, s.prototype.gcd = function(a) {
      if (this.isZero())
        return a.abs();
      if (a.isZero())
        return this.abs();
      var h = this.clone(), y = a.clone();
      h.negative = 0, y.negative = 0;
      for (var E = 0; h.isEven() && y.isEven(); E++)
        h.iushrn(1), y.iushrn(1);
      do {
        for (; h.isEven(); )
          h.iushrn(1);
        for (; y.isEven(); )
          y.iushrn(1);
        var b = h.cmp(y);
        if (b < 0) {
          var x = h;
          h = y, y = x;
        } else if (b === 0 || y.cmpn(1) === 0)
          break;
        h.isub(y);
      } while (!0);
      return y.iushln(E);
    }, s.prototype.invm = function(a) {
      return this.egcd(a).a.umod(a);
    }, s.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, s.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, s.prototype.andln = function(a) {
      return this.words[0] & a;
    }, s.prototype.bincn = function(a) {
      r(typeof a == "number");
      var h = a % 26, y = (a - h) / 26, E = 1 << h;
      if (this.length <= y)
        return this._expand(y + 1), this.words[y] |= E, this;
      for (var b = E, x = y; b !== 0 && x < this.length; x++) {
        var M = this.words[x] | 0;
        M += b, b = M >>> 26, M &= 67108863, this.words[x] = M;
      }
      return b !== 0 && (this.words[x] = b, this.length++), this;
    }, s.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, s.prototype.cmpn = function(a) {
      var h = a < 0;
      if (this.negative !== 0 && !h)
        return -1;
      if (this.negative === 0 && h)
        return 1;
      this._strip();
      var y;
      if (this.length > 1)
        y = 1;
      else {
        h && (a = -a), r(a <= 67108863, "Number is too big");
        var E = this.words[0] | 0;
        y = E === a ? 0 : E < a ? -1 : 1;
      }
      return this.negative !== 0 ? -y | 0 : y;
    }, s.prototype.cmp = function(a) {
      if (this.negative !== 0 && a.negative === 0)
        return -1;
      if (this.negative === 0 && a.negative !== 0)
        return 1;
      var h = this.ucmp(a);
      return this.negative !== 0 ? -h | 0 : h;
    }, s.prototype.ucmp = function(a) {
      if (this.length > a.length)
        return 1;
      if (this.length < a.length)
        return -1;
      for (var h = 0, y = this.length - 1; y >= 0; y--) {
        var E = this.words[y] | 0, b = a.words[y] | 0;
        if (E !== b) {
          E < b ? h = -1 : E > b && (h = 1);
          break;
        }
      }
      return h;
    }, s.prototype.gtn = function(a) {
      return this.cmpn(a) === 1;
    }, s.prototype.gt = function(a) {
      return this.cmp(a) === 1;
    }, s.prototype.gten = function(a) {
      return this.cmpn(a) >= 0;
    }, s.prototype.gte = function(a) {
      return this.cmp(a) >= 0;
    }, s.prototype.ltn = function(a) {
      return this.cmpn(a) === -1;
    }, s.prototype.lt = function(a) {
      return this.cmp(a) === -1;
    }, s.prototype.lten = function(a) {
      return this.cmpn(a) <= 0;
    }, s.prototype.lte = function(a) {
      return this.cmp(a) <= 0;
    }, s.prototype.eqn = function(a) {
      return this.cmpn(a) === 0;
    }, s.prototype.eq = function(a) {
      return this.cmp(a) === 0;
    }, s.red = function(a) {
      return new W(a);
    }, s.prototype.toRed = function(a) {
      return r(!this.red, "Already a number in reduction context"), r(this.negative === 0, "red works only with positives"), a.convertTo(this)._forceRed(a);
    }, s.prototype.fromRed = function() {
      return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, s.prototype._forceRed = function(a) {
      return this.red = a, this;
    }, s.prototype.forceRed = function(a) {
      return r(!this.red, "Already a number in reduction context"), this._forceRed(a);
    }, s.prototype.redAdd = function(a) {
      return r(this.red, "redAdd works only with red numbers"), this.red.add(this, a);
    }, s.prototype.redIAdd = function(a) {
      return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, a);
    }, s.prototype.redSub = function(a) {
      return r(this.red, "redSub works only with red numbers"), this.red.sub(this, a);
    }, s.prototype.redISub = function(a) {
      return r(this.red, "redISub works only with red numbers"), this.red.isub(this, a);
    }, s.prototype.redShl = function(a) {
      return r(this.red, "redShl works only with red numbers"), this.red.shl(this, a);
    }, s.prototype.redMul = function(a) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.mul(this, a);
    }, s.prototype.redIMul = function(a) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.imul(this, a);
    }, s.prototype.redSqr = function() {
      return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, s.prototype.redISqr = function() {
      return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, s.prototype.redSqrt = function() {
      return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, s.prototype.redInvm = function() {
      return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, s.prototype.redNeg = function() {
      return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, s.prototype.redPow = function(a) {
      return r(this.red && !a.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, a);
    };
    var _ = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function z(I, a) {
      this.name = I, this.p = new s(a, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    z.prototype._tmp = function() {
      var a = new s(null);
      return a.words = new Array(Math.ceil(this.n / 13)), a;
    }, z.prototype.ireduce = function(a) {
      var h = a, y;
      do
        this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), y = h.bitLength();
      while (y > this.n);
      var E = y < this.n ? -1 : h.ucmp(this.p);
      return E === 0 ? (h.words[0] = 0, h.length = 1) : E > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
    }, z.prototype.split = function(a, h) {
      a.iushrn(this.n, 0, h);
    }, z.prototype.imulK = function(a) {
      return a.imul(this.k);
    };
    function K() {
      z.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    i(K, z), K.prototype.split = function(a, h) {
      for (var y = 4194303, E = Math.min(a.length, 9), b = 0; b < E; b++)
        h.words[b] = a.words[b];
      if (h.length = E, a.length <= 9) {
        a.words[0] = 0, a.length = 1;
        return;
      }
      var x = a.words[9];
      for (h.words[h.length++] = x & y, b = 10; b < a.length; b++) {
        var M = a.words[b] | 0;
        a.words[b - 10] = (M & y) << 4 | x >>> 22, x = M;
      }
      x >>>= 22, a.words[b - 10] = x, x === 0 && a.length > 10 ? a.length -= 10 : a.length -= 9;
    }, K.prototype.imulK = function(a) {
      a.words[a.length] = 0, a.words[a.length + 1] = 0, a.length += 2;
      for (var h = 0, y = 0; y < a.length; y++) {
        var E = a.words[y] | 0;
        h += E * 977, a.words[y] = h & 67108863, h = E * 64 + (h / 67108864 | 0);
      }
      return a.words[a.length - 1] === 0 && (a.length--, a.words[a.length - 1] === 0 && a.length--), a;
    };
    function Y() {
      z.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    i(Y, z);
    function dt() {
      z.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    i(dt, z);
    function ut() {
      z.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    i(ut, z), ut.prototype.imulK = function(a) {
      for (var h = 0, y = 0; y < a.length; y++) {
        var E = (a.words[y] | 0) * 19 + h, b = E & 67108863;
        E >>>= 26, a.words[y] = b, h = E;
      }
      return h !== 0 && (a.words[a.length++] = h), a;
    }, s._prime = function(a) {
      if (_[a])
        return _[a];
      var h;
      if (a === "k256")
        h = new K();
      else if (a === "p224")
        h = new Y();
      else if (a === "p192")
        h = new dt();
      else if (a === "p25519")
        h = new ut();
      else
        throw new Error("Unknown prime " + a);
      return _[a] = h, h;
    };
    function W(I) {
      if (typeof I == "string") {
        var a = s._prime(I);
        this.m = a.p, this.prime = a;
      } else
        r(I.gtn(1), "modulus must be greater than 1"), this.m = I, this.prime = null;
    }
    W.prototype._verify1 = function(a) {
      r(a.negative === 0, "red works only with positives"), r(a.red, "red works only with red numbers");
    }, W.prototype._verify2 = function(a, h) {
      r((a.negative | h.negative) === 0, "red works only with positives"), r(
        a.red && a.red === h.red,
        "red works only with red numbers"
      );
    }, W.prototype.imod = function(a) {
      return this.prime ? this.prime.ireduce(a)._forceRed(this) : (w(a, a.umod(this.m)._forceRed(this)), a);
    }, W.prototype.neg = function(a) {
      return a.isZero() ? a.clone() : this.m.sub(a)._forceRed(this);
    }, W.prototype.add = function(a, h) {
      this._verify2(a, h);
      var y = a.add(h);
      return y.cmp(this.m) >= 0 && y.isub(this.m), y._forceRed(this);
    }, W.prototype.iadd = function(a, h) {
      this._verify2(a, h);
      var y = a.iadd(h);
      return y.cmp(this.m) >= 0 && y.isub(this.m), y;
    }, W.prototype.sub = function(a, h) {
      this._verify2(a, h);
      var y = a.sub(h);
      return y.cmpn(0) < 0 && y.iadd(this.m), y._forceRed(this);
    }, W.prototype.isub = function(a, h) {
      this._verify2(a, h);
      var y = a.isub(h);
      return y.cmpn(0) < 0 && y.iadd(this.m), y;
    }, W.prototype.shl = function(a, h) {
      return this._verify1(a), this.imod(a.ushln(h));
    }, W.prototype.imul = function(a, h) {
      return this._verify2(a, h), this.imod(a.imul(h));
    }, W.prototype.mul = function(a, h) {
      return this._verify2(a, h), this.imod(a.mul(h));
    }, W.prototype.isqr = function(a) {
      return this.imul(a, a.clone());
    }, W.prototype.sqr = function(a) {
      return this.mul(a, a);
    }, W.prototype.sqrt = function(a) {
      if (a.isZero())
        return a.clone();
      var h = this.m.andln(3);
      if (r(h % 2 === 1), h === 3) {
        var y = this.m.add(new s(1)).iushrn(2);
        return this.pow(a, y);
      }
      for (var E = this.m.subn(1), b = 0; !E.isZero() && E.andln(1) === 0; )
        b++, E.iushrn(1);
      r(!E.isZero());
      var x = new s(1).toRed(this), M = x.redNeg(), g = this.m.subn(1).iushrn(1), f = this.m.bitLength();
      for (f = new s(2 * f * f).toRed(this); this.pow(f, g).cmp(M) !== 0; )
        f.redIAdd(M);
      for (var v = this.pow(f, E), Q = this.pow(a, E.addn(1).iushrn(1)), V = this.pow(a, E), q = b; V.cmp(x) !== 0; ) {
        for (var nt = V, $ = 0; nt.cmp(x) !== 0; $++)
          nt = nt.redSqr();
        r($ < q);
        var rt = this.pow(v, new s(1).iushln(q - $ - 1));
        Q = Q.redMul(rt), v = rt.redSqr(), V = V.redMul(v), q = $;
      }
      return Q;
    }, W.prototype.invm = function(a) {
      var h = a._invmp(this.m);
      return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
    }, W.prototype.pow = function(a, h) {
      if (h.isZero())
        return new s(1).toRed(this);
      if (h.cmpn(1) === 0)
        return a.clone();
      var y = 4, E = new Array(1 << y);
      E[0] = new s(1).toRed(this), E[1] = a;
      for (var b = 2; b < E.length; b++)
        E[b] = this.mul(E[b - 1], a);
      var x = E[0], M = 0, g = 0, f = h.bitLength() % 26;
      for (f === 0 && (f = 26), b = h.length - 1; b >= 0; b--) {
        for (var v = h.words[b], Q = f - 1; Q >= 0; Q--) {
          var V = v >> Q & 1;
          if (x !== E[0] && (x = this.sqr(x)), V === 0 && M === 0) {
            g = 0;
            continue;
          }
          M <<= 1, M |= V, g++, !(g !== y && (b !== 0 || Q !== 0)) && (x = this.mul(x, E[M]), g = 0, M = 0);
        }
        f = 26;
      }
      return x;
    }, W.prototype.convertTo = function(a) {
      var h = a.umod(this.m);
      return h === a ? h.clone() : h;
    }, W.prototype.convertFrom = function(a) {
      var h = a.clone();
      return h.red = null, h;
    }, s.mont = function(a) {
      return new Et(a);
    };
    function Et(I) {
      W.call(this, I), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    i(Et, W), Et.prototype.convertTo = function(a) {
      return this.imod(a.ushln(this.shift));
    }, Et.prototype.convertFrom = function(a) {
      var h = this.imod(a.mul(this.rinv));
      return h.red = null, h;
    }, Et.prototype.imul = function(a, h) {
      if (a.isZero() || h.isZero())
        return a.words[0] = 0, a.length = 1, a;
      var y = a.imul(h), E = y.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), b = y.isub(E).iushrn(this.shift), x = b;
      return b.cmp(this.m) >= 0 ? x = b.isub(this.m) : b.cmpn(0) < 0 && (x = b.iadd(this.m)), x._forceRed(this);
    }, Et.prototype.mul = function(a, h) {
      if (a.isZero() || h.isZero())
        return new s(0)._forceRed(this);
      var y = a.mul(h), E = y.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), b = y.isub(E).iushrn(this.shift), x = b;
      return b.cmp(this.m) >= 0 ? x = b.isub(this.m) : b.cmpn(0) < 0 && (x = b.iadd(this.m)), x._forceRed(this);
    }, Et.prototype.invm = function(a) {
      var h = this.imod(a._invmp(this.m).mul(this.r2));
      return h._forceRed(this);
    };
  })(e, He);
})(qs);
var gu = qs.exports;
const ws = /* @__PURE__ */ mu(gu), fh = "bignumber/5.7.0";
var bs = ws.BN;
const tn = new Bt(fh), Ji = {}, Ko = 9007199254740991;
let Yo = !1;
class yt {
  constructor(t, n) {
    t !== Ji && tn.throwError("cannot call constructor directly; use BigNumber.from", Bt.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = n, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(t) {
    return Be(mt(this).fromTwos(t));
  }
  toTwos(t) {
    return Be(mt(this).toTwos(t));
  }
  abs() {
    return this._hex[0] === "-" ? yt.from(this._hex.substring(1)) : this;
  }
  add(t) {
    return Be(mt(this).add(mt(t)));
  }
  sub(t) {
    return Be(mt(this).sub(mt(t)));
  }
  div(t) {
    return yt.from(t).isZero() && Re("division-by-zero", "div"), Be(mt(this).div(mt(t)));
  }
  mul(t) {
    return Be(mt(this).mul(mt(t)));
  }
  mod(t) {
    const n = mt(t);
    return n.isNeg() && Re("division-by-zero", "mod"), Be(mt(this).umod(n));
  }
  pow(t) {
    const n = mt(t);
    return n.isNeg() && Re("negative-power", "pow"), Be(mt(this).pow(n));
  }
  and(t) {
    const n = mt(t);
    return (this.isNegative() || n.isNeg()) && Re("unbound-bitwise-result", "and"), Be(mt(this).and(n));
  }
  or(t) {
    const n = mt(t);
    return (this.isNegative() || n.isNeg()) && Re("unbound-bitwise-result", "or"), Be(mt(this).or(n));
  }
  xor(t) {
    const n = mt(t);
    return (this.isNegative() || n.isNeg()) && Re("unbound-bitwise-result", "xor"), Be(mt(this).xor(n));
  }
  mask(t) {
    return (this.isNegative() || t < 0) && Re("negative-width", "mask"), Be(mt(this).maskn(t));
  }
  shl(t) {
    return (this.isNegative() || t < 0) && Re("negative-width", "shl"), Be(mt(this).shln(t));
  }
  shr(t) {
    return (this.isNegative() || t < 0) && Re("negative-width", "shr"), Be(mt(this).shrn(t));
  }
  eq(t) {
    return mt(this).eq(mt(t));
  }
  lt(t) {
    return mt(this).lt(mt(t));
  }
  lte(t) {
    return mt(this).lte(mt(t));
  }
  gt(t) {
    return mt(this).gt(mt(t));
  }
  gte(t) {
    return mt(this).gte(mt(t));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return mt(this).isZero();
  }
  toNumber() {
    try {
      return mt(this).toNumber();
    } catch {
      Re("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return tn.throwError("this platform does not support BigInt", Bt.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? Yo || (Yo = !0, tn.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? tn.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Bt.errors.UNEXPECTED_ARGUMENT, {}) : tn.throwError("BigNumber.toString does not accept parameters", Bt.errors.UNEXPECTED_ARGUMENT, {})), mt(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(t) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(t) {
    if (t instanceof yt)
      return t;
    if (typeof t == "string")
      return t.match(/^-?0x[0-9a-f]+$/i) ? new yt(Ji, Er(t)) : t.match(/^-?[0-9]+$/) ? new yt(Ji, Er(new bs(t))) : tn.throwArgumentError("invalid BigNumber string", "value", t);
    if (typeof t == "number")
      return t % 1 && Re("underflow", "BigNumber.from", t), (t >= Ko || t <= -Ko) && Re("overflow", "BigNumber.from", t), yt.from(String(t));
    const n = t;
    if (typeof n == "bigint")
      return yt.from(n.toString());
    if (Qs(n))
      return yt.from(vn(n));
    if (n)
      if (n.toHexString) {
        const r = n.toHexString();
        if (typeof r == "string")
          return yt.from(r);
      } else {
        let r = n._hex;
        if (r == null && n.type === "BigNumber" && (r = n.hex), typeof r == "string" && (xr(r) || r[0] === "-" && xr(r.substring(1))))
          return yt.from(r);
      }
    return tn.throwArgumentError("invalid BigNumber value", "value", t);
  }
  static isBigNumber(t) {
    return !!(t && t._isBigNumber);
  }
}
function Er(e) {
  if (typeof e != "string")
    return Er(e.toString(16));
  if (e[0] === "-")
    return e = e.substring(1), e[0] === "-" && tn.throwArgumentError("invalid hex", "value", e), e = Er(e), e === "0x00" ? e : "-" + e;
  if (e.substring(0, 2) !== "0x" && (e = "0x" + e), e === "0x")
    return "0x00";
  for (e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && e.substring(0, 4) === "0x00"; )
    e = "0x" + e.substring(4);
  return e;
}
function Be(e) {
  return yt.from(Er(e));
}
function mt(e) {
  const t = yt.from(e).toHexString();
  return t[0] === "-" ? new bs("-" + t.substring(3), 16) : new bs(t.substring(2), 16);
}
function Re(e, t, n) {
  const r = { fault: e, operation: t };
  return n != null && (r.value = n), tn.throwError(e, Bt.errors.NUMERIC_FAULT, r);
}
var _t = {}, ci = {};
ci.byteLength = dh;
ci.toByteArray = yh;
ci.fromByteArray = wh;
var Ze = [], Ne = [], lh = typeof Uint8Array < "u" ? Uint8Array : Array, Xi = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var _n = 0, hh = Xi.length; _n < hh; ++_n)
  Ze[_n] = Xi[_n], Ne[Xi.charCodeAt(_n)] = _n;
Ne["-".charCodeAt(0)] = 62;
Ne["_".charCodeAt(0)] = 63;
function wu(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = t);
  var r = n === t ? 0 : 4 - n % 4;
  return [n, r];
}
function dh(e) {
  var t = wu(e), n = t[0], r = t[1];
  return (n + r) * 3 / 4 - r;
}
function ph(e, t, n) {
  return (t + n) * 3 / 4 - n;
}
function yh(e) {
  var t, n = wu(e), r = n[0], i = n[1], s = new lh(ph(e, r, i)), o = 0, u = i > 0 ? r - 4 : r, d;
  for (d = 0; d < u; d += 4)
    t = Ne[e.charCodeAt(d)] << 18 | Ne[e.charCodeAt(d + 1)] << 12 | Ne[e.charCodeAt(d + 2)] << 6 | Ne[e.charCodeAt(d + 3)], s[o++] = t >> 16 & 255, s[o++] = t >> 8 & 255, s[o++] = t & 255;
  return i === 2 && (t = Ne[e.charCodeAt(d)] << 2 | Ne[e.charCodeAt(d + 1)] >> 4, s[o++] = t & 255), i === 1 && (t = Ne[e.charCodeAt(d)] << 10 | Ne[e.charCodeAt(d + 1)] << 4 | Ne[e.charCodeAt(d + 2)] >> 2, s[o++] = t >> 8 & 255, s[o++] = t & 255), s;
}
function mh(e) {
  return Ze[e >> 18 & 63] + Ze[e >> 12 & 63] + Ze[e >> 6 & 63] + Ze[e & 63];
}
function gh(e, t, n) {
  for (var r, i = [], s = t; s < n; s += 3)
    r = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (e[s + 2] & 255), i.push(mh(r));
  return i.join("");
}
function wh(e) {
  for (var t, n = e.length, r = n % 3, i = [], s = 16383, o = 0, u = n - r; o < u; o += s)
    i.push(gh(e, o, o + s > u ? u : o + s));
  return r === 1 ? (t = e[n - 1], i.push(
    Ze[t >> 2] + Ze[t << 4 & 63] + "=="
  )) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i.push(
    Ze[t >> 10] + Ze[t >> 4 & 63] + Ze[t << 2 & 63] + "="
  )), i.join("");
}
var js = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
js.read = function(e, t, n, r, i) {
  var s, o, u = i * 8 - r - 1, d = (1 << u) - 1, m = d >> 1, w = -7, B = n ? i - 1 : 0, S = n ? -1 : 1, T = e[t + B];
  for (B += S, s = T & (1 << -w) - 1, T >>= -w, w += u; w > 0; s = s * 256 + e[t + B], B += S, w -= 8)
    ;
  for (o = s & (1 << -w) - 1, s >>= -w, w += r; w > 0; o = o * 256 + e[t + B], B += S, w -= 8)
    ;
  if (s === 0)
    s = 1 - m;
  else {
    if (s === d)
      return o ? NaN : (T ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), s = s - m;
  }
  return (T ? -1 : 1) * o * Math.pow(2, s - r);
};
js.write = function(e, t, n, r, i, s) {
  var o, u, d, m = s * 8 - i - 1, w = (1 << m) - 1, B = w >> 1, S = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, T = r ? 0 : s - 1, O = r ? 1 : -1, U = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (u = isNaN(t) ? 1 : 0, o = w) : (o = Math.floor(Math.log(t) / Math.LN2), t * (d = Math.pow(2, -o)) < 1 && (o--, d *= 2), o + B >= 1 ? t += S / d : t += S * Math.pow(2, 1 - B), t * d >= 2 && (o++, d /= 2), o + B >= w ? (u = 0, o = w) : o + B >= 1 ? (u = (t * d - 1) * Math.pow(2, i), o = o + B) : (u = t * Math.pow(2, B - 1) * Math.pow(2, i), o = 0)); i >= 8; e[n + T] = u & 255, T += O, u /= 256, i -= 8)
    ;
  for (o = o << i | u, m += i; m > 0; e[n + T] = o & 255, T += O, o /= 256, m -= 8)
    ;
  e[n + T - O] |= U * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = ci, n = js, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = u, e.SlowBuffer = G, e.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  e.kMaxLength = i, u.TYPED_ARRAY_SUPPORT = s(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function s() {
    try {
      const p = new Uint8Array(1), c = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(c, Uint8Array.prototype), Object.setPrototypeOf(p, c), p.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(p) {
    if (p > i)
      throw new RangeError('The value "' + p + '" is invalid for option "size"');
    const c = new Uint8Array(p);
    return Object.setPrototypeOf(c, u.prototype), c;
  }
  function u(p, c, l) {
    if (typeof p == "number") {
      if (typeof c == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return B(p);
    }
    return d(p, c, l);
  }
  u.poolSize = 8192;
  function d(p, c, l) {
    if (typeof p == "string")
      return S(p, c);
    if (ArrayBuffer.isView(p))
      return O(p);
    if (p == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
      );
    if (ye(p, ArrayBuffer) || p && ye(p.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ye(p, SharedArrayBuffer) || p && ye(p.buffer, SharedArrayBuffer)))
      return U(p, c, l);
    if (typeof p == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const A = p.valueOf && p.valueOf();
    if (A != null && A !== p)
      return u.from(A, c, l);
    const C = R(p);
    if (C)
      return C;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof p[Symbol.toPrimitive] == "function")
      return u.from(p[Symbol.toPrimitive]("string"), c, l);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof p
    );
  }
  u.from = function(p, c, l) {
    return d(p, c, l);
  }, Object.setPrototypeOf(u.prototype, Uint8Array.prototype), Object.setPrototypeOf(u, Uint8Array);
  function m(p) {
    if (typeof p != "number")
      throw new TypeError('"size" argument must be of type number');
    if (p < 0)
      throw new RangeError('The value "' + p + '" is invalid for option "size"');
  }
  function w(p, c, l) {
    return m(p), p <= 0 ? o(p) : c !== void 0 ? typeof l == "string" ? o(p).fill(c, l) : o(p).fill(c) : o(p);
  }
  u.alloc = function(p, c, l) {
    return w(p, c, l);
  };
  function B(p) {
    return m(p), o(p < 0 ? 0 : P(p) | 0);
  }
  u.allocUnsafe = function(p) {
    return B(p);
  }, u.allocUnsafeSlow = function(p) {
    return B(p);
  };
  function S(p, c) {
    if ((typeof c != "string" || c === "") && (c = "utf8"), !u.isEncoding(c))
      throw new TypeError("Unknown encoding: " + c);
    const l = L(p, c) | 0;
    let A = o(l);
    const C = A.write(p, c);
    return C !== l && (A = A.slice(0, C)), A;
  }
  function T(p) {
    const c = p.length < 0 ? 0 : P(p.length) | 0, l = o(c);
    for (let A = 0; A < c; A += 1)
      l[A] = p[A] & 255;
    return l;
  }
  function O(p) {
    if (ye(p, Uint8Array)) {
      const c = new Uint8Array(p);
      return U(c.buffer, c.byteOffset, c.byteLength);
    }
    return T(p);
  }
  function U(p, c, l) {
    if (c < 0 || p.byteLength < c)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (p.byteLength < c + (l || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let A;
    return c === void 0 && l === void 0 ? A = new Uint8Array(p) : l === void 0 ? A = new Uint8Array(p, c) : A = new Uint8Array(p, c, l), Object.setPrototypeOf(A, u.prototype), A;
  }
  function R(p) {
    if (u.isBuffer(p)) {
      const c = P(p.length) | 0, l = o(c);
      return l.length === 0 || p.copy(l, 0, 0, c), l;
    }
    if (p.length !== void 0)
      return typeof p.length != "number" || St(p.length) ? o(0) : T(p);
    if (p.type === "Buffer" && Array.isArray(p.data))
      return T(p.data);
  }
  function P(p) {
    if (p >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return p | 0;
  }
  function G(p) {
    return +p != p && (p = 0), u.alloc(+p);
  }
  u.isBuffer = function(c) {
    return c != null && c._isBuffer === !0 && c !== u.prototype;
  }, u.compare = function(c, l) {
    if (ye(c, Uint8Array) && (c = u.from(c, c.offset, c.byteLength)), ye(l, Uint8Array) && (l = u.from(l, l.offset, l.byteLength)), !u.isBuffer(c) || !u.isBuffer(l))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (c === l)
      return 0;
    let A = c.length, C = l.length;
    for (let N = 0, F = Math.min(A, C); N < F; ++N)
      if (c[N] !== l[N]) {
        A = c[N], C = l[N];
        break;
      }
    return A < C ? -1 : C < A ? 1 : 0;
  }, u.isEncoding = function(c) {
    switch (String(c).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(c, l) {
    if (!Array.isArray(c))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (c.length === 0)
      return u.alloc(0);
    let A;
    if (l === void 0)
      for (l = 0, A = 0; A < c.length; ++A)
        l += c[A].length;
    const C = u.allocUnsafe(l);
    let N = 0;
    for (A = 0; A < c.length; ++A) {
      let F = c[A];
      if (ye(F, Uint8Array))
        N + F.length > C.length ? (u.isBuffer(F) || (F = u.from(F)), F.copy(C, N)) : Uint8Array.prototype.set.call(
          C,
          F,
          N
        );
      else if (u.isBuffer(F))
        F.copy(C, N);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      N += F.length;
    }
    return C;
  };
  function L(p, c) {
    if (u.isBuffer(p))
      return p.length;
    if (ArrayBuffer.isView(p) || ye(p, ArrayBuffer))
      return p.byteLength;
    if (typeof p != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof p
      );
    const l = p.length, A = arguments.length > 2 && arguments[2] === !0;
    if (!A && l === 0)
      return 0;
    let C = !1;
    for (; ; )
      switch (c) {
        case "ascii":
        case "latin1":
        case "binary":
          return l;
        case "utf8":
        case "utf-8":
          return Ct(p).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return l * 2;
        case "hex":
          return l >>> 1;
        case "base64":
          return Dt(p).length;
        default:
          if (C)
            return A ? -1 : Ct(p).length;
          c = ("" + c).toLowerCase(), C = !0;
      }
  }
  u.byteLength = L;
  function Z(p, c, l) {
    let A = !1;
    if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((l === void 0 || l > this.length) && (l = this.length), l <= 0) || (l >>>= 0, c >>>= 0, l <= c))
      return "";
    for (p || (p = "utf8"); ; )
      switch (p) {
        case "hex":
          return x(this, c, l);
        case "utf8":
        case "utf-8":
          return a(this, c, l);
        case "ascii":
          return E(this, c, l);
        case "latin1":
        case "binary":
          return b(this, c, l);
        case "base64":
          return I(this, c, l);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return M(this, c, l);
        default:
          if (A)
            throw new TypeError("Unknown encoding: " + p);
          p = (p + "").toLowerCase(), A = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function _(p, c, l) {
    const A = p[c];
    p[c] = p[l], p[l] = A;
  }
  u.prototype.swap16 = function() {
    const c = this.length;
    if (c % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let l = 0; l < c; l += 2)
      _(this, l, l + 1);
    return this;
  }, u.prototype.swap32 = function() {
    const c = this.length;
    if (c % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let l = 0; l < c; l += 4)
      _(this, l, l + 3), _(this, l + 1, l + 2);
    return this;
  }, u.prototype.swap64 = function() {
    const c = this.length;
    if (c % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let l = 0; l < c; l += 8)
      _(this, l, l + 7), _(this, l + 1, l + 6), _(this, l + 2, l + 5), _(this, l + 3, l + 4);
    return this;
  }, u.prototype.toString = function() {
    const c = this.length;
    return c === 0 ? "" : arguments.length === 0 ? a(this, 0, c) : Z.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(c) {
    if (!u.isBuffer(c))
      throw new TypeError("Argument must be a Buffer");
    return this === c ? !0 : u.compare(this, c) === 0;
  }, u.prototype.inspect = function() {
    let c = "";
    const l = e.INSPECT_MAX_BYTES;
    return c = this.toString("hex", 0, l).replace(/(.{2})/g, "$1 ").trim(), this.length > l && (c += " ... "), "<Buffer " + c + ">";
  }, r && (u.prototype[r] = u.prototype.inspect), u.prototype.compare = function(c, l, A, C, N) {
    if (ye(c, Uint8Array) && (c = u.from(c, c.offset, c.byteLength)), !u.isBuffer(c))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof c
      );
    if (l === void 0 && (l = 0), A === void 0 && (A = c ? c.length : 0), C === void 0 && (C = 0), N === void 0 && (N = this.length), l < 0 || A > c.length || C < 0 || N > this.length)
      throw new RangeError("out of range index");
    if (C >= N && l >= A)
      return 0;
    if (C >= N)
      return -1;
    if (l >= A)
      return 1;
    if (l >>>= 0, A >>>= 0, C >>>= 0, N >>>= 0, this === c)
      return 0;
    let F = N - C, ct = A - l;
    const at = Math.min(F, ct), ot = this.slice(C, N), Ot = c.slice(l, A);
    for (let st = 0; st < at; ++st)
      if (ot[st] !== Ot[st]) {
        F = ot[st], ct = Ot[st];
        break;
      }
    return F < ct ? -1 : ct < F ? 1 : 0;
  };
  function z(p, c, l, A, C) {
    if (p.length === 0)
      return -1;
    if (typeof l == "string" ? (A = l, l = 0) : l > 2147483647 ? l = 2147483647 : l < -2147483648 && (l = -2147483648), l = +l, St(l) && (l = C ? 0 : p.length - 1), l < 0 && (l = p.length + l), l >= p.length) {
      if (C)
        return -1;
      l = p.length - 1;
    } else if (l < 0)
      if (C)
        l = 0;
      else
        return -1;
    if (typeof c == "string" && (c = u.from(c, A)), u.isBuffer(c))
      return c.length === 0 ? -1 : K(p, c, l, A, C);
    if (typeof c == "number")
      return c = c & 255, typeof Uint8Array.prototype.indexOf == "function" ? C ? Uint8Array.prototype.indexOf.call(p, c, l) : Uint8Array.prototype.lastIndexOf.call(p, c, l) : K(p, [c], l, A, C);
    throw new TypeError("val must be string, number or Buffer");
  }
  function K(p, c, l, A, C) {
    let N = 1, F = p.length, ct = c.length;
    if (A !== void 0 && (A = String(A).toLowerCase(), A === "ucs2" || A === "ucs-2" || A === "utf16le" || A === "utf-16le")) {
      if (p.length < 2 || c.length < 2)
        return -1;
      N = 2, F /= 2, ct /= 2, l /= 2;
    }
    function at(Ot, st) {
      return N === 1 ? Ot[st] : Ot.readUInt16BE(st * N);
    }
    let ot;
    if (C) {
      let Ot = -1;
      for (ot = l; ot < F; ot++)
        if (at(p, ot) === at(c, Ot === -1 ? 0 : ot - Ot)) {
          if (Ot === -1 && (Ot = ot), ot - Ot + 1 === ct)
            return Ot * N;
        } else
          Ot !== -1 && (ot -= ot - Ot), Ot = -1;
    } else
      for (l + ct > F && (l = F - ct), ot = l; ot >= 0; ot--) {
        let Ot = !0;
        for (let st = 0; st < ct; st++)
          if (at(p, ot + st) !== at(c, st)) {
            Ot = !1;
            break;
          }
        if (Ot)
          return ot;
      }
    return -1;
  }
  u.prototype.includes = function(c, l, A) {
    return this.indexOf(c, l, A) !== -1;
  }, u.prototype.indexOf = function(c, l, A) {
    return z(this, c, l, A, !0);
  }, u.prototype.lastIndexOf = function(c, l, A) {
    return z(this, c, l, A, !1);
  };
  function Y(p, c, l, A) {
    l = Number(l) || 0;
    const C = p.length - l;
    A ? (A = Number(A), A > C && (A = C)) : A = C;
    const N = c.length;
    A > N / 2 && (A = N / 2);
    let F;
    for (F = 0; F < A; ++F) {
      const ct = parseInt(c.substr(F * 2, 2), 16);
      if (St(ct))
        return F;
      p[l + F] = ct;
    }
    return F;
  }
  function dt(p, c, l, A) {
    return Tt(Ct(c, p.length - l), p, l, A);
  }
  function ut(p, c, l, A) {
    return Tt(Ft(c), p, l, A);
  }
  function W(p, c, l, A) {
    return Tt(Dt(c), p, l, A);
  }
  function Et(p, c, l, A) {
    return Tt(Fn(c, p.length - l), p, l, A);
  }
  u.prototype.write = function(c, l, A, C) {
    if (l === void 0)
      C = "utf8", A = this.length, l = 0;
    else if (A === void 0 && typeof l == "string")
      C = l, A = this.length, l = 0;
    else if (isFinite(l))
      l = l >>> 0, isFinite(A) ? (A = A >>> 0, C === void 0 && (C = "utf8")) : (C = A, A = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const N = this.length - l;
    if ((A === void 0 || A > N) && (A = N), c.length > 0 && (A < 0 || l < 0) || l > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    C || (C = "utf8");
    let F = !1;
    for (; ; )
      switch (C) {
        case "hex":
          return Y(this, c, l, A);
        case "utf8":
        case "utf-8":
          return dt(this, c, l, A);
        case "ascii":
        case "latin1":
        case "binary":
          return ut(this, c, l, A);
        case "base64":
          return W(this, c, l, A);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Et(this, c, l, A);
        default:
          if (F)
            throw new TypeError("Unknown encoding: " + C);
          C = ("" + C).toLowerCase(), F = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function I(p, c, l) {
    return c === 0 && l === p.length ? t.fromByteArray(p) : t.fromByteArray(p.slice(c, l));
  }
  function a(p, c, l) {
    l = Math.min(p.length, l);
    const A = [];
    let C = c;
    for (; C < l; ) {
      const N = p[C];
      let F = null, ct = N > 239 ? 4 : N > 223 ? 3 : N > 191 ? 2 : 1;
      if (C + ct <= l) {
        let at, ot, Ot, st;
        switch (ct) {
          case 1:
            N < 128 && (F = N);
            break;
          case 2:
            at = p[C + 1], (at & 192) === 128 && (st = (N & 31) << 6 | at & 63, st > 127 && (F = st));
            break;
          case 3:
            at = p[C + 1], ot = p[C + 2], (at & 192) === 128 && (ot & 192) === 128 && (st = (N & 15) << 12 | (at & 63) << 6 | ot & 63, st > 2047 && (st < 55296 || st > 57343) && (F = st));
            break;
          case 4:
            at = p[C + 1], ot = p[C + 2], Ot = p[C + 3], (at & 192) === 128 && (ot & 192) === 128 && (Ot & 192) === 128 && (st = (N & 15) << 18 | (at & 63) << 12 | (ot & 63) << 6 | Ot & 63, st > 65535 && st < 1114112 && (F = st));
        }
      }
      F === null ? (F = 65533, ct = 1) : F > 65535 && (F -= 65536, A.push(F >>> 10 & 1023 | 55296), F = 56320 | F & 1023), A.push(F), C += ct;
    }
    return y(A);
  }
  const h = 4096;
  function y(p) {
    const c = p.length;
    if (c <= h)
      return String.fromCharCode.apply(String, p);
    let l = "", A = 0;
    for (; A < c; )
      l += String.fromCharCode.apply(
        String,
        p.slice(A, A += h)
      );
    return l;
  }
  function E(p, c, l) {
    let A = "";
    l = Math.min(p.length, l);
    for (let C = c; C < l; ++C)
      A += String.fromCharCode(p[C] & 127);
    return A;
  }
  function b(p, c, l) {
    let A = "";
    l = Math.min(p.length, l);
    for (let C = c; C < l; ++C)
      A += String.fromCharCode(p[C]);
    return A;
  }
  function x(p, c, l) {
    const A = p.length;
    (!c || c < 0) && (c = 0), (!l || l < 0 || l > A) && (l = A);
    let C = "";
    for (let N = c; N < l; ++N)
      C += Ut[p[N]];
    return C;
  }
  function M(p, c, l) {
    const A = p.slice(c, l);
    let C = "";
    for (let N = 0; N < A.length - 1; N += 2)
      C += String.fromCharCode(A[N] + A[N + 1] * 256);
    return C;
  }
  u.prototype.slice = function(c, l) {
    const A = this.length;
    c = ~~c, l = l === void 0 ? A : ~~l, c < 0 ? (c += A, c < 0 && (c = 0)) : c > A && (c = A), l < 0 ? (l += A, l < 0 && (l = 0)) : l > A && (l = A), l < c && (l = c);
    const C = this.subarray(c, l);
    return Object.setPrototypeOf(C, u.prototype), C;
  };
  function g(p, c, l) {
    if (p % 1 !== 0 || p < 0)
      throw new RangeError("offset is not uint");
    if (p + c > l)
      throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function(c, l, A) {
    c = c >>> 0, l = l >>> 0, A || g(c, l, this.length);
    let C = this[c], N = 1, F = 0;
    for (; ++F < l && (N *= 256); )
      C += this[c + F] * N;
    return C;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function(c, l, A) {
    c = c >>> 0, l = l >>> 0, A || g(c, l, this.length);
    let C = this[c + --l], N = 1;
    for (; l > 0 && (N *= 256); )
      C += this[c + --l] * N;
    return C;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function(c, l) {
    return c = c >>> 0, l || g(c, 1, this.length), this[c];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(c, l) {
    return c = c >>> 0, l || g(c, 2, this.length), this[c] | this[c + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(c, l) {
    return c = c >>> 0, l || g(c, 2, this.length), this[c] << 8 | this[c + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(c, l) {
    return c = c >>> 0, l || g(c, 4, this.length), (this[c] | this[c + 1] << 8 | this[c + 2] << 16) + this[c + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(c, l) {
    return c = c >>> 0, l || g(c, 4, this.length), this[c] * 16777216 + (this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3]);
  }, u.prototype.readBigUInt64LE = ve(function(c) {
    c = c >>> 0, At(c, "offset");
    const l = this[c], A = this[c + 7];
    (l === void 0 || A === void 0) && pt(c, this.length - 8);
    const C = l + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + this[++c] * 2 ** 24, N = this[++c] + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + A * 2 ** 24;
    return BigInt(C) + (BigInt(N) << BigInt(32));
  }), u.prototype.readBigUInt64BE = ve(function(c) {
    c = c >>> 0, At(c, "offset");
    const l = this[c], A = this[c + 7];
    (l === void 0 || A === void 0) && pt(c, this.length - 8);
    const C = l * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + this[++c], N = this[++c] * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + A;
    return (BigInt(C) << BigInt(32)) + BigInt(N);
  }), u.prototype.readIntLE = function(c, l, A) {
    c = c >>> 0, l = l >>> 0, A || g(c, l, this.length);
    let C = this[c], N = 1, F = 0;
    for (; ++F < l && (N *= 256); )
      C += this[c + F] * N;
    return N *= 128, C >= N && (C -= Math.pow(2, 8 * l)), C;
  }, u.prototype.readIntBE = function(c, l, A) {
    c = c >>> 0, l = l >>> 0, A || g(c, l, this.length);
    let C = l, N = 1, F = this[c + --C];
    for (; C > 0 && (N *= 256); )
      F += this[c + --C] * N;
    return N *= 128, F >= N && (F -= Math.pow(2, 8 * l)), F;
  }, u.prototype.readInt8 = function(c, l) {
    return c = c >>> 0, l || g(c, 1, this.length), this[c] & 128 ? (255 - this[c] + 1) * -1 : this[c];
  }, u.prototype.readInt16LE = function(c, l) {
    c = c >>> 0, l || g(c, 2, this.length);
    const A = this[c] | this[c + 1] << 8;
    return A & 32768 ? A | 4294901760 : A;
  }, u.prototype.readInt16BE = function(c, l) {
    c = c >>> 0, l || g(c, 2, this.length);
    const A = this[c + 1] | this[c] << 8;
    return A & 32768 ? A | 4294901760 : A;
  }, u.prototype.readInt32LE = function(c, l) {
    return c = c >>> 0, l || g(c, 4, this.length), this[c] | this[c + 1] << 8 | this[c + 2] << 16 | this[c + 3] << 24;
  }, u.prototype.readInt32BE = function(c, l) {
    return c = c >>> 0, l || g(c, 4, this.length), this[c] << 24 | this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3];
  }, u.prototype.readBigInt64LE = ve(function(c) {
    c = c >>> 0, At(c, "offset");
    const l = this[c], A = this[c + 7];
    (l === void 0 || A === void 0) && pt(c, this.length - 8);
    const C = this[c + 4] + this[c + 5] * 2 ** 8 + this[c + 6] * 2 ** 16 + (A << 24);
    return (BigInt(C) << BigInt(32)) + BigInt(l + this[++c] * 2 ** 8 + this[++c] * 2 ** 16 + this[++c] * 2 ** 24);
  }), u.prototype.readBigInt64BE = ve(function(c) {
    c = c >>> 0, At(c, "offset");
    const l = this[c], A = this[c + 7];
    (l === void 0 || A === void 0) && pt(c, this.length - 8);
    const C = (l << 24) + // Overflow
    this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + this[++c];
    return (BigInt(C) << BigInt(32)) + BigInt(this[++c] * 2 ** 24 + this[++c] * 2 ** 16 + this[++c] * 2 ** 8 + A);
  }), u.prototype.readFloatLE = function(c, l) {
    return c = c >>> 0, l || g(c, 4, this.length), n.read(this, c, !0, 23, 4);
  }, u.prototype.readFloatBE = function(c, l) {
    return c = c >>> 0, l || g(c, 4, this.length), n.read(this, c, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(c, l) {
    return c = c >>> 0, l || g(c, 8, this.length), n.read(this, c, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(c, l) {
    return c = c >>> 0, l || g(c, 8, this.length), n.read(this, c, !1, 52, 8);
  };
  function f(p, c, l, A, C, N) {
    if (!u.isBuffer(p))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (c > C || c < N)
      throw new RangeError('"value" argument is out of bounds');
    if (l + A > p.length)
      throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function(c, l, A, C) {
    if (c = +c, l = l >>> 0, A = A >>> 0, !C) {
      const ct = Math.pow(2, 8 * A) - 1;
      f(this, c, l, A, ct, 0);
    }
    let N = 1, F = 0;
    for (this[l] = c & 255; ++F < A && (N *= 256); )
      this[l + F] = c / N & 255;
    return l + A;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(c, l, A, C) {
    if (c = +c, l = l >>> 0, A = A >>> 0, !C) {
      const ct = Math.pow(2, 8 * A) - 1;
      f(this, c, l, A, ct, 0);
    }
    let N = A - 1, F = 1;
    for (this[l + N] = c & 255; --N >= 0 && (F *= 256); )
      this[l + N] = c / F & 255;
    return l + A;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 1, 255, 0), this[l] = c & 255, l + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 2, 65535, 0), this[l] = c & 255, this[l + 1] = c >>> 8, l + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 2, 65535, 0), this[l] = c >>> 8, this[l + 1] = c & 255, l + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 4, 4294967295, 0), this[l + 3] = c >>> 24, this[l + 2] = c >>> 16, this[l + 1] = c >>> 8, this[l] = c & 255, l + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 4, 4294967295, 0), this[l] = c >>> 24, this[l + 1] = c >>> 16, this[l + 2] = c >>> 8, this[l + 3] = c & 255, l + 4;
  };
  function v(p, c, l, A, C) {
    ht(c, A, C, p, l, 7);
    let N = Number(c & BigInt(4294967295));
    p[l++] = N, N = N >> 8, p[l++] = N, N = N >> 8, p[l++] = N, N = N >> 8, p[l++] = N;
    let F = Number(c >> BigInt(32) & BigInt(4294967295));
    return p[l++] = F, F = F >> 8, p[l++] = F, F = F >> 8, p[l++] = F, F = F >> 8, p[l++] = F, l;
  }
  function Q(p, c, l, A, C) {
    ht(c, A, C, p, l, 7);
    let N = Number(c & BigInt(4294967295));
    p[l + 7] = N, N = N >> 8, p[l + 6] = N, N = N >> 8, p[l + 5] = N, N = N >> 8, p[l + 4] = N;
    let F = Number(c >> BigInt(32) & BigInt(4294967295));
    return p[l + 3] = F, F = F >> 8, p[l + 2] = F, F = F >> 8, p[l + 1] = F, F = F >> 8, p[l] = F, l + 8;
  }
  u.prototype.writeBigUInt64LE = ve(function(c, l = 0) {
    return v(this, c, l, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeBigUInt64BE = ve(function(c, l = 0) {
    return Q(this, c, l, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeIntLE = function(c, l, A, C) {
    if (c = +c, l = l >>> 0, !C) {
      const at = Math.pow(2, 8 * A - 1);
      f(this, c, l, A, at - 1, -at);
    }
    let N = 0, F = 1, ct = 0;
    for (this[l] = c & 255; ++N < A && (F *= 256); )
      c < 0 && ct === 0 && this[l + N - 1] !== 0 && (ct = 1), this[l + N] = (c / F >> 0) - ct & 255;
    return l + A;
  }, u.prototype.writeIntBE = function(c, l, A, C) {
    if (c = +c, l = l >>> 0, !C) {
      const at = Math.pow(2, 8 * A - 1);
      f(this, c, l, A, at - 1, -at);
    }
    let N = A - 1, F = 1, ct = 0;
    for (this[l + N] = c & 255; --N >= 0 && (F *= 256); )
      c < 0 && ct === 0 && this[l + N + 1] !== 0 && (ct = 1), this[l + N] = (c / F >> 0) - ct & 255;
    return l + A;
  }, u.prototype.writeInt8 = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 1, 127, -128), c < 0 && (c = 255 + c + 1), this[l] = c & 255, l + 1;
  }, u.prototype.writeInt16LE = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 2, 32767, -32768), this[l] = c & 255, this[l + 1] = c >>> 8, l + 2;
  }, u.prototype.writeInt16BE = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 2, 32767, -32768), this[l] = c >>> 8, this[l + 1] = c & 255, l + 2;
  }, u.prototype.writeInt32LE = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 4, 2147483647, -2147483648), this[l] = c & 255, this[l + 1] = c >>> 8, this[l + 2] = c >>> 16, this[l + 3] = c >>> 24, l + 4;
  }, u.prototype.writeInt32BE = function(c, l, A) {
    return c = +c, l = l >>> 0, A || f(this, c, l, 4, 2147483647, -2147483648), c < 0 && (c = 4294967295 + c + 1), this[l] = c >>> 24, this[l + 1] = c >>> 16, this[l + 2] = c >>> 8, this[l + 3] = c & 255, l + 4;
  }, u.prototype.writeBigInt64LE = ve(function(c, l = 0) {
    return v(this, c, l, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), u.prototype.writeBigInt64BE = ve(function(c, l = 0) {
    return Q(this, c, l, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function V(p, c, l, A, C, N) {
    if (l + A > p.length)
      throw new RangeError("Index out of range");
    if (l < 0)
      throw new RangeError("Index out of range");
  }
  function q(p, c, l, A, C) {
    return c = +c, l = l >>> 0, C || V(p, c, l, 4), n.write(p, c, l, A, 23, 4), l + 4;
  }
  u.prototype.writeFloatLE = function(c, l, A) {
    return q(this, c, l, !0, A);
  }, u.prototype.writeFloatBE = function(c, l, A) {
    return q(this, c, l, !1, A);
  };
  function nt(p, c, l, A, C) {
    return c = +c, l = l >>> 0, C || V(p, c, l, 8), n.write(p, c, l, A, 52, 8), l + 8;
  }
  u.prototype.writeDoubleLE = function(c, l, A) {
    return nt(this, c, l, !0, A);
  }, u.prototype.writeDoubleBE = function(c, l, A) {
    return nt(this, c, l, !1, A);
  }, u.prototype.copy = function(c, l, A, C) {
    if (!u.isBuffer(c))
      throw new TypeError("argument should be a Buffer");
    if (A || (A = 0), !C && C !== 0 && (C = this.length), l >= c.length && (l = c.length), l || (l = 0), C > 0 && C < A && (C = A), C === A || c.length === 0 || this.length === 0)
      return 0;
    if (l < 0)
      throw new RangeError("targetStart out of bounds");
    if (A < 0 || A >= this.length)
      throw new RangeError("Index out of range");
    if (C < 0)
      throw new RangeError("sourceEnd out of bounds");
    C > this.length && (C = this.length), c.length - l < C - A && (C = c.length - l + A);
    const N = C - A;
    return this === c && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(l, A, C) : Uint8Array.prototype.set.call(
      c,
      this.subarray(A, C),
      l
    ), N;
  }, u.prototype.fill = function(c, l, A, C) {
    if (typeof c == "string") {
      if (typeof l == "string" ? (C = l, l = 0, A = this.length) : typeof A == "string" && (C = A, A = this.length), C !== void 0 && typeof C != "string")
        throw new TypeError("encoding must be a string");
      if (typeof C == "string" && !u.isEncoding(C))
        throw new TypeError("Unknown encoding: " + C);
      if (c.length === 1) {
        const F = c.charCodeAt(0);
        (C === "utf8" && F < 128 || C === "latin1") && (c = F);
      }
    } else
      typeof c == "number" ? c = c & 255 : typeof c == "boolean" && (c = Number(c));
    if (l < 0 || this.length < l || this.length < A)
      throw new RangeError("Out of range index");
    if (A <= l)
      return this;
    l = l >>> 0, A = A === void 0 ? this.length : A >>> 0, c || (c = 0);
    let N;
    if (typeof c == "number")
      for (N = l; N < A; ++N)
        this[N] = c;
    else {
      const F = u.isBuffer(c) ? c : u.from(c, C), ct = F.length;
      if (ct === 0)
        throw new TypeError('The value "' + c + '" is invalid for argument "value"');
      for (N = 0; N < A - l; ++N)
        this[N + l] = F[N % ct];
    }
    return this;
  };
  const $ = {};
  function rt(p, c, l) {
    $[p] = class extends l {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: c.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${p}]`, this.stack, delete this.name;
      }
      get code() {
        return p;
      }
      set code(C) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: C,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${p}]: ${this.message}`;
      }
    };
  }
  rt(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(p) {
      return p ? `${p} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), rt(
    "ERR_INVALID_ARG_TYPE",
    function(p, c) {
      return `The "${p}" argument must be of type number. Received type ${typeof c}`;
    },
    TypeError
  ), rt(
    "ERR_OUT_OF_RANGE",
    function(p, c, l) {
      let A = `The value of "${p}" is out of range.`, C = l;
      return Number.isInteger(l) && Math.abs(l) > 2 ** 32 ? C = Pt(String(l)) : typeof l == "bigint" && (C = String(l), (l > BigInt(2) ** BigInt(32) || l < -(BigInt(2) ** BigInt(32))) && (C = Pt(C)), C += "n"), A += ` It must be ${c}. Received ${C}`, A;
    },
    RangeError
  );
  function Pt(p) {
    let c = "", l = p.length;
    const A = p[0] === "-" ? 1 : 0;
    for (; l >= A + 4; l -= 3)
      c = `_${p.slice(l - 3, l)}${c}`;
    return `${p.slice(0, l)}${c}`;
  }
  function ft(p, c, l) {
    At(c, "offset"), (p[c] === void 0 || p[c + l] === void 0) && pt(c, p.length - (l + 1));
  }
  function ht(p, c, l, A, C, N) {
    if (p > l || p < c) {
      const F = typeof c == "bigint" ? "n" : "";
      let ct;
      throw N > 3 ? c === 0 || c === BigInt(0) ? ct = `>= 0${F} and < 2${F} ** ${(N + 1) * 8}${F}` : ct = `>= -(2${F} ** ${(N + 1) * 8 - 1}${F}) and < 2 ** ${(N + 1) * 8 - 1}${F}` : ct = `>= ${c}${F} and <= ${l}${F}`, new $.ERR_OUT_OF_RANGE("value", ct, p);
    }
    ft(A, C, N);
  }
  function At(p, c) {
    if (typeof p != "number")
      throw new $.ERR_INVALID_ARG_TYPE(c, "number", p);
  }
  function pt(p, c, l) {
    throw Math.floor(p) !== p ? (At(p, l), new $.ERR_OUT_OF_RANGE(l || "offset", "an integer", p)) : c < 0 ? new $.ERR_BUFFER_OUT_OF_BOUNDS() : new $.ERR_OUT_OF_RANGE(
      l || "offset",
      `>= ${l ? 1 : 0} and <= ${c}`,
      p
    );
  }
  const vt = /[^+/0-9A-Za-z-_]/g;
  function Qe(p) {
    if (p = p.split("=")[0], p = p.trim().replace(vt, ""), p.length < 2)
      return "";
    for (; p.length % 4 !== 0; )
      p = p + "=";
    return p;
  }
  function Ct(p, c) {
    c = c || 1 / 0;
    let l;
    const A = p.length;
    let C = null;
    const N = [];
    for (let F = 0; F < A; ++F) {
      if (l = p.charCodeAt(F), l > 55295 && l < 57344) {
        if (!C) {
          if (l > 56319) {
            (c -= 3) > -1 && N.push(239, 191, 189);
            continue;
          } else if (F + 1 === A) {
            (c -= 3) > -1 && N.push(239, 191, 189);
            continue;
          }
          C = l;
          continue;
        }
        if (l < 56320) {
          (c -= 3) > -1 && N.push(239, 191, 189), C = l;
          continue;
        }
        l = (C - 55296 << 10 | l - 56320) + 65536;
      } else
        C && (c -= 3) > -1 && N.push(239, 191, 189);
      if (C = null, l < 128) {
        if ((c -= 1) < 0)
          break;
        N.push(l);
      } else if (l < 2048) {
        if ((c -= 2) < 0)
          break;
        N.push(
          l >> 6 | 192,
          l & 63 | 128
        );
      } else if (l < 65536) {
        if ((c -= 3) < 0)
          break;
        N.push(
          l >> 12 | 224,
          l >> 6 & 63 | 128,
          l & 63 | 128
        );
      } else if (l < 1114112) {
        if ((c -= 4) < 0)
          break;
        N.push(
          l >> 18 | 240,
          l >> 12 & 63 | 128,
          l >> 6 & 63 | 128,
          l & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return N;
  }
  function Ft(p) {
    const c = [];
    for (let l = 0; l < p.length; ++l)
      c.push(p.charCodeAt(l) & 255);
    return c;
  }
  function Fn(p, c) {
    let l, A, C;
    const N = [];
    for (let F = 0; F < p.length && !((c -= 2) < 0); ++F)
      l = p.charCodeAt(F), A = l >> 8, C = l % 256, N.push(C), N.push(A);
    return N;
  }
  function Dt(p) {
    return t.toByteArray(Qe(p));
  }
  function Tt(p, c, l, A) {
    let C;
    for (C = 0; C < A && !(C + l >= c.length || C >= p.length); ++C)
      c[C + l] = p[C];
    return C;
  }
  function ye(p, c) {
    return p instanceof c || p != null && p.constructor != null && p.constructor.name != null && p.constructor.name === c.name;
  }
  function St(p) {
    return p !== p;
  }
  const Ut = function() {
    const p = "0123456789abcdef", c = new Array(256);
    for (let l = 0; l < 16; ++l) {
      const A = l * 16;
      for (let C = 0; C < 16; ++C)
        c[A + C] = p[l] + p[C];
    }
    return c;
  }();
  function ve(p) {
    return typeof BigInt > "u" ? kt : p;
  }
  function kt() {
    throw new Error("BigInt not supported");
  }
})(_t);
function Jo(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`positive integer expected, not ${e}`);
}
function bh(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function fi(e, ...t) {
  if (!bh(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${e.length}`);
}
function Ah(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Jo(e.outputLen), Jo(e.blockLen);
}
function Xr(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function xh(e, t) {
  fi(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const Wi = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const $i = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), qe = (e, t) => e << 32 - t | e >>> t;
new Uint8Array(new Uint32Array([287454020]).buffer)[0];
function bu(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function Zs(e) {
  return typeof e == "string" && (e = bu(e)), fi(e), e;
}
function Au(...e) {
  let t = 0;
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    fi(i), t += i.length;
  }
  const n = new Uint8Array(t);
  for (let r = 0, i = 0; r < e.length; r++) {
    const s = e[r];
    n.set(s, i), i += s.length;
  }
  return n;
}
class xu {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function Eu(e) {
  const t = (r) => e().update(Zs(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
function vu(e = 32) {
  if (Wi && typeof Wi.getRandomValues == "function")
    return Wi.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
function Eh(e, t, n, r) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, n, r);
  const i = BigInt(32), s = BigInt(4294967295), o = Number(n >> i & s), u = Number(n & s), d = r ? 4 : 0, m = r ? 0 : 4;
  e.setUint32(t + d, o, r), e.setUint32(t + m, u, r);
}
const vh = (e, t, n) => e & t ^ ~e & n, Bh = (e, t, n) => e & t ^ e & n ^ t & n;
class Bu extends xu {
  constructor(t, n, r, i) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = $i(this.buffer);
  }
  update(t) {
    Xr(this);
    const { view: n, buffer: r, blockLen: i } = this;
    t = Zs(t);
    const s = t.length;
    for (let o = 0; o < s; ) {
      const u = Math.min(i - this.pos, s - o);
      if (u === i) {
        const d = $i(t);
        for (; i <= s - o; o += i)
          this.process(d, o);
        continue;
      }
      r.set(t.subarray(o, o + u), this.pos), this.pos += u, o += u, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    Xr(this), xh(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: s } = this;
    let { pos: o } = this;
    n[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > i - o && (this.process(r, 0), o = 0);
    for (let B = o; B < i; B++)
      n[B] = 0;
    Eh(r, i - 8, BigInt(this.length * 8), s), this.process(r, 0);
    const u = $i(t), d = this.outputLen;
    if (d % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const m = d / 4, w = this.get();
    if (m > w.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let B = 0; B < m; B++)
      u.setUint32(4 * B, w[B], s);
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: s, destroyed: o, pos: u } = this;
    return t.length = i, t.pos = u, t.finished = s, t.destroyed = o, i % n && t.buffer.set(r), t;
  }
}
const Pr = /* @__PURE__ */ BigInt(2 ** 32 - 1), As = /* @__PURE__ */ BigInt(32);
function Iu(e, t = !1) {
  return t ? { h: Number(e & Pr), l: Number(e >> As & Pr) } : { h: Number(e >> As & Pr) | 0, l: Number(e & Pr) | 0 };
}
function Ih(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: s, l: o } = Iu(e[i], t);
    [n[i], r[i]] = [s, o];
  }
  return [n, r];
}
const Mh = (e, t) => BigInt(e >>> 0) << As | BigInt(t >>> 0), Ch = (e, t, n) => e >>> n, Th = (e, t, n) => e << 32 - n | t >>> n, Sh = (e, t, n) => e >>> n | t << 32 - n, Uh = (e, t, n) => e << 32 - n | t >>> n, Rh = (e, t, n) => e << 64 - n | t >>> n - 32, Nh = (e, t, n) => e >>> n - 32 | t << 64 - n, Dh = (e, t) => t, kh = (e, t) => e, Oh = (e, t, n) => e << n | t >>> 32 - n, Fh = (e, t, n) => t << n | e >>> 32 - n, Lh = (e, t, n) => t << n - 32 | e >>> 64 - n, Ph = (e, t, n) => e << n - 32 | t >>> 64 - n;
function _h(e, t, n, r) {
  const i = (t >>> 0) + (r >>> 0);
  return { h: e + n + (i / 2 ** 32 | 0) | 0, l: i | 0 };
}
const zh = (e, t, n) => (e >>> 0) + (t >>> 0) + (n >>> 0), Hh = (e, t, n, r) => t + n + r + (e / 2 ** 32 | 0) | 0, Gh = (e, t, n, r) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0), Qh = (e, t, n, r, i) => t + n + r + i + (e / 2 ** 32 | 0) | 0, Vh = (e, t, n, r, i) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0) + (i >>> 0), qh = (e, t, n, r, i, s) => t + n + r + i + s + (e / 2 ** 32 | 0) | 0, jh = {
  fromBig: Iu,
  split: Ih,
  toBig: Mh,
  shrSH: Ch,
  shrSL: Th,
  rotrSH: Sh,
  rotrSL: Uh,
  rotrBH: Rh,
  rotrBL: Nh,
  rotr32H: Dh,
  rotr32L: kh,
  rotlSH: Oh,
  rotlSL: Fh,
  rotlBH: Lh,
  rotlBL: Ph,
  add: _h,
  add3L: zh,
  add3H: Hh,
  add4L: Gh,
  add4H: Qh,
  add5H: qh,
  add5L: Vh
}, lt = jh, [Zh, Kh] = /* @__PURE__ */ (() => lt.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))))(), un = /* @__PURE__ */ new Uint32Array(80), cn = /* @__PURE__ */ new Uint32Array(80);
class Yh extends Bu {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: n, Bh: r, Bl: i, Ch: s, Cl: o, Dh: u, Dl: d, Eh: m, El: w, Fh: B, Fl: S, Gh: T, Gl: O, Hh: U, Hl: R } = this;
    return [t, n, r, i, s, o, u, d, m, w, B, S, T, O, U, R];
  }
  // prettier-ignore
  set(t, n, r, i, s, o, u, d, m, w, B, S, T, O, U, R) {
    this.Ah = t | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = i | 0, this.Ch = s | 0, this.Cl = o | 0, this.Dh = u | 0, this.Dl = d | 0, this.Eh = m | 0, this.El = w | 0, this.Fh = B | 0, this.Fl = S | 0, this.Gh = T | 0, this.Gl = O | 0, this.Hh = U | 0, this.Hl = R | 0;
  }
  process(t, n) {
    for (let L = 0; L < 16; L++, n += 4)
      un[L] = t.getUint32(n), cn[L] = t.getUint32(n += 4);
    for (let L = 16; L < 80; L++) {
      const Z = un[L - 15] | 0, _ = cn[L - 15] | 0, z = lt.rotrSH(Z, _, 1) ^ lt.rotrSH(Z, _, 8) ^ lt.shrSH(Z, _, 7), K = lt.rotrSL(Z, _, 1) ^ lt.rotrSL(Z, _, 8) ^ lt.shrSL(Z, _, 7), Y = un[L - 2] | 0, dt = cn[L - 2] | 0, ut = lt.rotrSH(Y, dt, 19) ^ lt.rotrBH(Y, dt, 61) ^ lt.shrSH(Y, dt, 6), W = lt.rotrSL(Y, dt, 19) ^ lt.rotrBL(Y, dt, 61) ^ lt.shrSL(Y, dt, 6), Et = lt.add4L(K, W, cn[L - 7], cn[L - 16]), I = lt.add4H(Et, z, ut, un[L - 7], un[L - 16]);
      un[L] = I | 0, cn[L] = Et | 0;
    }
    let { Ah: r, Al: i, Bh: s, Bl: o, Ch: u, Cl: d, Dh: m, Dl: w, Eh: B, El: S, Fh: T, Fl: O, Gh: U, Gl: R, Hh: P, Hl: G } = this;
    for (let L = 0; L < 80; L++) {
      const Z = lt.rotrSH(B, S, 14) ^ lt.rotrSH(B, S, 18) ^ lt.rotrBH(B, S, 41), _ = lt.rotrSL(B, S, 14) ^ lt.rotrSL(B, S, 18) ^ lt.rotrBL(B, S, 41), z = B & T ^ ~B & U, K = S & O ^ ~S & R, Y = lt.add5L(G, _, K, Kh[L], cn[L]), dt = lt.add5H(Y, P, Z, z, Zh[L], un[L]), ut = Y | 0, W = lt.rotrSH(r, i, 28) ^ lt.rotrBH(r, i, 34) ^ lt.rotrBH(r, i, 39), Et = lt.rotrSL(r, i, 28) ^ lt.rotrBL(r, i, 34) ^ lt.rotrBL(r, i, 39), I = r & s ^ r & u ^ s & u, a = i & o ^ i & d ^ o & d;
      P = U | 0, G = R | 0, U = T | 0, R = O | 0, T = B | 0, O = S | 0, { h: B, l: S } = lt.add(m | 0, w | 0, dt | 0, ut | 0), m = u | 0, w = d | 0, u = s | 0, d = o | 0, s = r | 0, o = i | 0;
      const h = lt.add3L(ut, Et, a);
      r = lt.add3H(h, dt, W, I), i = h | 0;
    }
    ({ h: r, l: i } = lt.add(this.Ah | 0, this.Al | 0, r | 0, i | 0)), { h: s, l: o } = lt.add(this.Bh | 0, this.Bl | 0, s | 0, o | 0), { h: u, l: d } = lt.add(this.Ch | 0, this.Cl | 0, u | 0, d | 0), { h: m, l: w } = lt.add(this.Dh | 0, this.Dl | 0, m | 0, w | 0), { h: B, l: S } = lt.add(this.Eh | 0, this.El | 0, B | 0, S | 0), { h: T, l: O } = lt.add(this.Fh | 0, this.Fl | 0, T | 0, O | 0), { h: U, l: R } = lt.add(this.Gh | 0, this.Gl | 0, U | 0, R | 0), { h: P, l: G } = lt.add(this.Hh | 0, this.Hl | 0, P | 0, G | 0), this.set(r, i, s, o, u, d, m, w, B, S, T, O, U, R, P, G);
  }
  roundClean() {
    un.fill(0), cn.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const Mu = /* @__PURE__ */ Eu(() => new Yh());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Cu = BigInt(0), li = BigInt(1), Jh = BigInt(2);
function Sn(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function Mr(e) {
  if (!Sn(e))
    throw new Error("Uint8Array expected");
}
const Xh = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Un(e) {
  Mr(e);
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += Xh[e[n]];
  return t;
}
function Tu(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function Ks(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
const $e = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function Xo(e) {
  if (e >= $e._0 && e <= $e._9)
    return e - $e._0;
  if (e >= $e._A && e <= $e._F)
    return e - ($e._A - 10);
  if (e >= $e._a && e <= $e._f)
    return e - ($e._a - 10);
}
function tr(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length, n = t / 2;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const r = new Uint8Array(n);
  for (let i = 0, s = 0; i < n; i++, s += 2) {
    const o = Xo(e.charCodeAt(s)), u = Xo(e.charCodeAt(s + 1));
    if (o === void 0 || u === void 0) {
      const d = e[s] + e[s + 1];
      throw new Error('hex string expected, got non-hex character "' + d + '" at index ' + s);
    }
    r[i] = o * 16 + u;
  }
  return r;
}
function Mn(e) {
  return Ks(Un(e));
}
function Kn(e) {
  return Mr(e), Ks(Un(Uint8Array.from(e).reverse()));
}
function er(e, t) {
  return tr(e.toString(16).padStart(t * 2, "0"));
}
function vr(e, t) {
  return er(e, t).reverse();
}
function Wh(e) {
  return tr(Tu(e));
}
function ue(e, t, n) {
  let r;
  if (typeof t == "string")
    try {
      r = tr(t);
    } catch (s) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${s}`);
    }
  else if (Sn(t))
    r = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const i = r.length;
  if (typeof n == "number" && i !== n)
    throw new Error(`${e} expected ${n} bytes, got ${i}`);
  return r;
}
function Rn(...e) {
  let t = 0;
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    Mr(i), t += i.length;
  }
  const n = new Uint8Array(t);
  for (let r = 0, i = 0; r < e.length; r++) {
    const s = e[r];
    n.set(s, i), i += s.length;
  }
  return n;
}
function $h(e, t) {
  if (e.length !== t.length)
    return !1;
  let n = 0;
  for (let r = 0; r < e.length; r++)
    n |= e[r] ^ t[r];
  return n === 0;
}
function td(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function ed(e) {
  let t;
  for (t = 0; e > Cu; e >>= li, t += 1)
    ;
  return t;
}
function nd(e, t) {
  return e >> BigInt(t) & li;
}
function rd(e, t, n) {
  return e | (n ? li : Cu) << BigInt(t);
}
const Ys = (e) => (Jh << BigInt(e - 1)) - li, ts = (e) => new Uint8Array(e), Wo = (e) => Uint8Array.from(e);
function Su(e, t, n) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof n != "function")
    throw new Error("hmacFn must be a function");
  let r = ts(e), i = ts(e), s = 0;
  const o = () => {
    r.fill(1), i.fill(0), s = 0;
  }, u = (...B) => n(i, r, ...B), d = (B = ts()) => {
    i = u(Wo([0]), B), r = u(), B.length !== 0 && (i = u(Wo([1]), B), r = u());
  }, m = () => {
    if (s++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let B = 0;
    const S = [];
    for (; B < t; ) {
      r = u();
      const T = r.slice();
      S.push(T), B += r.length;
    }
    return Rn(...S);
  };
  return (B, S) => {
    o(), d(B);
    let T;
    for (; !(T = S(m())); )
      d();
    return o(), T;
  };
}
const id = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || Sn(e),
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function ur(e, t, n = {}) {
  const r = (i, s, o) => {
    const u = id[s];
    if (typeof u != "function")
      throw new Error(`Invalid validator "${s}", expected function`);
    const d = e[i];
    if (!(o && d === void 0) && !u(d, e))
      throw new Error(`Invalid param ${String(i)}=${d} (${typeof d}), expected ${s}`);
  };
  for (const [i, s] of Object.entries(t))
    r(i, s, !1);
  for (const [i, s] of Object.entries(n))
    r(i, s, !0);
  return e;
}
const sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abytes: Mr,
  bitGet: nd,
  bitLen: ed,
  bitMask: Ys,
  bitSet: rd,
  bytesToHex: Un,
  bytesToNumberBE: Mn,
  bytesToNumberLE: Kn,
  concatBytes: Rn,
  createHmacDrbg: Su,
  ensureBytes: ue,
  equalBytes: $h,
  hexToBytes: tr,
  hexToNumber: Ks,
  isBytes: Sn,
  numberToBytesBE: er,
  numberToBytesLE: vr,
  numberToHexUnpadded: Tu,
  numberToVarBytesBE: Wh,
  utf8ToBytes: td,
  validateObject: ur
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const le = BigInt(0), Ht = BigInt(1), bn = BigInt(2), od = BigInt(3), xs = BigInt(4), $o = BigInt(5), ta = BigInt(8);
BigInt(9);
BigInt(16);
function Lt(e, t) {
  const n = e % t;
  return n >= le ? n : t + n;
}
function ad(e, t, n) {
  if (n <= le || t < le)
    throw new Error("Expected power/modulo > 0");
  if (n === Ht)
    return le;
  let r = Ht;
  for (; t > le; )
    t & Ht && (r = r * e % n), e = e * e % n, t >>= Ht;
  return r;
}
function Gt(e, t, n) {
  let r = e;
  for (; t-- > le; )
    r *= r, r %= n;
  return r;
}
function Es(e, t) {
  if (e === le || t <= le)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let n = Lt(e, t), r = t, i = le, s = Ht;
  for (; n !== le; ) {
    const u = r / n, d = r % n, m = i - s * u;
    r = n, n = d, i = s, s = m;
  }
  if (r !== Ht)
    throw new Error("invert: does not exist");
  return Lt(i, t);
}
function ud(e) {
  const t = (e - Ht) / bn;
  let n, r, i;
  for (n = e - Ht, r = 0; n % bn === le; n /= bn, r++)
    ;
  for (i = bn; i < e && ad(i, t, e) !== e - Ht; i++)
    ;
  if (r === 1) {
    const o = (e + Ht) / xs;
    return function(d, m) {
      const w = d.pow(m, o);
      if (!d.eql(d.sqr(w), m))
        throw new Error("Cannot find square root");
      return w;
    };
  }
  const s = (n + Ht) / bn;
  return function(u, d) {
    if (u.pow(d, t) === u.neg(u.ONE))
      throw new Error("Cannot find square root");
    let m = r, w = u.pow(u.mul(u.ONE, i), n), B = u.pow(d, s), S = u.pow(d, n);
    for (; !u.eql(S, u.ONE); ) {
      if (u.eql(S, u.ZERO))
        return u.ZERO;
      let T = 1;
      for (let U = u.sqr(S); T < m && !u.eql(U, u.ONE); T++)
        U = u.sqr(U);
      const O = u.pow(w, Ht << BigInt(m - T - 1));
      w = u.sqr(O), B = u.mul(B, O), S = u.mul(S, w), m = T;
    }
    return B;
  };
}
function cd(e) {
  if (e % xs === od) {
    const t = (e + Ht) / xs;
    return function(r, i) {
      const s = r.pow(i, t);
      if (!r.eql(r.sqr(s), i))
        throw new Error("Cannot find square root");
      return s;
    };
  }
  if (e % ta === $o) {
    const t = (e - $o) / ta;
    return function(r, i) {
      const s = r.mul(i, bn), o = r.pow(s, t), u = r.mul(i, o), d = r.mul(r.mul(u, bn), o), m = r.mul(u, r.sub(d, r.ONE));
      if (!r.eql(r.sqr(m), i))
        throw new Error("Cannot find square root");
      return m;
    };
  }
  return ud(e);
}
const fd = (e, t) => (Lt(e, t) & Ht) === Ht, ld = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function hd(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, n = ld.reduce((r, i) => (r[i] = "function", r), t);
  return ur(e, n);
}
function dd(e, t, n) {
  if (n < le)
    throw new Error("Expected power > 0");
  if (n === le)
    return e.ONE;
  if (n === Ht)
    return t;
  let r = e.ONE, i = t;
  for (; n > le; )
    n & Ht && (r = e.mul(r, i)), i = e.sqr(i), n >>= Ht;
  return r;
}
function pd(e, t) {
  const n = new Array(t.length), r = t.reduce((s, o, u) => e.is0(o) ? s : (n[u] = s, e.mul(s, o)), e.ONE), i = e.inv(r);
  return t.reduceRight((s, o, u) => e.is0(o) ? s : (n[u] = e.mul(s, n[u]), e.mul(s, o)), i), n;
}
function Uu(e, t) {
  const n = t !== void 0 ? t : e.toString(2).length, r = Math.ceil(n / 8);
  return { nBitLength: n, nByteLength: r };
}
function Ru(e, t, n = !1, r = {}) {
  if (e <= le)
    throw new Error(`Expected Field ORDER > 0, got ${e}`);
  const { nBitLength: i, nByteLength: s } = Uu(e, t);
  if (s > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const o = cd(e), u = Object.freeze({
    ORDER: e,
    BITS: i,
    BYTES: s,
    MASK: Ys(i),
    ZERO: le,
    ONE: Ht,
    create: (d) => Lt(d, e),
    isValid: (d) => {
      if (typeof d != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof d}`);
      return le <= d && d < e;
    },
    is0: (d) => d === le,
    isOdd: (d) => (d & Ht) === Ht,
    neg: (d) => Lt(-d, e),
    eql: (d, m) => d === m,
    sqr: (d) => Lt(d * d, e),
    add: (d, m) => Lt(d + m, e),
    sub: (d, m) => Lt(d - m, e),
    mul: (d, m) => Lt(d * m, e),
    pow: (d, m) => dd(u, d, m),
    div: (d, m) => Lt(d * Es(m, e), e),
    // Same as above, but doesn't normalize
    sqrN: (d) => d * d,
    addN: (d, m) => d + m,
    subN: (d, m) => d - m,
    mulN: (d, m) => d * m,
    inv: (d) => Es(d, e),
    sqrt: r.sqrt || ((d) => o(u, d)),
    invertBatch: (d) => pd(u, d),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (d, m, w) => w ? m : d,
    toBytes: (d) => n ? vr(d, s) : er(d, s),
    fromBytes: (d) => {
      if (d.length !== s)
        throw new Error(`Fp.fromBytes: expected ${s}, got ${d.length}`);
      return n ? Kn(d) : Mn(d);
    }
  });
  return Object.freeze(u);
}
function yd(e, t) {
  if (!e.isOdd)
    throw new Error("Field doesn't have isOdd");
  const n = e.sqrt(t);
  return e.isOdd(n) ? e.neg(n) : n;
}
function Nu(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function Du(e) {
  const t = Nu(e);
  return t + Math.ceil(t / 2);
}
function md(e, t, n = !1) {
  const r = e.length, i = Nu(t), s = Du(t);
  if (r < 16 || r < s || r > 1024)
    throw new Error(`expected ${s}-1024 bytes of input, got ${r}`);
  const o = n ? Mn(e) : Kn(e), u = Lt(o, t - Ht) + Ht;
  return n ? vr(u, i) : er(u, i);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const gd = BigInt(0), es = BigInt(1);
function ku(e, t) {
  const n = (i, s) => {
    const o = s.negate();
    return i ? o : s;
  }, r = (i) => {
    const s = Math.ceil(t / i) + 1, o = 2 ** (i - 1);
    return { windows: s, windowSize: o };
  };
  return {
    constTimeNegate: n,
    // non-const time multiplication ladder
    unsafeLadder(i, s) {
      let o = e.ZERO, u = i;
      for (; s > gd; )
        s & es && (o = o.add(u)), u = u.double(), s >>= es;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(i, s) {
      const { windows: o, windowSize: u } = r(s), d = [];
      let m = i, w = m;
      for (let B = 0; B < o; B++) {
        w = m, d.push(w);
        for (let S = 1; S < u; S++)
          w = w.add(m), d.push(w);
        m = w.double();
      }
      return d;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(i, s, o) {
      const { windows: u, windowSize: d } = r(i);
      let m = e.ZERO, w = e.BASE;
      const B = BigInt(2 ** i - 1), S = 2 ** i, T = BigInt(i);
      for (let O = 0; O < u; O++) {
        const U = O * d;
        let R = Number(o & B);
        o >>= T, R > d && (R -= S, o += es);
        const P = U, G = U + Math.abs(R) - 1, L = O % 2 !== 0, Z = R < 0;
        R === 0 ? w = w.add(n(L, s[P])) : m = m.add(n(Z, s[G]));
      }
      return { p: m, f: w };
    },
    wNAFCached(i, s, o, u) {
      const d = i._WINDOW_SIZE || 1;
      let m = s.get(i);
      return m || (m = this.precomputeWindow(i, d), d !== 1 && s.set(i, u(m))), this.wNAF(d, m, o);
    }
  };
}
function Js(e) {
  return hd(e.Fp), ur(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...Uu(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Pe = BigInt(0), Te = BigInt(1), _r = BigInt(2), wd = BigInt(8), bd = { zip215: !0 };
function Ad(e) {
  const t = Js(e);
  return ur(e, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...t });
}
function Xs(e) {
  const t = Ad(e), { Fp: n, n: r, prehash: i, hash: s, randomBytes: o, nByteLength: u, h: d } = t, m = _r << BigInt(u * 8) - Te, w = n.create, B = t.uvRatio || ((b, x) => {
    try {
      return { isValid: !0, value: n.sqrt(b * n.inv(x)) };
    } catch {
      return { isValid: !1, value: Pe };
    }
  }), S = t.adjustScalarBytes || ((b) => b), T = t.domain || ((b, x, M) => {
    if (x.length || M)
      throw new Error("Contexts/pre-hash are not supported");
    return b;
  }), O = (b) => typeof b == "bigint" && Pe < b, U = (b, x) => O(b) && O(x) && b < x, R = (b) => b === Pe || U(b, m);
  function P(b, x) {
    if (U(b, x))
      return b;
    throw new Error(`Expected valid scalar < ${x}, got ${typeof b} ${b}`);
  }
  function G(b) {
    return b === Pe ? b : P(b, r);
  }
  const L = /* @__PURE__ */ new Map();
  function Z(b) {
    if (!(b instanceof _))
      throw new Error("ExtendedPoint expected");
  }
  class _ {
    constructor(x, M, g, f) {
      if (this.ex = x, this.ey = M, this.ez = g, this.et = f, !R(x))
        throw new Error("x required");
      if (!R(M))
        throw new Error("y required");
      if (!R(g))
        throw new Error("z required");
      if (!R(f))
        throw new Error("t required");
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(x) {
      if (x instanceof _)
        throw new Error("extended point not allowed");
      const { x: M, y: g } = x || {};
      if (!R(M) || !R(g))
        throw new Error("invalid affine point");
      return new _(M, g, Te, w(M * g));
    }
    static normalizeZ(x) {
      const M = n.invertBatch(x.map((g) => g.ez));
      return x.map((g, f) => g.toAffine(M[f])).map(_.fromAffine);
    }
    // "Private method", don't use it directly
    _setWindowSize(x) {
      this._WINDOW_SIZE = x, L.delete(this);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      const { a: x, d: M } = t;
      if (this.is0())
        throw new Error("bad point: ZERO");
      const { ex: g, ey: f, ez: v, et: Q } = this, V = w(g * g), q = w(f * f), nt = w(v * v), $ = w(nt * nt), rt = w(V * x), Pt = w(nt * w(rt + q)), ft = w($ + w(M * w(V * q)));
      if (Pt !== ft)
        throw new Error("bad point: equation left != right (1)");
      const ht = w(g * f), At = w(v * Q);
      if (ht !== At)
        throw new Error("bad point: equation left != right (2)");
    }
    // Compare one point to another.
    equals(x) {
      Z(x);
      const { ex: M, ey: g, ez: f } = this, { ex: v, ey: Q, ez: V } = x, q = w(M * V), nt = w(v * f), $ = w(g * V), rt = w(Q * f);
      return q === nt && $ === rt;
    }
    is0() {
      return this.equals(_.ZERO);
    }
    negate() {
      return new _(w(-this.ex), this.ey, this.ez, w(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: x } = t, { ex: M, ey: g, ez: f } = this, v = w(M * M), Q = w(g * g), V = w(_r * w(f * f)), q = w(x * v), nt = M + g, $ = w(w(nt * nt) - v - Q), rt = q + Q, Pt = rt - V, ft = q - Q, ht = w($ * Pt), At = w(rt * ft), pt = w($ * ft), vt = w(Pt * rt);
      return new _(ht, At, vt, pt);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(x) {
      Z(x);
      const { a: M, d: g } = t, { ex: f, ey: v, ez: Q, et: V } = this, { ex: q, ey: nt, ez: $, et: rt } = x;
      if (M === BigInt(-1)) {
        const ye = w((v - f) * (nt + q)), St = w((v + f) * (nt - q)), Ut = w(St - ye);
        if (Ut === Pe)
          return this.double();
        const ve = w(Q * _r * rt), kt = w(V * _r * $), p = kt + ve, c = St + ye, l = kt - ve, A = w(p * Ut), C = w(c * l), N = w(p * l), F = w(Ut * c);
        return new _(A, C, F, N);
      }
      const Pt = w(f * q), ft = w(v * nt), ht = w(V * g * rt), At = w(Q * $), pt = w((f + v) * (q + nt) - Pt - ft), vt = At - ht, Qe = At + ht, Ct = w(ft - M * Pt), Ft = w(pt * vt), Fn = w(Qe * Ct), Dt = w(pt * Ct), Tt = w(vt * Qe);
      return new _(Ft, Fn, Tt, Dt);
    }
    subtract(x) {
      return this.add(x.negate());
    }
    wNAF(x) {
      return Y.wNAFCached(this, L, x, _.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(x) {
      const { p: M, f: g } = this.wNAF(P(x, r));
      return _.normalizeZ([M, g])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    multiplyUnsafe(x) {
      let M = G(x);
      return M === Pe ? K : this.equals(K) || M === Te ? this : this.equals(z) ? this.wNAF(M).p : Y.unsafeLadder(this, M);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(d).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return Y.unsafeLadder(this, r).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(x) {
      const { ex: M, ey: g, ez: f } = this, v = this.is0();
      x == null && (x = v ? wd : n.inv(f));
      const Q = w(M * x), V = w(g * x), q = w(f * x);
      if (v)
        return { x: Pe, y: Te };
      if (q !== Te)
        throw new Error("invZ was invalid");
      return { x: Q, y: V };
    }
    clearCofactor() {
      const { h: x } = t;
      return x === Te ? this : this.multiplyUnsafe(x);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(x, M = !1) {
      const { d: g, a: f } = t, v = n.BYTES;
      x = ue("pointHex", x, v);
      const Q = x.slice(), V = x[v - 1];
      Q[v - 1] = V & -129;
      const q = Kn(Q);
      q === Pe || (M ? P(q, m) : P(q, n.ORDER));
      const nt = w(q * q), $ = w(nt - Te), rt = w(g * nt - f);
      let { isValid: Pt, value: ft } = B($, rt);
      if (!Pt)
        throw new Error("Point.fromHex: invalid y coordinate");
      const ht = (ft & Te) === Te, At = (V & 128) !== 0;
      if (!M && ft === Pe && At)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return At !== ht && (ft = w(-ft)), _.fromAffine({ x: ft, y: q });
    }
    static fromPrivateKey(x) {
      return W(x).point;
    }
    toRawBytes() {
      const { x, y: M } = this.toAffine(), g = vr(M, n.BYTES);
      return g[g.length - 1] |= x & Te ? 128 : 0, g;
    }
    toHex() {
      return Un(this.toRawBytes());
    }
  }
  _.BASE = new _(t.Gx, t.Gy, Te, w(t.Gx * t.Gy)), _.ZERO = new _(Pe, Te, Te, Pe);
  const { BASE: z, ZERO: K } = _, Y = ku(_, u * 8);
  function dt(b) {
    return Lt(b, r);
  }
  function ut(b) {
    return dt(Kn(b));
  }
  function W(b) {
    const x = u;
    b = ue("private key", b, x);
    const M = ue("hashed private key", s(b), 2 * x), g = S(M.slice(0, x)), f = M.slice(x, 2 * x), v = ut(g), Q = z.multiply(v), V = Q.toRawBytes();
    return { head: g, prefix: f, scalar: v, point: Q, pointBytes: V };
  }
  function Et(b) {
    return W(b).pointBytes;
  }
  function I(b = new Uint8Array(), ...x) {
    const M = Rn(...x);
    return ut(s(T(M, ue("context", b), !!i)));
  }
  function a(b, x, M = {}) {
    b = ue("message", b), i && (b = i(b));
    const { prefix: g, scalar: f, pointBytes: v } = W(x), Q = I(M.context, g, b), V = z.multiply(Q).toRawBytes(), q = I(M.context, V, v, b), nt = dt(Q + q * f);
    G(nt);
    const $ = Rn(V, vr(nt, n.BYTES));
    return ue("result", $, u * 2);
  }
  const h = bd;
  function y(b, x, M, g = h) {
    const { context: f, zip215: v } = g, Q = n.BYTES;
    b = ue("signature", b, 2 * Q), x = ue("message", x), i && (x = i(x));
    const V = Kn(b.slice(Q, 2 * Q));
    let q, nt, $;
    try {
      q = _.fromHex(M, v), nt = _.fromHex(b.slice(0, Q), v), $ = z.multiplyUnsafe(V);
    } catch {
      return !1;
    }
    if (!v && q.isSmallOrder())
      return !1;
    const rt = I(f, nt.toRawBytes(), q.toRawBytes(), x);
    return nt.add(q.multiplyUnsafe(rt)).subtract($).clearCofactor().equals(_.ZERO);
  }
  return z._setWindowSize(8), {
    CURVE: t,
    getPublicKey: Et,
    sign: a,
    verify: y,
    ExtendedPoint: _,
    utils: {
      getExtendedPublicKey: W,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => o(n.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(b = 8, x = _.BASE) {
        return x._setWindowSize(b), x.multiply(BigInt(3)), x;
      }
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ws = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), ea = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const xd = BigInt(1), vs = BigInt(2), Ed = BigInt(5), na = BigInt(10), vd = BigInt(20), Bd = BigInt(40), ra = BigInt(80);
function Id(e) {
  const t = Ws, r = e * e % t * e % t, i = Gt(r, vs, t) * r % t, s = Gt(i, xd, t) * e % t, o = Gt(s, Ed, t) * s % t, u = Gt(o, na, t) * o % t, d = Gt(u, vd, t) * u % t, m = Gt(d, Bd, t) * d % t, w = Gt(m, ra, t) * m % t, B = Gt(w, ra, t) * m % t, S = Gt(B, na, t) * o % t;
  return { pow_p_5_8: Gt(S, vs, t) * e % t, b2: r };
}
function Md(e) {
  return e[0] &= 248, e[31] &= 127, e[31] |= 64, e;
}
function Cd(e, t) {
  const n = Ws, r = Lt(t * t * t, n), i = Lt(r * r * t, n), s = Id(e * i).pow_p_5_8;
  let o = Lt(e * r * s, n);
  const u = Lt(t * o * o, n), d = o, m = Lt(o * ea, n), w = u === e, B = u === Lt(-e, n), S = u === Lt(-e * ea, n);
  return w && (o = d), (B || S) && (o = m), fd(o, n) && (o = Lt(-o, n)), { isValid: w || B, value: o };
}
const sn = Ru(Ws, void 0, !0), $s = {
  // Param: a
  a: BigInt(-1),
  // Fp.create(-1) is proper; our way still works and is faster
  // d is equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
  Fp: sn,
  // Subgroup order: how many points curve has
  // 2n**252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: BigInt(8),
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: Mu,
  randomBytes: vu,
  adjustScalarBytes: Md,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio: Cd
}, Ou = /* @__PURE__ */ Xs($s);
function Fu(e, t, n) {
  if (t.length > 255)
    throw new Error("Context is too big");
  return Au(bu("SigEd25519 no Ed25519 collisions"), new Uint8Array([n ? 1 : 0, t.length]), t, e);
}
({
  ...$s
});
({
  ...$s
});
const Td = (sn.ORDER + BigInt(3)) / BigInt(8);
sn.pow(vs, Td);
sn.sqrt(sn.neg(sn.ONE));
(sn.ORDER - BigInt(5)) / BigInt(8);
BigInt(486662);
yd(sn, sn.neg(BigInt(486664)));
BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var Bs = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(e, t) {
  var n = _t, r = n.Buffer;
  function i(o, u) {
    for (var d in o)
      u[d] = o[d];
  }
  r.from && r.alloc && r.allocUnsafe && r.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = s);
  function s(o, u, d) {
    return r(o, u, d);
  }
  s.prototype = Object.create(r.prototype), i(r, s), s.from = function(o, u, d) {
    if (typeof o == "number")
      throw new TypeError("Argument must not be a number");
    return r(o, u, d);
  }, s.alloc = function(o, u, d) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    var m = r(o);
    return u !== void 0 ? typeof d == "string" ? m.fill(u, d) : m.fill(u) : m.fill(0), m;
  }, s.allocUnsafe = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return r(o);
  }, s.allocUnsafeSlow = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return n.SlowBuffer(o);
  };
})(Bs, Bs.exports);
var Sd = Bs.exports, zr = Sd.Buffer;
function Ud(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), n = 0; n < t.length; n++)
    t[n] = 255;
  for (var r = 0; r < e.length; r++) {
    var i = e.charAt(r), s = i.charCodeAt(0);
    if (t[s] !== 255)
      throw new TypeError(i + " is ambiguous");
    t[s] = r;
  }
  var o = e.length, u = e.charAt(0), d = Math.log(o) / Math.log(256), m = Math.log(256) / Math.log(o);
  function w(T) {
    if ((Array.isArray(T) || T instanceof Uint8Array) && (T = zr.from(T)), !zr.isBuffer(T))
      throw new TypeError("Expected Buffer");
    if (T.length === 0)
      return "";
    for (var O = 0, U = 0, R = 0, P = T.length; R !== P && T[R] === 0; )
      R++, O++;
    for (var G = (P - R) * m + 1 >>> 0, L = new Uint8Array(G); R !== P; ) {
      for (var Z = T[R], _ = 0, z = G - 1; (Z !== 0 || _ < U) && z !== -1; z--, _++)
        Z += 256 * L[z] >>> 0, L[z] = Z % o >>> 0, Z = Z / o >>> 0;
      if (Z !== 0)
        throw new Error("Non-zero carry");
      U = _, R++;
    }
    for (var K = G - U; K !== G && L[K] === 0; )
      K++;
    for (var Y = u.repeat(O); K < G; ++K)
      Y += e.charAt(L[K]);
    return Y;
  }
  function B(T) {
    if (typeof T != "string")
      throw new TypeError("Expected String");
    if (T.length === 0)
      return zr.alloc(0);
    for (var O = 0, U = 0, R = 0; T[O] === u; )
      U++, O++;
    for (var P = (T.length - O) * d + 1 >>> 0, G = new Uint8Array(P); T[O]; ) {
      var L = t[T.charCodeAt(O)];
      if (L === 255)
        return;
      for (var Z = 0, _ = P - 1; (L !== 0 || Z < R) && _ !== -1; _--, Z++)
        L += o * G[_] >>> 0, G[_] = L % 256 >>> 0, L = L / 256 >>> 0;
      if (L !== 0)
        throw new Error("Non-zero carry");
      R = Z, O++;
    }
    for (var z = P - R; z !== P && G[z] === 0; )
      z++;
    var K = zr.allocUnsafe(U + (P - z));
    K.fill(0, 0, U);
    for (var Y = U; z !== P; )
      K[Y++] = G[z++];
    return K;
  }
  function S(T) {
    var O = B(T);
    if (O)
      return O;
    throw new Error("Non-base" + o + " character");
  }
  return {
    encode: w,
    decodeUnsafe: B,
    decode: S
  };
}
var Rd = Ud, Nd = Rd, Dd = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", Lu = Nd(Dd);
const ia = /* @__PURE__ */ mu(Lu), kd = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), fn = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ln = /* @__PURE__ */ new Uint32Array(64);
class Od extends Bu {
  constructor() {
    super(64, 32, 8, !1), this.A = fn[0] | 0, this.B = fn[1] | 0, this.C = fn[2] | 0, this.D = fn[3] | 0, this.E = fn[4] | 0, this.F = fn[5] | 0, this.G = fn[6] | 0, this.H = fn[7] | 0;
  }
  get() {
    const { A: t, B: n, C: r, D: i, E: s, F: o, G: u, H: d } = this;
    return [t, n, r, i, s, o, u, d];
  }
  // prettier-ignore
  set(t, n, r, i, s, o, u, d) {
    this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = s | 0, this.F = o | 0, this.G = u | 0, this.H = d | 0;
  }
  process(t, n) {
    for (let B = 0; B < 16; B++, n += 4)
      ln[B] = t.getUint32(n, !1);
    for (let B = 16; B < 64; B++) {
      const S = ln[B - 15], T = ln[B - 2], O = qe(S, 7) ^ qe(S, 18) ^ S >>> 3, U = qe(T, 17) ^ qe(T, 19) ^ T >>> 10;
      ln[B] = U + ln[B - 7] + O + ln[B - 16] | 0;
    }
    let { A: r, B: i, C: s, D: o, E: u, F: d, G: m, H: w } = this;
    for (let B = 0; B < 64; B++) {
      const S = qe(u, 6) ^ qe(u, 11) ^ qe(u, 25), T = w + S + vh(u, d, m) + kd[B] + ln[B] | 0, U = (qe(r, 2) ^ qe(r, 13) ^ qe(r, 22)) + Bh(r, i, s) | 0;
      w = m, m = d, d = u, u = o + T | 0, o = s, s = i, i = r, r = T + U | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, s = s + this.C | 0, o = o + this.D | 0, u = u + this.E | 0, d = d + this.F | 0, m = m + this.G | 0, w = w + this.H | 0, this.set(r, i, s, o, u, d, m, w);
  }
  roundClean() {
    ln.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const Is = /* @__PURE__ */ Eu(() => new Od());
var pe = {};
function en(e, t, n) {
  return t <= e && e <= n;
}
function hi(e) {
  if (e === void 0)
    return {};
  if (e === Object(e))
    return e;
  throw TypeError("Could not convert argument to dictionary");
}
function Fd(e) {
  for (var t = String(e), n = t.length, r = 0, i = []; r < n; ) {
    var s = t.charCodeAt(r);
    if (s < 55296 || s > 57343)
      i.push(s);
    else if (56320 <= s && s <= 57343)
      i.push(65533);
    else if (55296 <= s && s <= 56319)
      if (r === n - 1)
        i.push(65533);
      else {
        var o = e.charCodeAt(r + 1);
        if (56320 <= o && o <= 57343) {
          var u = s & 1023, d = o & 1023;
          i.push(65536 + (u << 10) + d), r += 1;
        } else
          i.push(65533);
      }
    r += 1;
  }
  return i;
}
function Ld(e) {
  for (var t = "", n = 0; n < e.length; ++n) {
    var r = e[n];
    r <= 65535 ? t += String.fromCharCode(r) : (r -= 65536, t += String.fromCharCode(
      (r >> 10) + 55296,
      (r & 1023) + 56320
    ));
  }
  return t;
}
var Wr = -1;
function to(e) {
  this.tokens = [].slice.call(e);
}
to.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : Wr;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(e) {
    if (Array.isArray(e))
      for (var t = (
        /**@type {!Array.<number>}*/
        e
      ); t.length; )
        this.tokens.unshift(t.pop());
    else
      this.tokens.unshift(e);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(e) {
    if (Array.isArray(e))
      for (var t = (
        /**@type {!Array.<number>}*/
        e
      ); t.length; )
        this.tokens.push(t.shift());
    else
      this.tokens.push(e);
  }
};
var nr = -1;
function ns(e, t) {
  if (e)
    throw TypeError("Decoder error");
  return t || 65533;
}
var $r = "utf-8";
function ti(e, t) {
  if (!(this instanceof ti))
    return new ti(e, t);
  if (e = e !== void 0 ? String(e).toLowerCase() : $r, e !== $r)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  t = hi(t), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!t.fatal, this._ignoreBOM = !!t.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
ti.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function(t, n) {
    var r;
    typeof t == "object" && t instanceof ArrayBuffer ? r = new Uint8Array(t) : typeof t == "object" && "buffer" in t && t.buffer instanceof ArrayBuffer ? r = new Uint8Array(
      t.buffer,
      t.byteOffset,
      t.byteLength
    ) : r = new Uint8Array(0), n = hi(n), this._streaming || (this._decoder = new Pd({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!n.stream;
    for (var i = new to(r), s = [], o; !i.endOfStream() && (o = this._decoder.handler(i, i.read()), o !== nr); )
      o !== null && (Array.isArray(o) ? s.push.apply(
        s,
        /**@type {!Array.<number>}*/
        o
      ) : s.push(o));
    if (!this._streaming) {
      do {
        if (o = this._decoder.handler(i, i.read()), o === nr)
          break;
        o !== null && (Array.isArray(o) ? s.push.apply(
          s,
          /**@type {!Array.<number>}*/
          o
        ) : s.push(o));
      } while (!i.endOfStream());
      this._decoder = null;
    }
    return s.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (s[0] === 65279 ? (this._BOMseen = !0, s.shift()) : this._BOMseen = !0), Ld(s);
  }
};
function ei(e, t) {
  if (!(this instanceof ei))
    return new ei(e, t);
  if (e = e !== void 0 ? String(e).toLowerCase() : $r, e !== $r)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  t = hi(t), this._streaming = !1, this._encoder = null, this._options = { fatal: !!t.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
ei.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function(t, n) {
    t = t ? String(t) : "", n = hi(n), this._streaming || (this._encoder = new _d(this._options)), this._streaming = !!n.stream;
    for (var r = [], i = new to(Fd(t)), s; !i.endOfStream() && (s = this._encoder.handler(i, i.read()), s !== nr); )
      Array.isArray(s) ? r.push.apply(
        r,
        /**@type {!Array.<number>}*/
        s
      ) : r.push(s);
    if (!this._streaming) {
      for (; s = this._encoder.handler(i, i.read()), s !== nr; )
        Array.isArray(s) ? r.push.apply(
          r,
          /**@type {!Array.<number>}*/
          s
        ) : r.push(s);
      this._encoder = null;
    }
    return new Uint8Array(r);
  }
};
function Pd(e) {
  var t = e.fatal, n = 0, r = 0, i = 0, s = 128, o = 191;
  this.handler = function(u, d) {
    if (d === Wr && i !== 0)
      return i = 0, ns(t);
    if (d === Wr)
      return nr;
    if (i === 0) {
      if (en(d, 0, 127))
        return d;
      if (en(d, 194, 223))
        i = 1, n = d - 192;
      else if (en(d, 224, 239))
        d === 224 && (s = 160), d === 237 && (o = 159), i = 2, n = d - 224;
      else if (en(d, 240, 244))
        d === 240 && (s = 144), d === 244 && (o = 143), i = 3, n = d - 240;
      else
        return ns(t);
      return n = n << 6 * i, null;
    }
    if (!en(d, s, o))
      return n = i = r = 0, s = 128, o = 191, u.prepend(d), ns(t);
    if (s = 128, o = 191, r += 1, n += d - 128 << 6 * (i - r), r !== i)
      return null;
    var m = n;
    return n = i = r = 0, m;
  };
}
function _d(e) {
  e.fatal, this.handler = function(t, n) {
    if (n === Wr)
      return nr;
    if (en(n, 0, 127))
      return n;
    var r, i;
    en(n, 128, 2047) ? (r = 1, i = 192) : en(n, 2048, 65535) ? (r = 2, i = 224) : en(n, 65536, 1114111) && (r = 3, i = 240);
    for (var s = [(n >> 6 * r) + i]; r > 0; ) {
      var o = n >> 6 * (r - 1);
      s.push(128 | o & 63), r -= 1;
    }
    return s;
  };
}
const zd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: ti,
  TextEncoder: ei
}, Symbol.toStringTag, { value: "Module" })), Hd = /* @__PURE__ */ Vs(zd);
var Gd = He && He.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n), Object.defineProperty(e, r, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Qd = He && He.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Ye = He && He.__decorate || function(e, t, n, r) {
  var i = arguments.length, s = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(e, t, n, r);
  else
    for (var u = e.length - 1; u >= 0; u--)
      (o = e[u]) && (s = (i < 3 ? o(s) : i > 3 ? o(t, n, s) : o(t, n)) || s);
  return i > 3 && s && Object.defineProperty(t, n, s), s;
}, Vd = He && He.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.hasOwnProperty.call(e, n) && Gd(t, e, n);
  return Qd(t, e), t;
}, Pu = He && He.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(pe, "__esModule", { value: !0 });
var _u = pe.deserializeUnchecked = qu = pe.deserialize = Vu = pe.serialize = pe.BinaryReader = pe.BinaryWriter = pe.BorshError = pe.baseDecode = pe.baseEncode = void 0;
const dn = Pu(gu), zu = Pu(Lu), qd = Vd(Hd), jd = typeof TextDecoder != "function" ? qd.TextDecoder : TextDecoder, Zd = new jd("utf-8", { fatal: !0 });
function Kd(e) {
  return typeof e == "string" && (e = Buffer.from(e, "utf8")), zu.default.encode(Buffer.from(e));
}
pe.baseEncode = Kd;
function Yd(e) {
  return Buffer.from(zu.default.decode(e));
}
pe.baseDecode = Yd;
const rs = 1024;
class Ee extends Error {
  constructor(t) {
    super(t), this.fieldPath = [], this.originalMessage = t;
  }
  addToFieldPath(t) {
    this.fieldPath.splice(0, 0, t), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
pe.BorshError = Ee;
class Hu {
  constructor() {
    this.buf = Buffer.alloc(rs), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = Buffer.concat([this.buf, Buffer.alloc(rs)]));
  }
  writeU8(t) {
    this.maybeResize(), this.buf.writeUInt8(t, this.length), this.length += 1;
  }
  writeU16(t) {
    this.maybeResize(), this.buf.writeUInt16LE(t, this.length), this.length += 2;
  }
  writeU32(t) {
    this.maybeResize(), this.buf.writeUInt32LE(t, this.length), this.length += 4;
  }
  writeU64(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new dn.default(t).toArray("le", 8)));
  }
  writeU128(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new dn.default(t).toArray("le", 16)));
  }
  writeU256(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new dn.default(t).toArray("le", 32)));
  }
  writeU512(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new dn.default(t).toArray("le", 64)));
  }
  writeBuffer(t) {
    this.buf = Buffer.concat([
      Buffer.from(this.buf.subarray(0, this.length)),
      t,
      Buffer.alloc(rs)
    ]), this.length += t.length;
  }
  writeString(t) {
    this.maybeResize();
    const n = Buffer.from(t, "utf8");
    this.writeU32(n.length), this.writeBuffer(n);
  }
  writeFixedArray(t) {
    this.writeBuffer(Buffer.from(t));
  }
  writeArray(t, n) {
    this.maybeResize(), this.writeU32(t.length);
    for (const r of t)
      this.maybeResize(), n(r);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
}
pe.BinaryWriter = Hu;
function Je(e, t, n) {
  const r = n.value;
  n.value = function(...i) {
    try {
      return r.apply(this, i);
    } catch (s) {
      if (s instanceof RangeError) {
        const o = s.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(o) >= 0)
          throw new Ee("Reached the end of buffer when deserializing");
      }
      throw s;
    }
  };
}
class Ue {
  constructor(t) {
    this.buf = t, this.offset = 0;
  }
  readU8() {
    const t = this.buf.readUInt8(this.offset);
    return this.offset += 1, t;
  }
  readU16() {
    const t = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, t;
  }
  readU32() {
    const t = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, t;
  }
  readU64() {
    const t = this.readBuffer(8);
    return new dn.default(t, "le");
  }
  readU128() {
    const t = this.readBuffer(16);
    return new dn.default(t, "le");
  }
  readU256() {
    const t = this.readBuffer(32);
    return new dn.default(t, "le");
  }
  readU512() {
    const t = this.readBuffer(64);
    return new dn.default(t, "le");
  }
  readBuffer(t) {
    if (this.offset + t > this.buf.length)
      throw new Ee(`Expected buffer length ${t} isn't within bounds`);
    const n = this.buf.slice(this.offset, this.offset + t);
    return this.offset += t, n;
  }
  readString() {
    const t = this.readU32(), n = this.readBuffer(t);
    try {
      return Zd.decode(n);
    } catch (r) {
      throw new Ee(`Error decoding UTF-8 string: ${r}`);
    }
  }
  readFixedArray(t) {
    return new Uint8Array(this.readBuffer(t));
  }
  readArray(t) {
    const n = this.readU32(), r = Array();
    for (let i = 0; i < n; ++i)
      r.push(t());
    return r;
  }
}
Ye([
  Je
], Ue.prototype, "readU8", null);
Ye([
  Je
], Ue.prototype, "readU16", null);
Ye([
  Je
], Ue.prototype, "readU32", null);
Ye([
  Je
], Ue.prototype, "readU64", null);
Ye([
  Je
], Ue.prototype, "readU128", null);
Ye([
  Je
], Ue.prototype, "readU256", null);
Ye([
  Je
], Ue.prototype, "readU512", null);
Ye([
  Je
], Ue.prototype, "readString", null);
Ye([
  Je
], Ue.prototype, "readFixedArray", null);
Ye([
  Je
], Ue.prototype, "readArray", null);
pe.BinaryReader = Ue;
function Gu(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function An(e, t, n, r, i) {
  try {
    if (typeof r == "string")
      i[`write${Gu(r)}`](n);
    else if (r instanceof Array)
      if (typeof r[0] == "number") {
        if (n.length !== r[0])
          throw new Ee(`Expecting byte array of length ${r[0]}, but got ${n.length} bytes`);
        i.writeFixedArray(n);
      } else if (r.length === 2 && typeof r[1] == "number") {
        if (n.length !== r[1])
          throw new Ee(`Expecting byte array of length ${r[1]}, but got ${n.length} bytes`);
        for (let s = 0; s < r[1]; s++)
          An(e, null, n[s], r[0], i);
      } else
        i.writeArray(n, (s) => {
          An(e, t, s, r[0], i);
        });
    else if (r.kind !== void 0)
      switch (r.kind) {
        case "option": {
          n == null ? i.writeU8(0) : (i.writeU8(1), An(e, t, n, r.type, i));
          break;
        }
        case "map": {
          i.writeU32(n.size), n.forEach((s, o) => {
            An(e, t, o, r.key, i), An(e, t, s, r.value, i);
          });
          break;
        }
        default:
          throw new Ee(`FieldType ${r} unrecognized`);
      }
    else
      Qu(e, n, i);
  } catch (s) {
    throw s instanceof Ee && s.addToFieldPath(t), s;
  }
}
function Qu(e, t, n) {
  if (typeof t.borshSerialize == "function") {
    t.borshSerialize(n);
    return;
  }
  const r = e.get(t.constructor);
  if (!r)
    throw new Ee(`Class ${t.constructor.name} is missing in schema`);
  if (r.kind === "struct")
    r.fields.map(([i, s]) => {
      An(e, i, t[i], s, n);
    });
  else if (r.kind === "enum") {
    const i = t[r.field];
    for (let s = 0; s < r.values.length; ++s) {
      const [o, u] = r.values[s];
      if (o === i) {
        n.writeU8(s), An(e, o, t[o], u, n);
        break;
      }
    }
  } else
    throw new Ee(`Unexpected schema kind: ${r.kind} for ${t.constructor.name}`);
}
function Jd(e, t, n = Hu) {
  const r = new n();
  return Qu(e, t, r), r.toArray();
}
var Vu = pe.serialize = Jd;
function xn(e, t, n, r) {
  try {
    if (typeof n == "string")
      return r[`read${Gu(n)}`]();
    if (n instanceof Array) {
      if (typeof n[0] == "number")
        return r.readFixedArray(n[0]);
      if (typeof n[1] == "number") {
        const i = [];
        for (let s = 0; s < n[1]; s++)
          i.push(xn(e, null, n[0], r));
        return i;
      } else
        return r.readArray(() => xn(e, t, n[0], r));
    }
    if (n.kind === "option")
      return r.readU8() ? xn(e, t, n.type, r) : void 0;
    if (n.kind === "map") {
      let i = /* @__PURE__ */ new Map();
      const s = r.readU32();
      for (let o = 0; o < s; o++) {
        const u = xn(e, t, n.key, r), d = xn(e, t, n.value, r);
        i.set(u, d);
      }
      return i;
    }
    return eo(e, n, r);
  } catch (i) {
    throw i instanceof Ee && i.addToFieldPath(t), i;
  }
}
function eo(e, t, n) {
  if (typeof t.borshDeserialize == "function")
    return t.borshDeserialize(n);
  const r = e.get(t);
  if (!r)
    throw new Ee(`Class ${t.name} is missing in schema`);
  if (r.kind === "struct") {
    const i = {};
    for (const [s, o] of e.get(t).fields)
      i[s] = xn(e, s, o, n);
    return new t(i);
  }
  if (r.kind === "enum") {
    const i = n.readU8();
    if (i >= r.values.length)
      throw new Ee(`Enum index: ${i} is out of range`);
    const [s, o] = r.values[i], u = xn(e, s, o, n);
    return new t({ [s]: u });
  }
  throw new Ee(`Unexpected schema kind: ${r.kind} for ${t.constructor.name}`);
}
function Xd(e, t, n, r = Ue) {
  const i = new r(n), s = eo(e, t, i);
  if (i.offset < n.length)
    throw new Ee(`Unexpected ${n.length - i.offset} bytes after deserialized data`);
  return s;
}
var qu = pe.deserialize = Xd;
function Wd(e, t, n, r = Ue) {
  const i = new r(n);
  return eo(e, t, i);
}
_u = pe.deserializeUnchecked = Wd;
var k = {};
Object.defineProperty(k, "__esModule", { value: !0 });
k.s16 = k.s8 = k.nu64be = k.u48be = k.u40be = k.u32be = k.u24be = k.u16be = de = k.nu64 = k.u48 = k.u40 = tt = k.u32 = k.u24 = ke = k.u16 = ae = k.u8 = Cn = k.offset = k.greedy = k.Constant = k.UTF8 = k.CString = k.Blob = k.Boolean = k.BitField = k.BitStructure = k.VariantLayout = k.Union = k.UnionLayoutDiscriminator = k.UnionDiscriminator = k.Structure = k.Sequence = k.DoubleBE = k.Double = k.FloatBE = k.Float = k.NearInt64BE = k.NearInt64 = k.NearUInt64BE = k.NearUInt64 = k.IntBE = k.Int = k.UIntBE = k.UInt = k.OffsetLayout = k.GreedyCount = k.ExternalLayout = k.bindConstructorLayout = k.nameWithProperty = k.Layout = k.uint8ArrayToBuffer = k.checkUint8Array = void 0;
k.constant = k.utf8 = k.cstr = rr = k.blob = k.unionLayoutDiscriminator = k.union = Bn = k.seq = k.bits = et = k.struct = k.f64be = k.f64 = k.f32be = k.f32 = k.ns64be = k.s48be = k.s40be = k.s32be = k.s24be = k.s16be = Se = k.ns64 = k.s48 = k.s40 = k.s32 = k.s24 = void 0;
const no = _t;
function cr(e) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
k.checkUint8Array = cr;
function bt(e) {
  return cr(e), no.Buffer.from(e.buffer, e.byteOffset, e.length);
}
k.uint8ArrayToBuffer = bt;
class It {
  constructor(t, n) {
    if (!Number.isInteger(t))
      throw new TypeError("span must be an integer");
    this.span = t, this.property = n;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(t, n) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(t) {
    const n = Object.create(this.constructor.prototype);
    return Object.assign(n, this), n.property = t, n;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(t) {
  }
}
k.Layout = It;
function ro(e, t) {
  return t.property ? e + "[" + t.property + "]" : e;
}
k.nameWithProperty = ro;
function $d(e, t) {
  if (typeof e != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(e, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(t && t instanceof It))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(t, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  e.layout_ = t, t.boundConstructor_ = e, t.makeDestinationObject = () => new e(), Object.defineProperty(e.prototype, "encode", {
    value(n, r) {
      return t.encode(this, n, r);
    },
    writable: !0
  }), Object.defineProperty(e, "decode", {
    value(n, r) {
      return t.decode(n, r);
    },
    writable: !0
  });
}
k.bindConstructorLayout = $d;
class Ie extends It {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
k.ExternalLayout = Ie;
class ju extends Ie {
  constructor(t = 1, n) {
    if (!Number.isInteger(t) || 0 >= t)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, n), this.elementSpan = t;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(t, n = 0) {
    cr(t);
    const r = t.length - n;
    return Math.floor(r / this.elementSpan);
  }
  /** @override */
  encode(t, n, r) {
    return 0;
  }
}
k.GreedyCount = ju;
class io extends Ie {
  constructor(t, n = 0, r) {
    if (!(t instanceof It))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(n))
      throw new TypeError("offset must be integer or undefined");
    super(t.span, r || t.property), this.layout = t, this.offset = n;
  }
  /** @override */
  isCount() {
    return this.layout instanceof Fe || this.layout instanceof ze;
  }
  /** @override */
  decode(t, n = 0) {
    return this.layout.decode(t, n + this.offset);
  }
  /** @override */
  encode(t, n, r = 0) {
    return this.layout.encode(t, n, r + this.offset);
  }
}
k.OffsetLayout = io;
class Fe extends It {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return bt(t).readUIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, r = 0) {
    return bt(n).writeUIntLE(t, r, this.span), this.span;
  }
}
k.UInt = Fe;
class ze extends It {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return bt(t).readUIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, r = 0) {
    return bt(n).writeUIntBE(t, r, this.span), this.span;
  }
}
k.UIntBE = ze;
class Nn extends It {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return bt(t).readIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, r = 0) {
    return bt(n).writeIntLE(t, r, this.span), this.span;
  }
}
k.Int = Nn;
class fr extends It {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return bt(t).readIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, r = 0) {
    return bt(n).writeIntBE(t, r, this.span), this.span;
  }
}
k.IntBE = fr;
const Ms = Math.pow(2, 32);
function di(e) {
  const t = Math.floor(e / Ms), n = e - t * Ms;
  return { hi32: t, lo32: n };
}
function pi(e, t) {
  return e * Ms + t;
}
class Zu extends It {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const r = bt(t), i = r.readUInt32LE(n), s = r.readUInt32LE(n + 4);
    return pi(s, i);
  }
  /** @override */
  encode(t, n, r = 0) {
    const i = di(t), s = bt(n);
    return s.writeUInt32LE(i.lo32, r), s.writeUInt32LE(i.hi32, r + 4), 8;
  }
}
k.NearUInt64 = Zu;
class Ku extends It {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const r = bt(t), i = r.readUInt32BE(n), s = r.readUInt32BE(n + 4);
    return pi(i, s);
  }
  /** @override */
  encode(t, n, r = 0) {
    const i = di(t), s = bt(n);
    return s.writeUInt32BE(i.hi32, r), s.writeUInt32BE(i.lo32, r + 4), 8;
  }
}
k.NearUInt64BE = Ku;
class Yu extends It {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const r = bt(t), i = r.readUInt32LE(n), s = r.readInt32LE(n + 4);
    return pi(s, i);
  }
  /** @override */
  encode(t, n, r = 0) {
    const i = di(t), s = bt(n);
    return s.writeUInt32LE(i.lo32, r), s.writeInt32LE(i.hi32, r + 4), 8;
  }
}
k.NearInt64 = Yu;
class Ju extends It {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const r = bt(t), i = r.readInt32BE(n), s = r.readUInt32BE(n + 4);
    return pi(i, s);
  }
  /** @override */
  encode(t, n, r = 0) {
    const i = di(t), s = bt(n);
    return s.writeInt32BE(i.hi32, r), s.writeUInt32BE(i.lo32, r + 4), 8;
  }
}
k.NearInt64BE = Ju;
class Xu extends It {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, n = 0) {
    return bt(t).readFloatLE(n);
  }
  /** @override */
  encode(t, n, r = 0) {
    return bt(n).writeFloatLE(t, r), 4;
  }
}
k.Float = Xu;
class Wu extends It {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, n = 0) {
    return bt(t).readFloatBE(n);
  }
  /** @override */
  encode(t, n, r = 0) {
    return bt(n).writeFloatBE(t, r), 4;
  }
}
k.FloatBE = Wu;
class $u extends It {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    return bt(t).readDoubleLE(n);
  }
  /** @override */
  encode(t, n, r = 0) {
    return bt(n).writeDoubleLE(t, r), 8;
  }
}
k.Double = $u;
class tc extends It {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    return bt(t).readDoubleBE(n);
  }
  /** @override */
  encode(t, n, r = 0) {
    return bt(n).writeDoubleBE(t, r), 8;
  }
}
k.DoubleBE = tc;
class ec extends It {
  constructor(t, n, r) {
    if (!(t instanceof It))
      throw new TypeError("elementLayout must be a Layout");
    if (!(n instanceof Ie && n.isCount() || Number.isInteger(n) && 0 <= n))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let i = -1;
    !(n instanceof Ie) && 0 < t.span && (i = n * t.span), super(i, r), this.elementLayout = t, this.count = n;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0, i = this.count;
    if (i instanceof Ie && (i = i.decode(t, n)), 0 < this.elementLayout.span)
      r = i * this.elementLayout.span;
    else {
      let s = 0;
      for (; s < i; )
        r += this.elementLayout.getSpan(t, n + r), ++s;
    }
    return r;
  }
  /** @override */
  decode(t, n = 0) {
    const r = [];
    let i = 0, s = this.count;
    for (s instanceof Ie && (s = s.decode(t, n)); i < s; )
      r.push(this.elementLayout.decode(t, n)), n += this.elementLayout.getSpan(t, n), i += 1;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, r = 0) {
    const i = this.elementLayout, s = t.reduce((o, u) => o + i.encode(u, n, r + o), 0);
    return this.count instanceof Ie && this.count.encode(t.length, n, r), s;
  }
}
k.Sequence = ec;
class nc extends It {
  constructor(t, n, r) {
    if (!(Array.isArray(t) && t.reduce((s, o) => s && o instanceof It, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof n == "boolean" && r === void 0 && (r = n, n = void 0);
    for (const s of t)
      if (0 > s.span && s.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = t.reduce((s, o) => s + o.getSpan(), 0);
    } catch {
    }
    super(i, n), this.fields = t, this.decodePrefixes = !!r;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0;
    try {
      r = this.fields.reduce((i, s) => {
        const o = s.getSpan(t, n);
        return n += o, i + o;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return r;
  }
  /** @override */
  decode(t, n = 0) {
    cr(t);
    const r = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (r[i.property] = i.decode(t, n)), n += i.getSpan(t, n), this.decodePrefixes && t.length === n)
        break;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(t, n, r = 0) {
    const i = r;
    let s = 0, o = 0;
    for (const u of this.fields) {
      let d = u.span;
      if (o = 0 < d ? d : 0, u.property !== void 0) {
        const m = t[u.property];
        m !== void 0 && (o = u.encode(m, n, r), 0 > d && (d = u.getSpan(n, r)));
      }
      s = r, r += d;
    }
    return s + o - i;
  }
  /** @override */
  fromArray(t) {
    const n = this.makeDestinationObject();
    for (const r of this.fields)
      r.property !== void 0 && 0 < t.length && (n[r.property] = t.shift());
    return n;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    let n = 0;
    for (const r of this.fields) {
      if (r.property === t)
        return n;
      0 > r.span ? n = -1 : 0 <= n && (n += r.span);
    }
  }
}
k.Structure = nc;
class so {
  constructor(t) {
    this.property = t;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(t, n) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(t, n, r) {
    throw new Error("UnionDiscriminator is abstract");
  }
}
k.UnionDiscriminator = so;
class ni extends so {
  constructor(t, n) {
    if (!(t instanceof Ie && t.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(n || t.property || "variant"), this.layout = t;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(t, n) {
    return this.layout.decode(t, n);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(t, n, r) {
    return this.layout.encode(t, n, r);
  }
}
k.UnionLayoutDiscriminator = ni;
class oo extends It {
  constructor(t, n, r) {
    let i;
    if (t instanceof Fe || t instanceof ze)
      i = new ni(new io(t));
    else if (t instanceof Ie && t.isCount())
      i = new ni(t);
    else if (t instanceof so)
      i = t;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (n === void 0 && (n = null), !(n === null || n instanceof It))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (n !== null) {
      if (0 > n.span)
        throw new Error("defaultLayout must have constant span");
      n.property === void 0 && (n = n.replicate("content"));
    }
    let s = -1;
    n && (s = n.span, 0 <= s && (t instanceof Fe || t instanceof ze) && (s += i.layout.span)), super(s, r), this.discriminator = i, this.usesPrefixDiscriminator = t instanceof Fe || t instanceof ze, this.defaultLayout = n, this.registry = {};
    let o = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(u) {
      return o(u);
    }, this.configGetSourceVariant = function(u) {
      o = u.bind(this);
    };
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    const r = this.getVariant(t, n);
    if (!r)
      throw new Error("unable to determine span for unrecognized variant");
    return r.getSpan(t, n);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(t) {
    if (Object.prototype.hasOwnProperty.call(t, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(t, this.defaultLayout.property))
        return;
      const n = this.registry[t[this.discriminator.property]];
      if (n && (!n.layout || n.property && Object.prototype.hasOwnProperty.call(t, n.property)))
        return n;
    } else
      for (const n in this.registry) {
        const r = this.registry[n];
        if (r.property && Object.prototype.hasOwnProperty.call(t, r.property))
          return r;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(t, n = 0) {
    let r;
    const i = this.discriminator, s = i.decode(t, n), o = this.registry[s];
    if (o === void 0) {
      const u = this.defaultLayout;
      let d = 0;
      this.usesPrefixDiscriminator && (d = i.layout.span), r = this.makeDestinationObject(), r[i.property] = s, r[u.property] = u.decode(t, n + d);
    } else
      r = o.decode(t, n);
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(t, n, r = 0) {
    const i = this.getSourceVariant(t);
    if (i === void 0) {
      const s = this.discriminator, o = this.defaultLayout;
      let u = 0;
      return this.usesPrefixDiscriminator && (u = s.layout.span), s.encode(t[s.property], n, r), u + o.encode(t[o.property], n, r + u);
    }
    return i.encode(t, n, r);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(t, n, r) {
    const i = new rc(this, t, n, r);
    return this.registry[t] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(t, n = 0) {
    let r;
    return t instanceof Uint8Array ? r = this.discriminator.decode(t, n) : r = t, this.registry[r];
  }
}
k.Union = oo;
class rc extends It {
  constructor(t, n, r, i) {
    if (!(t instanceof oo))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(n) || 0 > n)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof r == "string" && i === void 0 && (i = r, r = null), r) {
      if (!(r instanceof It))
        throw new TypeError("layout must be a Layout");
      if (t.defaultLayout !== null && 0 <= r.span && r.span > t.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let s = t.span;
    0 > t.span && (s = r ? r.span : 0, 0 <= s && t.usesPrefixDiscriminator && (s += t.discriminator.layout.span)), super(s, i), this.union = t, this.variant = n, this.layout = r || null;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0;
    this.union.usesPrefixDiscriminator && (r = this.union.discriminator.layout.span);
    let i = 0;
    return this.layout && (i = this.layout.getSpan(t, n + r)), r + i;
  }
  /** @override */
  decode(t, n = 0) {
    const r = this.makeDestinationObject();
    if (this !== this.union.getVariant(t, n))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? r[this.property] = this.layout.decode(t, n + i) : this.property ? r[this.property] = !0 : this.union.usesPrefixDiscriminator && (r[this.union.discriminator.property] = this.variant), r;
  }
  /** @override */
  encode(t, n, r = 0) {
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(t, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, n, r);
    let s = i;
    if (this.layout && (this.layout.encode(t[this.property], n, r + i), s += this.layout.getSpan(n, r + i), 0 <= this.union.span && s > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return s;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(t) {
    if (this.layout)
      return this.layout.fromArray(t);
  }
}
k.VariantLayout = rc;
function Gn(e) {
  return 0 > e && (e += 4294967296), e;
}
class ao extends It {
  constructor(t, n, r) {
    if (!(t instanceof Fe || t instanceof ze))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof n == "string" && r === void 0 && (r = n, n = !1), 4 < t.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(t.span, r), this.word = t, this.msb = !!n, this.fields = [];
    let i = 0;
    this._packedSetValue = function(s) {
      return i = Gn(s), this;
    }, this._packedGetValue = function() {
      return i;
    };
  }
  /** @override */
  decode(t, n = 0) {
    const r = this.makeDestinationObject(), i = this.word.decode(t, n);
    this._packedSetValue(i);
    for (const s of this.fields)
      s.property !== void 0 && (r[s.property] = s.decode(t));
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(t, n, r = 0) {
    const i = this.word.decode(n, r);
    this._packedSetValue(i);
    for (const s of this.fields)
      if (s.property !== void 0) {
        const o = t[s.property];
        o !== void 0 && s.encode(o);
      }
    return this.word.encode(this._packedGetValue(), n, r);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(t, n) {
    const r = new uo(this, t, n);
    return this.fields.push(r), r;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(t) {
    const n = new ic(this, t);
    return this.fields.push(n), n;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
}
k.BitStructure = ao;
class uo {
  constructor(t, n, r) {
    if (!(t instanceof ao))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(n) || 0 >= n)
      throw new TypeError("bits must be positive integer");
    const i = 8 * t.span, s = t.fields.reduce((o, u) => o + u.bits, 0);
    if (n + s > i)
      throw new Error("bits too long for span remainder (" + (i - s) + " of " + i + " remain)");
    this.container = t, this.bits = n, this.valueMask = (1 << n) - 1, n === 32 && (this.valueMask = 4294967295), this.start = s, this.container.msb && (this.start = i - s - n), this.wordMask = Gn(this.valueMask << this.start), this.property = r;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(t, n) {
    const r = this.container._packedGetValue();
    return Gn(r & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(t) {
    if (typeof t != "number" || !Number.isInteger(t) || t !== Gn(t & this.valueMask))
      throw new TypeError(ro("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const n = this.container._packedGetValue(), r = Gn(t << this.start);
    this.container._packedSetValue(Gn(n & ~this.wordMask) | r);
  }
}
k.BitField = uo;
let ic = class extends uo {
  constructor(t, n) {
    super(t, 1, n);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(t, n) {
    return !!super.decode(t, n);
  }
  /** @override */
  encode(t) {
    typeof t == "boolean" && (t = +t), super.encode(t);
  }
};
k.Boolean = ic;
class sc extends It {
  constructor(t, n) {
    if (!(t instanceof Ie && t.isCount() || Number.isInteger(t) && 0 <= t))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let r = -1;
    t instanceof Ie || (r = t), super(r, n), this.length = t;
  }
  /** @override */
  getSpan(t, n) {
    let r = this.span;
    return 0 > r && (r = this.length.decode(t, n)), r;
  }
  /** @override */
  decode(t, n = 0) {
    let r = this.span;
    return 0 > r && (r = this.length.decode(t, n)), bt(t).slice(n, n + r);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, r) {
    let i = this.length;
    if (this.length instanceof Ie && (i = t.length), !(t instanceof Uint8Array && i === t.length))
      throw new TypeError(ro("Blob.encode", this) + " requires (length " + i + ") Uint8Array as src");
    if (r + i > n.length)
      throw new RangeError("encoding overruns Uint8Array");
    const s = bt(t);
    return bt(n).write(s.toString("hex"), r, i, "hex"), this.length instanceof Ie && this.length.encode(i, n, r), i;
  }
}
k.Blob = sc;
class oc extends It {
  constructor(t) {
    super(-1, t);
  }
  /** @override */
  getSpan(t, n = 0) {
    cr(t);
    let r = n;
    for (; r < t.length && t[r] !== 0; )
      r += 1;
    return 1 + r - n;
  }
  /** @override */
  decode(t, n = 0) {
    const r = this.getSpan(t, n);
    return bt(t).slice(n, n + r - 1).toString("utf-8");
  }
  /** @override */
  encode(t, n, r = 0) {
    typeof t != "string" && (t = String(t));
    const i = no.Buffer.from(t, "utf8"), s = i.length;
    if (r + s > n.length)
      throw new RangeError("encoding overruns Buffer");
    const o = bt(n);
    return i.copy(o, r), o[r + s] = 0, s + 1;
  }
}
k.CString = oc;
class ac extends It {
  constructor(t, n) {
    if (typeof t == "string" && n === void 0 && (n = t, t = void 0), t === void 0)
      t = -1;
    else if (!Number.isInteger(t))
      throw new TypeError("maxSpan must be an integer");
    super(-1, n), this.maxSpan = t;
  }
  /** @override */
  getSpan(t, n = 0) {
    return cr(t), t.length - n;
  }
  /** @override */
  decode(t, n = 0) {
    const r = this.getSpan(t, n);
    if (0 <= this.maxSpan && this.maxSpan < r)
      throw new RangeError("text length exceeds maxSpan");
    return bt(t).slice(n, n + r).toString("utf-8");
  }
  /** @override */
  encode(t, n, r = 0) {
    typeof t != "string" && (t = String(t));
    const i = no.Buffer.from(t, "utf8"), s = i.length;
    if (0 <= this.maxSpan && this.maxSpan < s)
      throw new RangeError("text length exceeds maxSpan");
    if (r + s > n.length)
      throw new RangeError("encoding overruns Buffer");
    return i.copy(bt(n), r), s;
  }
}
k.UTF8 = ac;
class uc extends It {
  constructor(t, n) {
    super(0, n), this.value = t;
  }
  /** @override */
  decode(t, n) {
    return this.value;
  }
  /** @override */
  encode(t, n, r) {
    return 0;
  }
}
k.Constant = uc;
k.greedy = (e, t) => new ju(e, t);
var Cn = k.offset = (e, t, n) => new io(e, t, n), ae = k.u8 = (e) => new Fe(1, e), ke = k.u16 = (e) => new Fe(2, e);
k.u24 = (e) => new Fe(3, e);
var tt = k.u32 = (e) => new Fe(4, e);
k.u40 = (e) => new Fe(5, e);
k.u48 = (e) => new Fe(6, e);
var de = k.nu64 = (e) => new Zu(e);
k.u16be = (e) => new ze(2, e);
k.u24be = (e) => new ze(3, e);
k.u32be = (e) => new ze(4, e);
k.u40be = (e) => new ze(5, e);
k.u48be = (e) => new ze(6, e);
k.nu64be = (e) => new Ku(e);
k.s8 = (e) => new Nn(1, e);
k.s16 = (e) => new Nn(2, e);
k.s24 = (e) => new Nn(3, e);
k.s32 = (e) => new Nn(4, e);
k.s40 = (e) => new Nn(5, e);
k.s48 = (e) => new Nn(6, e);
var Se = k.ns64 = (e) => new Yu(e);
k.s16be = (e) => new fr(2, e);
k.s24be = (e) => new fr(3, e);
k.s32be = (e) => new fr(4, e);
k.s40be = (e) => new fr(5, e);
k.s48be = (e) => new fr(6, e);
k.ns64be = (e) => new Ju(e);
k.f32 = (e) => new Xu(e);
k.f32be = (e) => new Wu(e);
k.f64 = (e) => new $u(e);
k.f64be = (e) => new tc(e);
var et = k.struct = (e, t, n) => new nc(e, t, n);
k.bits = (e, t, n) => new ao(e, t, n);
var Bn = k.seq = (e, t, n) => new ec(e, t, n);
k.union = (e, t, n) => new oo(e, t, n);
k.unionLayoutDiscriminator = (e, t) => new ni(e, t);
var rr = k.blob = (e, t) => new sc(e, t);
k.cstr = (e) => new oc(e);
k.utf8 = (e, t) => new ac(e, t);
k.constant = (e, t) => new uc(e, t);
var Cr = {};
Object.defineProperty(Cr, "__esModule", { value: !0 });
function tp(e) {
  {
    const t = Buffer.from(e);
    t.reverse();
    const n = t.toString("hex");
    return n.length === 0 ? BigInt(0) : BigInt(`0x${n}`);
  }
}
var ep = Cr.toBigIntLE = tp;
function np(e) {
  {
    const t = e.toString("hex");
    return t.length === 0 ? BigInt(0) : BigInt(`0x${t}`);
  }
}
Cr.toBigIntBE = np;
function rp(e, t) {
  {
    const n = e.toString(16), r = Buffer.from(n.padStart(t * 2, "0").slice(0, t * 2), "hex");
    return r.reverse(), r;
  }
}
var ip = Cr.toBufferLE = rp;
function sp(e, t) {
  {
    const n = e.toString(16);
    return Buffer.from(n.padStart(t * 2, "0").slice(0, t * 2), "hex");
  }
}
Cr.toBufferBE = sp;
class op extends TypeError {
  constructor(t, n) {
    let r;
    const {
      message: i,
      ...s
    } = t, {
      path: o
    } = t, u = o.length === 0 ? i : "At path: " + o.join(".") + " -- " + i;
    super(u), Object.assign(this, s), this.name = this.constructor.name, this.failures = () => {
      var d;
      return (d = r) != null ? d : r = [t, ...n()];
    };
  }
}
function ap(e) {
  return yn(e) && typeof e[Symbol.iterator] == "function";
}
function yn(e) {
  return typeof e == "object" && e != null;
}
function Ge(e) {
  return typeof e == "string" ? JSON.stringify(e) : "" + e;
}
function up(e) {
  const {
    done: t,
    value: n
  } = e.next();
  return t ? void 0 : n;
}
function cp(e, t, n, r) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = {
    message: e
  });
  const {
    path: i,
    branch: s
  } = t, {
    type: o
  } = n, {
    refinement: u,
    message: d = "Expected a value of type `" + o + "`" + (u ? " with refinement `" + u + "`" : "") + ", but received: `" + Ge(r) + "`"
  } = e;
  return {
    value: r,
    type: o,
    refinement: u,
    key: i[i.length - 1],
    path: i,
    branch: s,
    ...e,
    message: d
  };
}
function* sa(e, t, n, r) {
  ap(e) || (e = [e]);
  for (const i of e) {
    const s = cp(i, t, n, r);
    s && (yield s);
  }
}
function* co(e, t, n = {}) {
  const {
    path: r = [],
    branch: i = [e],
    coerce: s = !1,
    mask: o = !1
  } = n, u = {
    path: r,
    branch: i
  };
  if (s && (e = t.coercer(e, u), o && t.type !== "type" && yn(t.schema) && yn(e) && !Array.isArray(e)))
    for (const m in e)
      t.schema[m] === void 0 && delete e[m];
  let d = !0;
  for (const m of t.validator(e, u))
    d = !1, yield [m, void 0];
  for (let [m, w, B] of t.entries(e, u)) {
    const S = co(w, B, {
      path: m === void 0 ? r : [...r, m],
      branch: m === void 0 ? i : [...i, w],
      coerce: s,
      mask: o
    });
    for (const T of S)
      T[0] ? (d = !1, yield [T[0], void 0]) : s && (w = T[1], m === void 0 ? e = w : e instanceof Map ? e.set(m, w) : e instanceof Set ? e.add(w) : yn(e) && (e[m] = w));
  }
  if (d)
    for (const m of t.refiner(e, u))
      d = !1, yield [m, void 0];
  d && (yield [void 0, e]);
}
let Xe = class {
  constructor(t) {
    const {
      type: n,
      schema: r,
      validator: i,
      refiner: s,
      coercer: o = (d) => d,
      entries: u = function* () {
      }
    } = t;
    this.type = n, this.schema = r, this.entries = u, this.coercer = o, i ? this.validator = (d, m) => {
      const w = i(d, m);
      return sa(w, m, this, d);
    } : this.validator = () => [], s ? this.refiner = (d, m) => {
      const w = s(d, m);
      return sa(w, m, this, d);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t) {
    return fp(t, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t) {
    return Br(t, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return cc(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(t) {
    return lp(t, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(t, n = {}) {
    return Tr(t, this, n);
  }
};
function fp(e, t) {
  const n = Tr(e, t);
  if (n[0])
    throw n[0];
}
function Br(e, t) {
  const n = Tr(e, t, {
    coerce: !0
  });
  if (n[0])
    throw n[0];
  return n[1];
}
function lp(e, t) {
  const n = Tr(e, t, {
    coerce: !0,
    mask: !0
  });
  if (n[0])
    throw n[0];
  return n[1];
}
function cc(e, t) {
  return !Tr(e, t)[0];
}
function Tr(e, t, n = {}) {
  const r = co(e, t, n), i = up(r);
  return i[0] ? [new op(i[0], function* () {
    for (const o of r)
      o[0] && (yield o[0]);
  }), void 0] : [void 0, i[1]];
}
function Dn(e, t) {
  return new Xe({
    type: e,
    schema: null,
    validator: t
  });
}
function hp() {
  return Dn("any", () => !0);
}
function X(e) {
  return new Xe({
    type: "array",
    schema: e,
    *entries(t) {
      if (e && Array.isArray(t))
        for (const [n, r] of t.entries())
          yield [n, r, e];
    },
    coercer(t) {
      return Array.isArray(t) ? t.slice() : t;
    },
    validator(t) {
      return Array.isArray(t) || "Expected an array value, but received: " + Ge(t);
    }
  });
}
function Ke() {
  return Dn("boolean", (e) => typeof e == "boolean");
}
function fo(e) {
  return Dn("instance", (t) => t instanceof e || "Expected a `" + e.name + "` instance, but received: " + Ge(t));
}
function zt(e) {
  const t = Ge(e), n = typeof e;
  return new Xe({
    type: "literal",
    schema: n === "string" || n === "number" || n === "boolean" ? e : null,
    validator(r) {
      return r === e || "Expected the literal `" + t + "`, but received: " + Ge(r);
    }
  });
}
function dp() {
  return Dn("never", () => !1);
}
function J(e) {
  return new Xe({
    ...e,
    validator: (t, n) => t === null || e.validator(t, n),
    refiner: (t, n) => t === null || e.refiner(t, n)
  });
}
function D() {
  return Dn("number", (e) => typeof e == "number" && !isNaN(e) || "Expected a number, but received: " + Ge(e));
}
function it(e) {
  return new Xe({
    ...e,
    validator: (t, n) => t === void 0 || e.validator(t, n),
    refiner: (t, n) => t === void 0 || e.refiner(t, n)
  });
}
function fc(e, t) {
  return new Xe({
    type: "record",
    schema: null,
    *entries(n) {
      if (yn(n))
        for (const r in n) {
          const i = n[r];
          yield [r, r, e], yield [r, i, t];
        }
    },
    validator(n) {
      return yn(n) || "Expected an object, but received: " + Ge(n);
    }
  });
}
function j() {
  return Dn("string", (e) => typeof e == "string" || "Expected a string, but received: " + Ge(e));
}
function lo(e) {
  const t = dp();
  return new Xe({
    type: "tuple",
    schema: null,
    *entries(n) {
      if (Array.isArray(n)) {
        const r = Math.max(e.length, n.length);
        for (let i = 0; i < r; i++)
          yield [i, n[i], e[i] || t];
      }
    },
    validator(n) {
      return Array.isArray(n) || "Expected an array, but received: " + Ge(n);
    }
  });
}
function H(e) {
  const t = Object.keys(e);
  return new Xe({
    type: "type",
    schema: e,
    *entries(n) {
      if (yn(n))
        for (const r of t)
          yield [r, n[r], e[r]];
    },
    validator(n) {
      return yn(n) || "Expected an object, but received: " + Ge(n);
    }
  });
}
function Ce(e) {
  const t = e.map((n) => n.type).join(" | ");
  return new Xe({
    type: "union",
    schema: null,
    validator(n, r) {
      const i = [];
      for (const s of e) {
        const [...o] = co(n, s, r), [u] = o;
        if (u[0])
          for (const [d] of o)
            d && i.push(d);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + t + "`, but received: " + Ge(n), ...i];
    }
  });
}
function Sr() {
  return Dn("unknown", () => !0);
}
function Ur(e, t, n) {
  return new Xe({
    ...e,
    coercer: (r, i) => cc(r, t) ? e.coercer(n(r, i), i) : e.coercer(r, i)
  });
}
var Hr, pp = new Uint8Array(16);
function lc() {
  if (!Hr && (Hr = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Hr))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Hr(pp);
}
const yp = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function yi(e) {
  return typeof e == "string" && yp.test(e);
}
var he = [];
for (var is = 0; is < 256; ++is)
  he.push((is + 256).toString(16).substr(1));
function mi(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (he[e[t + 0]] + he[e[t + 1]] + he[e[t + 2]] + he[e[t + 3]] + "-" + he[e[t + 4]] + he[e[t + 5]] + "-" + he[e[t + 6]] + he[e[t + 7]] + "-" + he[e[t + 8]] + he[e[t + 9]] + "-" + he[e[t + 10]] + he[e[t + 11]] + he[e[t + 12]] + he[e[t + 13]] + he[e[t + 14]] + he[e[t + 15]]).toLowerCase();
  if (!yi(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
var oa, ss, os = 0, as = 0;
function mp(e, t, n) {
  var r = t && n || 0, i = t || new Array(16);
  e = e || {};
  var s = e.node || oa, o = e.clockseq !== void 0 ? e.clockseq : ss;
  if (s == null || o == null) {
    var u = e.random || (e.rng || lc)();
    s == null && (s = oa = [u[0] | 1, u[1], u[2], u[3], u[4], u[5]]), o == null && (o = ss = (u[6] << 8 | u[7]) & 16383);
  }
  var d = e.msecs !== void 0 ? e.msecs : Date.now(), m = e.nsecs !== void 0 ? e.nsecs : as + 1, w = d - os + (m - as) / 1e4;
  if (w < 0 && e.clockseq === void 0 && (o = o + 1 & 16383), (w < 0 || d > os) && e.nsecs === void 0 && (m = 0), m >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  os = d, as = m, ss = o, d += 122192928e5;
  var B = ((d & 268435455) * 1e4 + m) % 4294967296;
  i[r++] = B >>> 24 & 255, i[r++] = B >>> 16 & 255, i[r++] = B >>> 8 & 255, i[r++] = B & 255;
  var S = d / 4294967296 * 1e4 & 268435455;
  i[r++] = S >>> 8 & 255, i[r++] = S & 255, i[r++] = S >>> 24 & 15 | 16, i[r++] = S >>> 16 & 255, i[r++] = o >>> 8 | 128, i[r++] = o & 255;
  for (var T = 0; T < 6; ++T)
    i[r + T] = s[T];
  return t || mi(i);
}
function hc(e) {
  if (!yi(e))
    throw TypeError("Invalid UUID");
  var t, n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = t & 255, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = t & 255, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = t & 255, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = t & 255, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = t & 255, n;
}
function gp(e) {
  e = unescape(encodeURIComponent(e));
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(e.charCodeAt(n));
  return t;
}
var wp = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", bp = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function dc(e, t, n) {
  function r(i, s, o, u) {
    if (typeof i == "string" && (i = gp(i)), typeof s == "string" && (s = hc(s)), s.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var d = new Uint8Array(16 + i.length);
    if (d.set(s), d.set(i, s.length), d = n(d), d[6] = d[6] & 15 | t, d[8] = d[8] & 63 | 128, o) {
      u = u || 0;
      for (var m = 0; m < 16; ++m)
        o[u + m] = d[m];
      return o;
    }
    return mi(d);
  }
  try {
    r.name = e;
  } catch {
  }
  return r.DNS = wp, r.URL = bp, r;
}
function Ap(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var n = 0; n < t.length; ++n)
      e[n] = t.charCodeAt(n);
  }
  return xp(Ep(vp(e), e.length * 8));
}
function xp(e) {
  for (var t = [], n = e.length * 32, r = "0123456789abcdef", i = 0; i < n; i += 8) {
    var s = e[i >> 5] >>> i % 32 & 255, o = parseInt(r.charAt(s >>> 4 & 15) + r.charAt(s & 15), 16);
    t.push(o);
  }
  return t;
}
function pc(e) {
  return (e + 64 >>> 9 << 4) + 14 + 1;
}
function Ep(e, t) {
  e[t >> 5] |= 128 << t % 32, e[pc(t) - 1] = t;
  for (var n = 1732584193, r = -271733879, i = -1732584194, s = 271733878, o = 0; o < e.length; o += 16) {
    var u = n, d = r, m = i, w = s;
    n = me(n, r, i, s, e[o], 7, -680876936), s = me(s, n, r, i, e[o + 1], 12, -389564586), i = me(i, s, n, r, e[o + 2], 17, 606105819), r = me(r, i, s, n, e[o + 3], 22, -1044525330), n = me(n, r, i, s, e[o + 4], 7, -176418897), s = me(s, n, r, i, e[o + 5], 12, 1200080426), i = me(i, s, n, r, e[o + 6], 17, -1473231341), r = me(r, i, s, n, e[o + 7], 22, -45705983), n = me(n, r, i, s, e[o + 8], 7, 1770035416), s = me(s, n, r, i, e[o + 9], 12, -1958414417), i = me(i, s, n, r, e[o + 10], 17, -42063), r = me(r, i, s, n, e[o + 11], 22, -1990404162), n = me(n, r, i, s, e[o + 12], 7, 1804603682), s = me(s, n, r, i, e[o + 13], 12, -40341101), i = me(i, s, n, r, e[o + 14], 17, -1502002290), r = me(r, i, s, n, e[o + 15], 22, 1236535329), n = ge(n, r, i, s, e[o + 1], 5, -165796510), s = ge(s, n, r, i, e[o + 6], 9, -1069501632), i = ge(i, s, n, r, e[o + 11], 14, 643717713), r = ge(r, i, s, n, e[o], 20, -373897302), n = ge(n, r, i, s, e[o + 5], 5, -701558691), s = ge(s, n, r, i, e[o + 10], 9, 38016083), i = ge(i, s, n, r, e[o + 15], 14, -660478335), r = ge(r, i, s, n, e[o + 4], 20, -405537848), n = ge(n, r, i, s, e[o + 9], 5, 568446438), s = ge(s, n, r, i, e[o + 14], 9, -1019803690), i = ge(i, s, n, r, e[o + 3], 14, -187363961), r = ge(r, i, s, n, e[o + 8], 20, 1163531501), n = ge(n, r, i, s, e[o + 13], 5, -1444681467), s = ge(s, n, r, i, e[o + 2], 9, -51403784), i = ge(i, s, n, r, e[o + 7], 14, 1735328473), r = ge(r, i, s, n, e[o + 12], 20, -1926607734), n = we(n, r, i, s, e[o + 5], 4, -378558), s = we(s, n, r, i, e[o + 8], 11, -2022574463), i = we(i, s, n, r, e[o + 11], 16, 1839030562), r = we(r, i, s, n, e[o + 14], 23, -35309556), n = we(n, r, i, s, e[o + 1], 4, -1530992060), s = we(s, n, r, i, e[o + 4], 11, 1272893353), i = we(i, s, n, r, e[o + 7], 16, -155497632), r = we(r, i, s, n, e[o + 10], 23, -1094730640), n = we(n, r, i, s, e[o + 13], 4, 681279174), s = we(s, n, r, i, e[o], 11, -358537222), i = we(i, s, n, r, e[o + 3], 16, -722521979), r = we(r, i, s, n, e[o + 6], 23, 76029189), n = we(n, r, i, s, e[o + 9], 4, -640364487), s = we(s, n, r, i, e[o + 12], 11, -421815835), i = we(i, s, n, r, e[o + 15], 16, 530742520), r = we(r, i, s, n, e[o + 2], 23, -995338651), n = be(n, r, i, s, e[o], 6, -198630844), s = be(s, n, r, i, e[o + 7], 10, 1126891415), i = be(i, s, n, r, e[o + 14], 15, -1416354905), r = be(r, i, s, n, e[o + 5], 21, -57434055), n = be(n, r, i, s, e[o + 12], 6, 1700485571), s = be(s, n, r, i, e[o + 3], 10, -1894986606), i = be(i, s, n, r, e[o + 10], 15, -1051523), r = be(r, i, s, n, e[o + 1], 21, -2054922799), n = be(n, r, i, s, e[o + 8], 6, 1873313359), s = be(s, n, r, i, e[o + 15], 10, -30611744), i = be(i, s, n, r, e[o + 6], 15, -1560198380), r = be(r, i, s, n, e[o + 13], 21, 1309151649), n = be(n, r, i, s, e[o + 4], 6, -145523070), s = be(s, n, r, i, e[o + 11], 10, -1120210379), i = be(i, s, n, r, e[o + 2], 15, 718787259), r = be(r, i, s, n, e[o + 9], 21, -343485551), n = pn(n, u), r = pn(r, d), i = pn(i, m), s = pn(s, w);
  }
  return [n, r, i, s];
}
function vp(e) {
  if (e.length === 0)
    return [];
  for (var t = e.length * 8, n = new Uint32Array(pc(t)), r = 0; r < t; r += 8)
    n[r >> 5] |= (e[r / 8] & 255) << r % 32;
  return n;
}
function pn(e, t) {
  var n = (e & 65535) + (t & 65535), r = (e >> 16) + (t >> 16) + (n >> 16);
  return r << 16 | n & 65535;
}
function Bp(e, t) {
  return e << t | e >>> 32 - t;
}
function gi(e, t, n, r, i, s) {
  return pn(Bp(pn(pn(t, e), pn(r, s)), i), n);
}
function me(e, t, n, r, i, s, o) {
  return gi(t & n | ~t & r, e, t, i, s, o);
}
function ge(e, t, n, r, i, s, o) {
  return gi(t & r | n & ~r, e, t, i, s, o);
}
function we(e, t, n, r, i, s, o) {
  return gi(t ^ n ^ r, e, t, i, s, o);
}
function be(e, t, n, r, i, s, o) {
  return gi(n ^ (t | ~r), e, t, i, s, o);
}
var Ip = dc("v3", 48, Ap);
const Mp = Ip;
function Cp(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || lc)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (var i = 0; i < 16; ++i)
      t[n + i] = r[i];
    return t;
  }
  return mi(r);
}
function Tp(e, t, n, r) {
  switch (e) {
    case 0:
      return t & n ^ ~t & r;
    case 1:
      return t ^ n ^ r;
    case 2:
      return t & n ^ t & r ^ n & r;
    case 3:
      return t ^ n ^ r;
  }
}
function us(e, t) {
  return e << t | e >>> 32 - t;
}
function Sp(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var r = unescape(encodeURIComponent(e));
    e = [];
    for (var i = 0; i < r.length; ++i)
      e.push(r.charCodeAt(i));
  } else
    Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var s = e.length / 4 + 2, o = Math.ceil(s / 16), u = new Array(o), d = 0; d < o; ++d) {
    for (var m = new Uint32Array(16), w = 0; w < 16; ++w)
      m[w] = e[d * 64 + w * 4] << 24 | e[d * 64 + w * 4 + 1] << 16 | e[d * 64 + w * 4 + 2] << 8 | e[d * 64 + w * 4 + 3];
    u[d] = m;
  }
  u[o - 1][14] = (e.length - 1) * 8 / Math.pow(2, 32), u[o - 1][14] = Math.floor(u[o - 1][14]), u[o - 1][15] = (e.length - 1) * 8 & 4294967295;
  for (var B = 0; B < o; ++B) {
    for (var S = new Uint32Array(80), T = 0; T < 16; ++T)
      S[T] = u[B][T];
    for (var O = 16; O < 80; ++O)
      S[O] = us(S[O - 3] ^ S[O - 8] ^ S[O - 14] ^ S[O - 16], 1);
    for (var U = n[0], R = n[1], P = n[2], G = n[3], L = n[4], Z = 0; Z < 80; ++Z) {
      var _ = Math.floor(Z / 20), z = us(U, 5) + Tp(_, R, P, G) + L + t[_] + S[Z] >>> 0;
      L = G, G = P, P = us(R, 30) >>> 0, R = U, U = z;
    }
    n[0] = n[0] + U >>> 0, n[1] = n[1] + R >>> 0, n[2] = n[2] + P >>> 0, n[3] = n[3] + G >>> 0, n[4] = n[4] + L >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, n[0] & 255, n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, n[1] & 255, n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, n[2] & 255, n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, n[3] & 255, n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, n[4] & 255];
}
var Up = dc("v5", 80, Sp);
const Rp = Up, Np = "00000000-0000-0000-0000-000000000000";
function Dp(e) {
  if (!yi(e))
    throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}
const kp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: Np,
  parse: hc,
  stringify: mi,
  v1: mp,
  v3: Mp,
  v4: Cp,
  v5: Rp,
  validate: yi,
  version: Dp
}, Symbol.toStringTag, { value: "Module" })), yc = /* @__PURE__ */ Vs(kp), Op = yc.v4, Fp = function(e, t, n, r) {
  if (typeof e != "string")
    throw new TypeError(e + " must be a string");
  r = r || {};
  const i = typeof r.version == "number" ? r.version : 2;
  if (i !== 1 && i !== 2)
    throw new TypeError(i + " must be 1 or 2");
  const s = {
    method: e
  };
  if (i === 2 && (s.jsonrpc = "2.0"), t) {
    if (typeof t != "object" && !Array.isArray(t))
      throw new TypeError(t + " must be an object, array or omitted");
    s.params = t;
  }
  if (typeof n > "u") {
    const o = typeof r.generator == "function" ? r.generator : function() {
      return Op();
    };
    s.id = o(s, r);
  } else
    i === 2 && n === null ? r.notificationIdNull && (s.id = null) : s.id = n;
  return s;
};
var Lp = Fp;
const Pp = yc.v4, _p = Lp, ri = function(e, t) {
  if (!(this instanceof ri))
    return new ri(e, t);
  t || (t = {}), this.options = {
    reviver: typeof t.reviver < "u" ? t.reviver : null,
    replacer: typeof t.replacer < "u" ? t.replacer : null,
    generator: typeof t.generator < "u" ? t.generator : function() {
      return Pp();
    },
    version: typeof t.version < "u" ? t.version : 2,
    notificationIdNull: typeof t.notificationIdNull == "boolean" ? t.notificationIdNull : !1
  }, this.callServer = e;
};
ri.prototype.request = function(e, t, n, r) {
  const i = this;
  let s = null;
  const o = Array.isArray(e) && typeof t == "function";
  if (this.options.version === 1 && o)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (o || !o && e && typeof e == "object" && typeof t == "function")
    r = t, s = e;
  else {
    typeof n == "function" && (r = n, n = void 0);
    const m = typeof r == "function";
    try {
      s = _p(e, t, n, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (w) {
      if (m)
        return r(w);
      throw w;
    }
    if (!m)
      return s;
  }
  let d;
  try {
    d = JSON.stringify(s, this.options.replacer);
  } catch (m) {
    return r(m);
  }
  return this.callServer(d, function(m, w) {
    i._parseResponse(m, w, r);
  }), s;
};
ri.prototype._parseResponse = function(e, t, n) {
  if (e) {
    n(e);
    return;
  }
  if (!t)
    return n();
  let r;
  try {
    r = JSON.parse(t, this.options.reviver);
  } catch (i) {
    return n(i);
  }
  if (n.length === 3)
    if (Array.isArray(r)) {
      const i = function(o) {
        return typeof o.error < "u";
      }, s = function(o) {
        return !i(o);
      };
      return n(null, r.filter(i), r.filter(s));
    } else
      return n(null, r.error, r.result);
  n(null, r);
};
var mc = {}, gc = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(d, m, w) {
    this.fn = d, this.context = m, this.once = w || !1;
  }
  function s(d, m, w, B, S) {
    if (typeof w != "function")
      throw new TypeError("The listener must be a function");
    var T = new i(w, B || d, S), O = n ? n + m : m;
    return d._events[O] ? d._events[O].fn ? d._events[O] = [d._events[O], T] : d._events[O].push(T) : (d._events[O] = T, d._eventsCount++), d;
  }
  function o(d, m) {
    --d._eventsCount === 0 ? d._events = new r() : delete d._events[m];
  }
  function u() {
    this._events = new r(), this._eventsCount = 0;
  }
  u.prototype.eventNames = function() {
    var m = [], w, B;
    if (this._eventsCount === 0)
      return m;
    for (B in w = this._events)
      t.call(w, B) && m.push(n ? B.slice(1) : B);
    return Object.getOwnPropertySymbols ? m.concat(Object.getOwnPropertySymbols(w)) : m;
  }, u.prototype.listeners = function(m) {
    var w = n ? n + m : m, B = this._events[w];
    if (!B)
      return [];
    if (B.fn)
      return [B.fn];
    for (var S = 0, T = B.length, O = new Array(T); S < T; S++)
      O[S] = B[S].fn;
    return O;
  }, u.prototype.listenerCount = function(m) {
    var w = n ? n + m : m, B = this._events[w];
    return B ? B.fn ? 1 : B.length : 0;
  }, u.prototype.emit = function(m, w, B, S, T, O) {
    var U = n ? n + m : m;
    if (!this._events[U])
      return !1;
    var R = this._events[U], P = arguments.length, G, L;
    if (R.fn) {
      switch (R.once && this.removeListener(m, R.fn, void 0, !0), P) {
        case 1:
          return R.fn.call(R.context), !0;
        case 2:
          return R.fn.call(R.context, w), !0;
        case 3:
          return R.fn.call(R.context, w, B), !0;
        case 4:
          return R.fn.call(R.context, w, B, S), !0;
        case 5:
          return R.fn.call(R.context, w, B, S, T), !0;
        case 6:
          return R.fn.call(R.context, w, B, S, T, O), !0;
      }
      for (L = 1, G = new Array(P - 1); L < P; L++)
        G[L - 1] = arguments[L];
      R.fn.apply(R.context, G);
    } else {
      var Z = R.length, _;
      for (L = 0; L < Z; L++)
        switch (R[L].once && this.removeListener(m, R[L].fn, void 0, !0), P) {
          case 1:
            R[L].fn.call(R[L].context);
            break;
          case 2:
            R[L].fn.call(R[L].context, w);
            break;
          case 3:
            R[L].fn.call(R[L].context, w, B);
            break;
          case 4:
            R[L].fn.call(R[L].context, w, B, S);
            break;
          default:
            if (!G)
              for (_ = 1, G = new Array(P - 1); _ < P; _++)
                G[_ - 1] = arguments[_];
            R[L].fn.apply(R[L].context, G);
        }
    }
    return !0;
  }, u.prototype.on = function(m, w, B) {
    return s(this, m, w, B, !1);
  }, u.prototype.once = function(m, w, B) {
    return s(this, m, w, B, !0);
  }, u.prototype.removeListener = function(m, w, B, S) {
    var T = n ? n + m : m;
    if (!this._events[T])
      return this;
    if (!w)
      return o(this, T), this;
    var O = this._events[T];
    if (O.fn)
      O.fn === w && (!S || O.once) && (!B || O.context === B) && o(this, T);
    else {
      for (var U = 0, R = [], P = O.length; U < P; U++)
        (O[U].fn !== w || S && !O[U].once || B && O[U].context !== B) && R.push(O[U]);
      R.length ? this._events[T] = R.length === 1 ? R[0] : R : o(this, T);
    }
    return this;
  }, u.prototype.removeAllListeners = function(m) {
    var w;
    return m ? (w = n ? n + m : m, this._events[w] && o(this, w)) : (this._events = new r(), this._eventsCount = 0), this;
  }, u.prototype.off = u.prototype.removeListener, u.prototype.addListener = u.prototype.on, u.prefixed = n, u.EventEmitter = u, e.exports = u;
})(gc);
var wc = gc.exports, ir = {};
Object.defineProperty(ir, "__esModule", { value: !0 });
ir.createError = ir.DefaultDataPack = void 0;
const zp = /* @__PURE__ */ new Map([
  [-32e3, "Event not provided"],
  [-32600, "Invalid Request"],
  [-32601, "Method not found"],
  [-32602, "Invalid params"],
  [-32603, "Internal error"],
  [-32604, "Params not found"],
  [-32605, "Method forbidden"],
  [-32606, "Event forbidden"],
  [-32700, "Parse error"]
]);
class Hp {
  encode(t) {
    return JSON.stringify(t);
  }
  decode(t) {
    return JSON.parse(t);
  }
}
ir.DefaultDataPack = Hp;
function Gp(e, t) {
  const n = {
    code: e,
    message: zp.get(e) || "Internal Server Error"
  };
  return t && (n.data = t), n;
}
ir.createError = Gp;
Object.defineProperty(mc, "__esModule", { value: !0 });
const Qp = wc, Vp = ir;
class qp extends Qp.EventEmitter {
  /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */
  constructor(n, r = "ws://localhost:8080", { autoconnect: i = !0, reconnect: s = !0, reconnect_interval: o = 1e3, max_reconnects: u = 5, ...d } = {}, m, w) {
    super();
    Mt(this, "address");
    Mt(this, "rpc_id");
    Mt(this, "queue");
    Mt(this, "options");
    Mt(this, "autoconnect");
    Mt(this, "ready");
    Mt(this, "reconnect");
    Mt(this, "reconnect_timer_id");
    Mt(this, "reconnect_interval");
    Mt(this, "max_reconnects");
    Mt(this, "rest_options");
    Mt(this, "current_reconnects");
    Mt(this, "generate_request_id");
    Mt(this, "socket");
    Mt(this, "webSocketFactory");
    Mt(this, "dataPack");
    this.webSocketFactory = n, this.queue = {}, this.rpc_id = 0, this.address = r, this.autoconnect = i, this.ready = !1, this.reconnect = s, this.reconnect_timer_id = void 0, this.reconnect_interval = o, this.max_reconnects = u, this.rest_options = d, this.current_reconnects = 0, this.generate_request_id = m || (() => ++this.rpc_id), w ? this.dataPack = w : this.dataPack = new Vp.DefaultDataPack(), this.autoconnect && this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */
  connect() {
    this.socket || this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Calls a registered RPC method on server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object|Array} params - optional method parameters
   * @param {Number} timeout - RPC reply timeout value
   * @param {Object} ws_opts - options passed to ws
   * @return {Promise}
   */
  call(n, r, i, s) {
    return !s && typeof i == "object" && (s = i, i = null), new Promise((o, u) => {
      if (!this.ready)
        return u(new Error("socket not ready"));
      const d = this.generate_request_id(n, r), m = {
        jsonrpc: "2.0",
        method: n,
        params: r || void 0,
        id: d
      };
      this.socket.send(this.dataPack.encode(m), s, (w) => {
        if (w)
          return u(w);
        this.queue[d] = { promise: [o, u] }, i && (this.queue[d].timeout = setTimeout(() => {
          delete this.queue[d], u(new Error("reply timeout"));
        }, i));
      });
    });
  }
  /**
   * Logins with the other side of the connection.
   * @method
   * @param {Object} params - Login credentials object
   * @return {Promise}
   */
  async login(n) {
    const r = await this.call("rpc.login", n);
    if (!r)
      throw new Error("authentication failed");
    return r;
  }
  /**
   * Fetches a list of client's methods registered on server.
   * @method
   * @return {Array}
   */
  async listMethods() {
    return await this.call("__listMethods");
  }
  /**
   * Sends a JSON-RPC 2.0 notification to server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object} params - optional method parameters
   * @return {Promise}
   */
  notify(n, r) {
    return new Promise((i, s) => {
      if (!this.ready)
        return s(new Error("socket not ready"));
      const o = {
        jsonrpc: "2.0",
        method: n,
        params: r
      };
      this.socket.send(this.dataPack.encode(o), (u) => {
        if (u)
          return s(u);
        i();
      });
    });
  }
  /**
   * Subscribes for a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async subscribe(n) {
    typeof n == "string" && (n = [n]);
    const r = await this.call("rpc.on", n);
    if (typeof n == "string" && r[n] !== "ok")
      throw new Error("Failed subscribing to an event '" + n + "' with: " + r[n]);
    return r;
  }
  /**
   * Unsubscribes from a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async unsubscribe(n) {
    typeof n == "string" && (n = [n]);
    const r = await this.call("rpc.off", n);
    if (typeof n == "string" && r[n] !== "ok")
      throw new Error("Failed unsubscribing from an event with: " + r);
    return r;
  }
  /**
   * Closes a WebSocket connection gracefully.
   * @method
   * @param {Number} code - socket close code
   * @param {String} data - optional data to be sent before closing
   * @return {Undefined}
   */
  close(n, r) {
    this.socket.close(n || 1e3, r);
  }
  /**
   * Enable / disable automatic reconnection.
   * @method
   * @param {Boolean} reconnect - enable / disable reconnection
   * @return {Undefined}
   */
  setAutoReconnect(n) {
    this.reconnect = n;
  }
  /**
   * Set the interval between reconnection attempts.
   * @method
   * @param {Number} interval - reconnection interval in milliseconds
   * @return {Undefined}
   */
  setReconnectInterval(n) {
    this.reconnect_interval = n;
  }
  /**
   * Set the maximum number of reconnection attempts.
   * @method
   * @param {Number} max_reconnects - maximum reconnection attempts
   * @return {Undefined}
   */
  setMaxReconnects(n) {
    this.max_reconnects = n;
  }
  /**
   * Connection/Message handler.
   * @method
   * @private
   * @param {String} address - WebSocket API address
   * @param {Object} options - ws options object
   * @return {Undefined}
   */
  _connect(n, r) {
    clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(n, r), this.socket.addEventListener("open", () => {
      this.ready = !0, this.emit("open"), this.current_reconnects = 0;
    }), this.socket.addEventListener("message", ({ data: i }) => {
      i instanceof ArrayBuffer && (i = Buffer.from(i).toString());
      try {
        i = this.dataPack.decode(i);
      } catch {
        return;
      }
      if (i.notification && this.listeners(i.notification).length) {
        if (!Object.keys(i.params).length)
          return this.emit(i.notification);
        const s = [i.notification];
        if (i.params.constructor === Object)
          s.push(i.params);
        else
          for (let o = 0; o < i.params.length; o++)
            s.push(i.params[o]);
        return Promise.resolve().then(() => {
          this.emit.apply(this, s);
        });
      }
      if (!this.queue[i.id])
        return i.method ? Promise.resolve().then(() => {
          this.emit(i.method, i == null ? void 0 : i.params);
        }) : void 0;
      "error" in i == "result" in i && this.queue[i.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), this.queue[i.id].timeout && clearTimeout(this.queue[i.id].timeout), i.error ? this.queue[i.id].promise[1](i.error) : this.queue[i.id].promise[0](i.result), delete this.queue[i.id];
    }), this.socket.addEventListener("error", (i) => this.emit("error", i)), this.socket.addEventListener("close", ({ code: i, reason: s }) => {
      this.ready && setTimeout(() => this.emit("close", i, s), 0), this.ready = !1, this.socket = void 0, i !== 1e3 && (this.current_reconnects++, this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0) && (this.reconnect_timer_id = setTimeout(() => this._connect(n, r), this.reconnect_interval)));
    });
  }
}
mc.default = qp;
var bc = {};
Object.defineProperty(bc, "__esModule", { value: !0 });
const jp = wc;
class Zp extends jp.EventEmitter {
  /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */
  constructor(n, r, i) {
    super();
    Mt(this, "socket");
    this.socket = new window.WebSocket(n, i), this.socket.onopen = () => this.emit("open"), this.socket.onmessage = (s) => this.emit("message", s.data), this.socket.onerror = (s) => this.emit("error", s), this.socket.onclose = (s) => {
      this.emit("close", s.code, s.reason);
    };
  }
  /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */
  send(n, r, i) {
    const s = i || r;
    try {
      this.socket.send(n), s();
    } catch (o) {
      s(o);
    }
  }
  /**
   * Closes an underlying socket
   * @method
   * @param {Number} code - status code explaining why the connection is being closed
   * @param {String} reason - a description why the connection is closing
   * @return {Undefined}
   * @throws {Error}
   */
  close(n, r) {
    this.socket.close(n, r);
  }
  addEventListener(n, r, i) {
    this.socket.addEventListener(n, r, i);
  }
}
function Kp(e, t) {
  return new Zp(e, t);
}
bc.default = Kp;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Yp(e) {
  const t = Js(e);
  ur(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: n, Fp: r, a: i } = t;
  if (n) {
    if (!r.eql(i, r.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: Jp, hexToBytes: Xp } = sd, In = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  _parseInt(e) {
    const { Err: t } = In;
    if (e.length < 2 || e[0] !== 2)
      throw new t("Invalid signature integer tag");
    const n = e[1], r = e.subarray(2, n + 2);
    if (!n || r.length !== n)
      throw new t("Invalid signature integer: wrong length");
    if (r[0] & 128)
      throw new t("Invalid signature integer: negative");
    if (r[0] === 0 && !(r[1] & 128))
      throw new t("Invalid signature integer: unnecessary leading zero");
    return { d: Jp(r), l: e.subarray(n + 2) };
  },
  toSig(e) {
    const { Err: t } = In, n = typeof e == "string" ? Xp(e) : e;
    Mr(n);
    let r = n.length;
    if (r < 2 || n[0] != 48)
      throw new t("Invalid signature tag");
    if (n[1] !== r - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: i, l: s } = In._parseInt(n.subarray(2)), { d: o, l: u } = In._parseInt(s);
    if (u.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: i, s: o };
  },
  hexFromSig(e) {
    const t = (m) => Number.parseInt(m[0], 16) & 8 ? "00" + m : m, n = (m) => {
      const w = m.toString(16);
      return w.length & 1 ? `0${w}` : w;
    }, r = t(n(e.s)), i = t(n(e.r)), s = r.length / 2, o = i.length / 2, u = n(s), d = n(o);
    return `30${n(o + s + 4)}02${d}${i}02${u}${r}`;
  }
}, nn = BigInt(0), De = BigInt(1);
BigInt(2);
const aa = BigInt(3);
BigInt(4);
function Wp(e) {
  const t = Yp(e), { Fp: n } = t, r = t.toBytes || ((O, U, R) => {
    const P = U.toAffine();
    return Rn(Uint8Array.from([4]), n.toBytes(P.x), n.toBytes(P.y));
  }), i = t.fromBytes || ((O) => {
    const U = O.subarray(1), R = n.fromBytes(U.subarray(0, n.BYTES)), P = n.fromBytes(U.subarray(n.BYTES, 2 * n.BYTES));
    return { x: R, y: P };
  });
  function s(O) {
    const { a: U, b: R } = t, P = n.sqr(O), G = n.mul(P, O);
    return n.add(n.add(G, n.mul(O, U)), R);
  }
  if (!n.eql(n.sqr(t.Gy), s(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function o(O) {
    return typeof O == "bigint" && nn < O && O < t.n;
  }
  function u(O) {
    if (!o(O))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function d(O) {
    const { allowedPrivateKeyLengths: U, nByteLength: R, wrapPrivateKey: P, n: G } = t;
    if (U && typeof O != "bigint") {
      if (Sn(O) && (O = Un(O)), typeof O != "string" || !U.includes(O.length))
        throw new Error("Invalid key");
      O = O.padStart(R * 2, "0");
    }
    let L;
    try {
      L = typeof O == "bigint" ? O : Mn(ue("private key", O, R));
    } catch {
      throw new Error(`private key must be ${R} bytes, hex or bigint, not ${typeof O}`);
    }
    return P && (L = Lt(L, G)), u(L), L;
  }
  const m = /* @__PURE__ */ new Map();
  function w(O) {
    if (!(O instanceof B))
      throw new Error("ProjectivePoint expected");
  }
  class B {
    constructor(U, R, P) {
      if (this.px = U, this.py = R, this.pz = P, U == null || !n.isValid(U))
        throw new Error("x required");
      if (R == null || !n.isValid(R))
        throw new Error("y required");
      if (P == null || !n.isValid(P))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(U) {
      const { x: R, y: P } = U || {};
      if (!U || !n.isValid(R) || !n.isValid(P))
        throw new Error("invalid affine point");
      if (U instanceof B)
        throw new Error("projective point not allowed");
      const G = (L) => n.eql(L, n.ZERO);
      return G(R) && G(P) ? B.ZERO : new B(R, P, n.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(U) {
      const R = n.invertBatch(U.map((P) => P.pz));
      return U.map((P, G) => P.toAffine(R[G])).map(B.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(U) {
      const R = B.fromAffine(i(ue("pointHex", U)));
      return R.assertValidity(), R;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(U) {
      return B.BASE.multiply(d(U));
    }
    // "Private method", don't use it directly
    _setWindowSize(U) {
      this._WINDOW_SIZE = U, m.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint && !n.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: U, y: R } = this.toAffine();
      if (!n.isValid(U) || !n.isValid(R))
        throw new Error("bad point: x or y not FE");
      const P = n.sqr(R), G = s(U);
      if (!n.eql(P, G))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: U } = this.toAffine();
      if (n.isOdd)
        return !n.isOdd(U);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(U) {
      w(U);
      const { px: R, py: P, pz: G } = this, { px: L, py: Z, pz: _ } = U, z = n.eql(n.mul(R, _), n.mul(L, G)), K = n.eql(n.mul(P, _), n.mul(Z, G));
      return z && K;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new B(this.px, n.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: U, b: R } = t, P = n.mul(R, aa), { px: G, py: L, pz: Z } = this;
      let _ = n.ZERO, z = n.ZERO, K = n.ZERO, Y = n.mul(G, G), dt = n.mul(L, L), ut = n.mul(Z, Z), W = n.mul(G, L);
      return W = n.add(W, W), K = n.mul(G, Z), K = n.add(K, K), _ = n.mul(U, K), z = n.mul(P, ut), z = n.add(_, z), _ = n.sub(dt, z), z = n.add(dt, z), z = n.mul(_, z), _ = n.mul(W, _), K = n.mul(P, K), ut = n.mul(U, ut), W = n.sub(Y, ut), W = n.mul(U, W), W = n.add(W, K), K = n.add(Y, Y), Y = n.add(K, Y), Y = n.add(Y, ut), Y = n.mul(Y, W), z = n.add(z, Y), ut = n.mul(L, Z), ut = n.add(ut, ut), Y = n.mul(ut, W), _ = n.sub(_, Y), K = n.mul(ut, dt), K = n.add(K, K), K = n.add(K, K), new B(_, z, K);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(U) {
      w(U);
      const { px: R, py: P, pz: G } = this, { px: L, py: Z, pz: _ } = U;
      let z = n.ZERO, K = n.ZERO, Y = n.ZERO;
      const dt = t.a, ut = n.mul(t.b, aa);
      let W = n.mul(R, L), Et = n.mul(P, Z), I = n.mul(G, _), a = n.add(R, P), h = n.add(L, Z);
      a = n.mul(a, h), h = n.add(W, Et), a = n.sub(a, h), h = n.add(R, G);
      let y = n.add(L, _);
      return h = n.mul(h, y), y = n.add(W, I), h = n.sub(h, y), y = n.add(P, G), z = n.add(Z, _), y = n.mul(y, z), z = n.add(Et, I), y = n.sub(y, z), Y = n.mul(dt, h), z = n.mul(ut, I), Y = n.add(z, Y), z = n.sub(Et, Y), Y = n.add(Et, Y), K = n.mul(z, Y), Et = n.add(W, W), Et = n.add(Et, W), I = n.mul(dt, I), h = n.mul(ut, h), Et = n.add(Et, I), I = n.sub(W, I), I = n.mul(dt, I), h = n.add(h, I), W = n.mul(Et, h), K = n.add(K, W), W = n.mul(y, h), z = n.mul(a, z), z = n.sub(z, W), W = n.mul(a, Et), Y = n.mul(y, Y), Y = n.add(Y, W), new B(z, K, Y);
    }
    subtract(U) {
      return this.add(U.negate());
    }
    is0() {
      return this.equals(B.ZERO);
    }
    wNAF(U) {
      return T.wNAFCached(this, m, U, (R) => {
        const P = n.invertBatch(R.map((G) => G.pz));
        return R.map((G, L) => G.toAffine(P[L])).map(B.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(U) {
      const R = B.ZERO;
      if (U === nn)
        return R;
      if (u(U), U === De)
        return this;
      const { endo: P } = t;
      if (!P)
        return T.unsafeLadder(this, U);
      let { k1neg: G, k1: L, k2neg: Z, k2: _ } = P.splitScalar(U), z = R, K = R, Y = this;
      for (; L > nn || _ > nn; )
        L & De && (z = z.add(Y)), _ & De && (K = K.add(Y)), Y = Y.double(), L >>= De, _ >>= De;
      return G && (z = z.negate()), Z && (K = K.negate()), K = new B(n.mul(K.px, P.beta), K.py, K.pz), z.add(K);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(U) {
      u(U);
      let R = U, P, G;
      const { endo: L } = t;
      if (L) {
        const { k1neg: Z, k1: _, k2neg: z, k2: K } = L.splitScalar(R);
        let { p: Y, f: dt } = this.wNAF(_), { p: ut, f: W } = this.wNAF(K);
        Y = T.constTimeNegate(Z, Y), ut = T.constTimeNegate(z, ut), ut = new B(n.mul(ut.px, L.beta), ut.py, ut.pz), P = Y.add(ut), G = dt.add(W);
      } else {
        const { p: Z, f: _ } = this.wNAF(R);
        P = Z, G = _;
      }
      return B.normalizeZ([P, G])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(U, R, P) {
      const G = B.BASE, L = (_, z) => z === nn || z === De || !_.equals(G) ? _.multiplyUnsafe(z) : _.multiply(z), Z = L(this, R).add(L(U, P));
      return Z.is0() ? void 0 : Z;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(U) {
      const { px: R, py: P, pz: G } = this, L = this.is0();
      U == null && (U = L ? n.ONE : n.inv(G));
      const Z = n.mul(R, U), _ = n.mul(P, U), z = n.mul(G, U);
      if (L)
        return { x: n.ZERO, y: n.ZERO };
      if (!n.eql(z, n.ONE))
        throw new Error("invZ was invalid");
      return { x: Z, y: _ };
    }
    isTorsionFree() {
      const { h: U, isTorsionFree: R } = t;
      if (U === De)
        return !0;
      if (R)
        return R(B, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: U, clearCofactor: R } = t;
      return U === De ? this : R ? R(B, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(U = !0) {
      return this.assertValidity(), r(B, this, U);
    }
    toHex(U = !0) {
      return Un(this.toRawBytes(U));
    }
  }
  B.BASE = new B(t.Gx, t.Gy, n.ONE), B.ZERO = new B(n.ZERO, n.ONE, n.ZERO);
  const S = t.nBitLength, T = ku(B, t.endo ? Math.ceil(S / 2) : S);
  return {
    CURVE: t,
    ProjectivePoint: B,
    normPrivateKeyToScalar: d,
    weierstrassEquation: s,
    isWithinCurveOrder: o
  };
}
function $p(e) {
  const t = Js(e);
  return ur(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function t1(e) {
  const t = $p(e), { Fp: n, n: r } = t, i = n.BYTES + 1, s = 2 * n.BYTES + 1;
  function o(h) {
    return nn < h && h < n.ORDER;
  }
  function u(h) {
    return Lt(h, r);
  }
  function d(h) {
    return Es(h, r);
  }
  const { ProjectivePoint: m, normPrivateKeyToScalar: w, weierstrassEquation: B, isWithinCurveOrder: S } = Wp({
    ...t,
    toBytes(h, y, E) {
      const b = y.toAffine(), x = n.toBytes(b.x), M = Rn;
      return E ? M(Uint8Array.from([y.hasEvenY() ? 2 : 3]), x) : M(Uint8Array.from([4]), x, n.toBytes(b.y));
    },
    fromBytes(h) {
      const y = h.length, E = h[0], b = h.subarray(1);
      if (y === i && (E === 2 || E === 3)) {
        const x = Mn(b);
        if (!o(x))
          throw new Error("Point is not on curve");
        const M = B(x);
        let g;
        try {
          g = n.sqrt(M);
        } catch (Q) {
          const V = Q instanceof Error ? ": " + Q.message : "";
          throw new Error("Point is not on curve" + V);
        }
        const f = (g & De) === De;
        return (E & 1) === 1 !== f && (g = n.neg(g)), { x, y: g };
      } else if (y === s && E === 4) {
        const x = n.fromBytes(b.subarray(0, n.BYTES)), M = n.fromBytes(b.subarray(n.BYTES, 2 * n.BYTES));
        return { x, y: M };
      } else
        throw new Error(`Point of length ${y} was invalid. Expected ${i} compressed bytes or ${s} uncompressed bytes`);
    }
  }), T = (h) => Un(er(h, t.nByteLength));
  function O(h) {
    const y = r >> De;
    return h > y;
  }
  function U(h) {
    return O(h) ? u(-h) : h;
  }
  const R = (h, y, E) => Mn(h.slice(y, E));
  class P {
    constructor(y, E, b) {
      this.r = y, this.s = E, this.recovery = b, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(y) {
      const E = t.nByteLength;
      return y = ue("compactSignature", y, E * 2), new P(R(y, 0, E), R(y, E, 2 * E));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(y) {
      const { r: E, s: b } = In.toSig(ue("DER", y));
      return new P(E, b);
    }
    assertValidity() {
      if (!S(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!S(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(y) {
      return new P(this.r, this.s, y);
    }
    recoverPublicKey(y) {
      const { r: E, s: b, recovery: x } = this, M = K(ue("msgHash", y));
      if (x == null || ![0, 1, 2, 3].includes(x))
        throw new Error("recovery id invalid");
      const g = x === 2 || x === 3 ? E + t.n : E;
      if (g >= n.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const f = x & 1 ? "03" : "02", v = m.fromHex(f + T(g)), Q = d(g), V = u(-M * Q), q = u(b * Q), nt = m.BASE.multiplyAndAddUnsafe(v, V, q);
      if (!nt)
        throw new Error("point at infinify");
      return nt.assertValidity(), nt;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return O(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new P(this.r, u(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return tr(this.toDERHex());
    }
    toDERHex() {
      return In.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return tr(this.toCompactHex());
    }
    toCompactHex() {
      return T(this.r) + T(this.s);
    }
  }
  const G = {
    isValidPrivateKey(h) {
      try {
        return w(h), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: w,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const h = Du(t.n);
      return md(t.randomBytes(h), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(h = 8, y = m.BASE) {
      return y._setWindowSize(h), y.multiply(BigInt(3)), y;
    }
  };
  function L(h, y = !0) {
    return m.fromPrivateKey(h).toRawBytes(y);
  }
  function Z(h) {
    const y = Sn(h), E = typeof h == "string", b = (y || E) && h.length;
    return y ? b === i || b === s : E ? b === 2 * i || b === 2 * s : h instanceof m;
  }
  function _(h, y, E = !0) {
    if (Z(h))
      throw new Error("first arg must be private key");
    if (!Z(y))
      throw new Error("second arg must be public key");
    return m.fromHex(y).multiply(w(h)).toRawBytes(E);
  }
  const z = t.bits2int || function(h) {
    const y = Mn(h), E = h.length * 8 - t.nBitLength;
    return E > 0 ? y >> BigInt(E) : y;
  }, K = t.bits2int_modN || function(h) {
    return u(z(h));
  }, Y = Ys(t.nBitLength);
  function dt(h) {
    if (typeof h != "bigint")
      throw new Error("bigint expected");
    if (!(nn <= h && h < Y))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return er(h, t.nByteLength);
  }
  function ut(h, y, E = W) {
    if (["recovered", "canonical"].some((rt) => rt in E))
      throw new Error("sign() legacy options not supported");
    const { hash: b, randomBytes: x } = t;
    let { lowS: M, prehash: g, extraEntropy: f } = E;
    M == null && (M = !0), h = ue("msgHash", h), g && (h = ue("prehashed msgHash", b(h)));
    const v = K(h), Q = w(y), V = [dt(Q), dt(v)];
    if (f != null && f !== !1) {
      const rt = f === !0 ? x(n.BYTES) : f;
      V.push(ue("extraEntropy", rt));
    }
    const q = Rn(...V), nt = v;
    function $(rt) {
      const Pt = z(rt);
      if (!S(Pt))
        return;
      const ft = d(Pt), ht = m.BASE.multiply(Pt).toAffine(), At = u(ht.x);
      if (At === nn)
        return;
      const pt = u(ft * u(nt + At * Q));
      if (pt === nn)
        return;
      let vt = (ht.x === At ? 0 : 2) | Number(ht.y & De), Qe = pt;
      return M && O(pt) && (Qe = U(pt), vt ^= 1), new P(At, Qe, vt);
    }
    return { seed: q, k2sig: $ };
  }
  const W = { lowS: t.lowS, prehash: !1 }, Et = { lowS: t.lowS, prehash: !1 };
  function I(h, y, E = W) {
    const { seed: b, k2sig: x } = ut(h, y, E), M = t;
    return Su(M.hash.outputLen, M.nByteLength, M.hmac)(b, x);
  }
  m.BASE._setWindowSize(8);
  function a(h, y, E, b = Et) {
    var ht;
    const x = h;
    if (y = ue("msgHash", y), E = ue("publicKey", E), "strict" in b)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: M, prehash: g } = b;
    let f, v;
    try {
      if (typeof x == "string" || Sn(x))
        try {
          f = P.fromDER(x);
        } catch (At) {
          if (!(At instanceof In.Err))
            throw At;
          f = P.fromCompact(x);
        }
      else if (typeof x == "object" && typeof x.r == "bigint" && typeof x.s == "bigint") {
        const { r: At, s: pt } = x;
        f = new P(At, pt);
      } else
        throw new Error("PARSE");
      v = m.fromHex(E);
    } catch (At) {
      if (At.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (M && f.hasHighS())
      return !1;
    g && (y = t.hash(y));
    const { r: Q, s: V } = f, q = K(y), nt = d(V), $ = u(q * nt), rt = u(Q * nt), Pt = (ht = m.BASE.multiplyAndAddUnsafe(v, $, rt)) == null ? void 0 : ht.toAffine();
    return Pt ? u(Pt.x) === Q : !1;
  }
  return {
    CURVE: t,
    getPublicKey: L,
    getSharedSecret: _,
    sign: I,
    verify: a,
    ProjectivePoint: m,
    Signature: P,
    utils: G
  };
}
class Ac extends xu {
  constructor(t, n) {
    super(), this.finished = !1, this.destroyed = !1, Ah(t);
    const r = Zs(n);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const i = this.blockLen, s = new Uint8Array(i);
    s.set(r.length > i ? t.create().update(r).digest() : r);
    for (let o = 0; o < s.length; o++)
      s[o] ^= 54;
    this.iHash.update(s), this.oHash = t.create();
    for (let o = 0; o < s.length; o++)
      s[o] ^= 106;
    this.oHash.update(s), s.fill(0);
  }
  update(t) {
    return Xr(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    Xr(this), fi(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: r, finished: i, destroyed: s, blockLen: o, outputLen: u } = this;
    return t = t, t.finished = i, t.destroyed = s, t.blockLen = o, t.outputLen = u, t.oHash = n._cloneInto(t.oHash), t.iHash = r._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const xc = (e, t, n) => new Ac(e, t).update(n).digest();
xc.create = (e, t) => new Ac(e, t);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function e1(e) {
  return {
    hash: e,
    hmac: (t, ...n) => xc(e, t, Au(...n)),
    randomBytes: vu
  };
}
function n1(e, t) {
  const n = (r) => t1({ ...e, ...e1(r) });
  return Object.freeze({ ...n(t), create: n });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ec = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), ua = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), r1 = BigInt(1), Cs = BigInt(2), ca = (e, t) => (e + t / Cs) / t;
function i1(e) {
  const t = Ec, n = BigInt(3), r = BigInt(6), i = BigInt(11), s = BigInt(22), o = BigInt(23), u = BigInt(44), d = BigInt(88), m = e * e * e % t, w = m * m * e % t, B = Gt(w, n, t) * w % t, S = Gt(B, n, t) * w % t, T = Gt(S, Cs, t) * m % t, O = Gt(T, i, t) * T % t, U = Gt(O, s, t) * O % t, R = Gt(U, u, t) * U % t, P = Gt(R, d, t) * R % t, G = Gt(P, u, t) * U % t, L = Gt(G, n, t) * w % t, Z = Gt(L, o, t) * O % t, _ = Gt(Z, r, t) * m % t, z = Gt(_, Cs, t);
  if (!Ts.eql(Ts.sqr(z), e))
    throw new Error("Cannot find square root");
  return z;
}
const Ts = Ru(Ec, void 0, void 0, { sqrt: i1 }), ho = n1({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp: Ts,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: ua,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = ua, n = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), r = -r1 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), s = n, o = BigInt("0x100000000000000000000000000000000"), u = ca(s * e, t), d = ca(-r * e, t);
      let m = Lt(e - u * n - d * i, t), w = Lt(-u * r - d * s, t);
      const B = m > o, S = w > o;
      if (B && (m = t - m), S && (w = t - w), m > o || w > o)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: B, k1: m, k2neg: S, k2: w };
    }
  }
}, Is);
BigInt(0);
ho.ProjectivePoint;
Ou.utils.randomPrivateKey;
function fa(e) {
  try {
    return Ou.ExtendedPoint.fromHex(e), !0;
  } catch {
    return !1;
  }
}
const s1 = (e) => _t.Buffer.isBuffer(e) ? e : e instanceof Uint8Array ? _t.Buffer.from(e.buffer, e.byteOffset, e.byteLength) : _t.Buffer.from(e);
class o1 {
  constructor(t) {
    Object.assign(this, t);
  }
  encode() {
    return _t.Buffer.from(Vu(Vr, this));
  }
  static decode(t) {
    return qu(Vr, this, t);
  }
  static decodeUnchecked(t) {
    return _u(Vr, this, t);
  }
}
const Vr = /* @__PURE__ */ new Map();
var vc;
const a1 = 32, cs = 32;
function u1(e) {
  return e._bn !== void 0;
}
let la = 1;
class gt extends o1 {
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(t) {
    if (super({}), this._bn = void 0, u1(t))
      this._bn = t._bn;
    else {
      if (typeof t == "string") {
        const n = ia.decode(t);
        if (n.length != cs)
          throw new Error("Invalid public key input");
        this._bn = new ws(n);
      } else
        this._bn = new ws(t);
      if (this._bn.byteLength() > cs)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const t = new gt(la);
    return la += 1, new gt(t.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(t) {
    return this._bn.eq(t._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return ia.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const t = this.toBuffer();
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const t = this._bn.toArrayLike(_t.Buffer);
    if (t.length === cs)
      return t;
    const n = _t.Buffer.alloc(32);
    return t.copy(n, 32 - t.length), n;
  }
  get [Symbol.toStringTag]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(t, n, r) {
    const i = _t.Buffer.concat([t.toBuffer(), _t.Buffer.from(n), r.toBuffer()]), s = Is(i);
    return new gt(s);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(t, n) {
    let r = _t.Buffer.alloc(0);
    t.forEach(function(s) {
      if (s.length > a1)
        throw new TypeError("Max seed length exceeded");
      r = _t.Buffer.concat([r, s1(s)]);
    }), r = _t.Buffer.concat([r, n.toBuffer(), _t.Buffer.from("ProgramDerivedAddress")]);
    const i = Is(r);
    if (fa(i))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new gt(i);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(t, n) {
    return this.createProgramAddressSync(t, n);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(t, n) {
    let r = 255, i;
    for (; r != 0; ) {
      try {
        const s = t.concat(_t.Buffer.from([r]));
        i = this.createProgramAddressSync(s, n);
      } catch (s) {
        if (s instanceof TypeError)
          throw s;
        r--;
        continue;
      }
      return [i, r];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(t, n) {
    return this.findProgramAddressSync(t, n);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(t) {
    const n = new gt(t);
    return fa(n.toBytes());
  }
}
vc = gt;
gt.default = new vc("11111111111111111111111111111111");
Vr.set(gt, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
new gt("BPFLoader1111111111111111111111111111111111");
const c1 = 64, xt = (e = "publicKey") => rr(32, e), qn = (e = "string") => {
  const t = et([tt("length"), tt("lengthPadding"), rr(Cn(tt(), -8), "chars")], e), n = t.decode.bind(t), r = t.encode.bind(t), i = t;
  return i.decode = (s, o) => n(s, o).chars.toString(), i.encode = (s, o, u) => {
    const d = {
      chars: _t.Buffer.from(s, "utf8")
    };
    return r(d, o, u);
  }, i.alloc = (s) => tt().span + tt().span + _t.Buffer.from(s, "utf8").length, i;
}, f1 = (e = "authorized") => et([xt("staker"), xt("withdrawer")], e), l1 = (e = "lockup") => et([Se("unixTimestamp"), Se("epoch"), xt("custodian")], e), h1 = (e = "voteInit") => et([xt("nodePubkey"), xt("authorizedVoter"), xt("authorizedWithdrawer"), ae("commission")], e), d1 = (e = "voteAuthorizeWithSeedArgs") => et([tt("voteAuthorizationType"), xt("currentAuthorityDerivedKeyOwnerPubkey"), qn("currentAuthorityDerivedKeySeed"), xt("newAuthorized")], e);
_t.Buffer.alloc(c1).fill(0);
new gt("SysvarC1ock11111111111111111111111111111111");
new gt("SysvarEpochSchedu1e111111111111111111111111");
new gt("Sysvar1nstructions1111111111111111111111111");
new gt("SysvarRecentB1ockHashes11111111111111111111");
new gt("SysvarRent111111111111111111111111111111111");
new gt("SysvarRewards111111111111111111111111111111");
new gt("SysvarS1otHashes111111111111111111111111111");
new gt("SysvarS1otHistory11111111111111111111111111");
new gt("SysvarStakeHistory1111111111111111111111111");
const p1 = de("lamportsPerSignature"), y1 = et([tt("version"), tt("state"), xt("authorizedPubkey"), xt("nonce"), et([p1], "feeCalculator")]);
y1.span;
const m1 = (e) => {
  const t = e.decode.bind(e), n = e.encode.bind(e);
  return {
    decode: t,
    encode: n
  };
}, g1 = (e) => (t) => {
  const n = rr(e, t), {
    encode: r,
    decode: i
  } = m1(n), s = n;
  return s.decode = (o, u) => {
    const d = i(o, u);
    return ep(_t.Buffer.from(d));
  }, s.encode = (o, u, d) => {
    const m = ip(o, e);
    return r(m, u, d);
  }, s;
}, sr = g1(8);
Object.freeze({
  Create: {
    index: 0,
    layout: et([tt("instruction"), Se("lamports"), Se("space"), xt("programId")])
  },
  Assign: {
    index: 1,
    layout: et([tt("instruction"), xt("programId")])
  },
  Transfer: {
    index: 2,
    layout: et([tt("instruction"), sr("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: et([tt("instruction"), xt("base"), qn("seed"), Se("lamports"), Se("space"), xt("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: et([tt("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: et([tt("instruction"), Se("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: et([tt("instruction"), xt("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: et([tt("instruction"), xt("authorized")])
  },
  Allocate: {
    index: 8,
    layout: et([tt("instruction"), Se("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: et([tt("instruction"), xt("base"), qn("seed"), Se("space"), xt("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: et([tt("instruction"), xt("base"), qn("seed"), xt("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: et([tt("instruction"), sr("lamports"), qn("seed"), xt("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: et([tt("instruction")])
  }
});
new gt("11111111111111111111111111111111");
new gt("BPFLoader2111111111111111111111111111111111");
et([
  tt("typeIndex"),
  sr("deactivationSlot"),
  de("lastExtendedSlot"),
  ae("lastExtendedStartIndex"),
  ae(),
  // option
  Bn(xt(), Cn(ae(), -1), "authority")
]);
const ce = Ur(fo(gt), j(), (e) => new gt(e)), Bc = lo([j(), zt("base64")]), po = Ur(fo(_t.Buffer), Bc, (e) => _t.Buffer.from(e[0], "base64"));
function Ic(e) {
  return Ce([H({
    jsonrpc: zt("2.0"),
    id: j(),
    result: e
  }), H({
    jsonrpc: zt("2.0"),
    id: j(),
    error: H({
      code: Sr(),
      message: j(),
      data: it(hp())
    })
  })]);
}
const w1 = Ic(Sr());
function Nt(e) {
  return Ur(Ic(e), w1, (t) => "error" in t ? t : {
    ...t,
    result: Br(t.result, e)
  });
}
function Le(e) {
  return Nt(H({
    context: H({
      slot: D()
    }),
    value: e
  }));
}
function wi(e) {
  return H({
    context: H({
      slot: D()
    }),
    value: e
  });
}
const b1 = H({
  foundation: D(),
  foundationTerm: D(),
  initial: D(),
  taper: D(),
  terminal: D()
});
Nt(X(J(H({
  epoch: D(),
  effectiveSlot: D(),
  amount: D(),
  postBalance: D(),
  commission: it(J(D()))
}))));
const A1 = X(H({
  slot: D(),
  prioritizationFee: D()
})), x1 = H({
  total: D(),
  validator: D(),
  foundation: D(),
  epoch: D()
}), E1 = H({
  epoch: D(),
  slotIndex: D(),
  slotsInEpoch: D(),
  absoluteSlot: D(),
  blockHeight: it(D()),
  transactionCount: it(D())
}), v1 = H({
  slotsPerEpoch: D(),
  leaderScheduleSlotOffset: D(),
  warmup: Ke(),
  firstNormalEpoch: D(),
  firstNormalSlot: D()
}), B1 = fc(j(), X(D())), kn = J(Ce([H({}), j()])), I1 = H({
  err: kn
}), M1 = zt("receivedSignature");
H({
  "solana-core": j(),
  "feature-set": it(D())
});
Le(H({
  err: J(Ce([H({}), j()])),
  logs: J(X(j())),
  accounts: it(J(X(J(H({
    executable: Ke(),
    owner: j(),
    lamports: D(),
    data: X(j()),
    rentEpoch: it(D())
  }))))),
  unitsConsumed: it(D()),
  returnData: it(J(H({
    programId: j(),
    data: lo([j(), zt("base64")])
  })))
}));
Le(H({
  byIdentity: fc(j(), X(D())),
  range: H({
    firstSlot: D(),
    lastSlot: D()
  })
}));
Nt(b1);
Nt(x1);
Nt(A1);
Nt(E1);
Nt(v1);
Nt(B1);
Nt(D());
Le(H({
  total: D(),
  circulating: D(),
  nonCirculating: D(),
  nonCirculatingAccounts: X(ce)
}));
const C1 = H({
  amount: j(),
  uiAmount: J(D()),
  decimals: D(),
  uiAmountString: it(j())
});
Le(X(H({
  address: ce,
  amount: j(),
  uiAmount: J(D()),
  decimals: D(),
  uiAmountString: it(j())
})));
Le(X(H({
  pubkey: ce,
  account: H({
    executable: Ke(),
    owner: ce,
    lamports: D(),
    data: po,
    rentEpoch: D()
  })
})));
const Ss = H({
  program: j(),
  parsed: Sr(),
  space: D()
});
Le(X(H({
  pubkey: ce,
  account: H({
    executable: Ke(),
    owner: ce,
    lamports: D(),
    data: Ss,
    rentEpoch: D()
  })
})));
Le(X(H({
  lamports: D(),
  address: ce
})));
const yo = H({
  executable: Ke(),
  owner: ce,
  lamports: D(),
  data: po,
  rentEpoch: D()
});
H({
  pubkey: ce,
  account: yo
});
const T1 = Ur(Ce([fo(_t.Buffer), Ss]), Ce([Bc, Ss]), (e) => Array.isArray(e) ? Br(e, po) : e), S1 = H({
  executable: Ke(),
  owner: ce,
  lamports: D(),
  data: T1,
  rentEpoch: D()
});
H({
  pubkey: ce,
  account: S1
});
H({
  state: Ce([zt("active"), zt("inactive"), zt("activating"), zt("deactivating")]),
  active: D(),
  inactive: D()
});
Nt(X(H({
  signature: j(),
  slot: D(),
  err: kn,
  memo: J(j()),
  blockTime: it(J(D()))
})));
Nt(X(H({
  signature: j(),
  slot: D(),
  err: kn,
  memo: J(j()),
  blockTime: it(J(D()))
})));
H({
  subscription: D(),
  result: wi(yo)
});
const U1 = H({
  pubkey: ce,
  account: yo
});
H({
  subscription: D(),
  result: wi(U1)
});
const R1 = H({
  parent: D(),
  slot: D(),
  root: D()
});
H({
  subscription: D(),
  result: R1
});
const N1 = Ce([H({
  type: Ce([zt("firstShredReceived"), zt("completed"), zt("optimisticConfirmation"), zt("root")]),
  slot: D(),
  timestamp: D()
}), H({
  type: zt("createdBank"),
  parent: D(),
  slot: D(),
  timestamp: D()
}), H({
  type: zt("frozen"),
  slot: D(),
  timestamp: D(),
  stats: H({
    numTransactionEntries: D(),
    numSuccessfulTransactions: D(),
    numFailedTransactions: D(),
    maxTransactionsPerEntry: D()
  })
}), H({
  type: zt("dead"),
  slot: D(),
  timestamp: D(),
  err: j()
})]);
H({
  subscription: D(),
  result: N1
});
H({
  subscription: D(),
  result: wi(Ce([I1, M1]))
});
H({
  subscription: D(),
  result: D()
});
H({
  pubkey: j(),
  gossip: J(j()),
  tpu: J(j()),
  rpc: J(j()),
  version: J(j())
});
const ha = H({
  votePubkey: j(),
  nodePubkey: j(),
  activatedStake: D(),
  epochVoteAccount: Ke(),
  epochCredits: X(lo([D(), D(), D()])),
  commission: D(),
  lastVote: D(),
  rootSlot: J(D())
});
Nt(H({
  current: X(ha),
  delinquent: X(ha)
}));
const D1 = Ce([zt("processed"), zt("confirmed"), zt("finalized")]), k1 = H({
  slot: D(),
  confirmations: J(D()),
  err: kn,
  confirmationStatus: it(D1)
});
Le(X(J(k1)));
Nt(D());
const Mc = H({
  accountKey: ce,
  writableIndexes: X(D()),
  readonlyIndexes: X(D())
}), mo = H({
  signatures: X(j()),
  message: H({
    accountKeys: X(j()),
    header: H({
      numRequiredSignatures: D(),
      numReadonlySignedAccounts: D(),
      numReadonlyUnsignedAccounts: D()
    }),
    instructions: X(H({
      accounts: X(D()),
      data: j(),
      programIdIndex: D()
    })),
    recentBlockhash: j(),
    addressTableLookups: it(X(Mc))
  })
}), Cc = H({
  pubkey: ce,
  signer: Ke(),
  writable: Ke(),
  source: it(Ce([zt("transaction"), zt("lookupTable")]))
}), Tc = H({
  accountKeys: X(Cc),
  signatures: X(j())
}), Sc = H({
  parsed: Sr(),
  program: j(),
  programId: ce
}), Uc = H({
  accounts: X(ce),
  data: j(),
  programId: ce
}), O1 = Ce([Uc, Sc]), F1 = Ce([H({
  parsed: Sr(),
  program: j(),
  programId: j()
}), H({
  accounts: X(j()),
  data: j(),
  programId: j()
})]), Rc = Ur(O1, F1, (e) => "accounts" in e ? Br(e, Uc) : Br(e, Sc)), Nc = H({
  signatures: X(j()),
  message: H({
    accountKeys: X(Cc),
    instructions: X(Rc),
    recentBlockhash: j(),
    addressTableLookups: it(J(X(Mc)))
  })
}), ii = H({
  accountIndex: D(),
  mint: j(),
  owner: it(j()),
  uiTokenAmount: C1
}), Dc = H({
  writable: X(ce),
  readonly: X(ce)
}), bi = H({
  err: kn,
  fee: D(),
  innerInstructions: it(J(X(H({
    index: D(),
    instructions: X(H({
      accounts: X(D()),
      data: j(),
      programIdIndex: D()
    }))
  })))),
  preBalances: X(D()),
  postBalances: X(D()),
  logMessages: it(J(X(j()))),
  preTokenBalances: it(J(X(ii))),
  postTokenBalances: it(J(X(ii))),
  loadedAddresses: it(Dc),
  computeUnitsConsumed: it(D())
}), go = H({
  err: kn,
  fee: D(),
  innerInstructions: it(J(X(H({
    index: D(),
    instructions: X(Rc)
  })))),
  preBalances: X(D()),
  postBalances: X(D()),
  logMessages: it(J(X(j()))),
  preTokenBalances: it(J(X(ii))),
  postTokenBalances: it(J(X(ii))),
  loadedAddresses: it(Dc),
  computeUnitsConsumed: it(D())
}), lr = Ce([zt(0), zt("legacy")]), On = H({
  pubkey: j(),
  lamports: D(),
  postBalance: J(D()),
  rewardType: J(j()),
  commission: it(J(D()))
});
Nt(J(H({
  blockhash: j(),
  previousBlockhash: j(),
  parentSlot: D(),
  transactions: X(H({
    transaction: mo,
    meta: J(bi),
    version: it(lr)
  })),
  rewards: it(X(On)),
  blockTime: J(D()),
  blockHeight: J(D())
})));
Nt(J(H({
  blockhash: j(),
  previousBlockhash: j(),
  parentSlot: D(),
  rewards: it(X(On)),
  blockTime: J(D()),
  blockHeight: J(D())
})));
Nt(J(H({
  blockhash: j(),
  previousBlockhash: j(),
  parentSlot: D(),
  transactions: X(H({
    transaction: Tc,
    meta: J(bi),
    version: it(lr)
  })),
  rewards: it(X(On)),
  blockTime: J(D()),
  blockHeight: J(D())
})));
Nt(J(H({
  blockhash: j(),
  previousBlockhash: j(),
  parentSlot: D(),
  transactions: X(H({
    transaction: Nc,
    meta: J(go),
    version: it(lr)
  })),
  rewards: it(X(On)),
  blockTime: J(D()),
  blockHeight: J(D())
})));
Nt(J(H({
  blockhash: j(),
  previousBlockhash: j(),
  parentSlot: D(),
  transactions: X(H({
    transaction: Tc,
    meta: J(go),
    version: it(lr)
  })),
  rewards: it(X(On)),
  blockTime: J(D()),
  blockHeight: J(D())
})));
Nt(J(H({
  blockhash: j(),
  previousBlockhash: j(),
  parentSlot: D(),
  rewards: it(X(On)),
  blockTime: J(D()),
  blockHeight: J(D())
})));
Nt(J(H({
  blockhash: j(),
  previousBlockhash: j(),
  parentSlot: D(),
  transactions: X(H({
    transaction: mo,
    meta: J(bi)
  })),
  rewards: it(X(On)),
  blockTime: J(D())
})));
Nt(J(H({
  blockhash: j(),
  previousBlockhash: j(),
  parentSlot: D(),
  signatures: X(j()),
  blockTime: J(D())
})));
Nt(J(H({
  slot: D(),
  meta: J(bi),
  blockTime: it(J(D())),
  transaction: mo,
  version: it(lr)
})));
Nt(J(H({
  slot: D(),
  transaction: Nc,
  meta: J(go),
  blockTime: it(J(D())),
  version: it(lr)
})));
Le(H({
  blockhash: j(),
  feeCalculator: H({
    lamportsPerSignature: D()
  })
}));
Le(H({
  blockhash: j(),
  lastValidBlockHeight: D()
}));
Le(Ke());
const L1 = H({
  slot: D(),
  numTransactions: D(),
  numSlots: D(),
  samplePeriodSecs: D()
});
Nt(X(L1));
Le(J(H({
  feeCalculator: H({
    lamportsPerSignature: D()
  })
})));
Nt(j());
Nt(j());
const P1 = H({
  err: kn,
  logs: X(j()),
  signature: j()
});
H({
  result: wi(P1),
  subscription: D()
});
Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: et([tt("instruction"), sr("recentSlot"), ae("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: et([tt("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: et([tt("instruction"), sr(), Bn(xt(), Cn(tt(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: et([tt("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: et([tt("instruction")])
  }
});
new gt("AddressLookupTab1e1111111111111111111111111");
Object.freeze({
  RequestUnits: {
    index: 0,
    layout: et([ae("instruction"), tt("units"), tt("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: et([ae("instruction"), tt("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: et([ae("instruction"), tt("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: et([ae("instruction"), sr("microLamports")])
  }
});
new gt("ComputeBudget111111111111111111111111111111");
et([ae("numSignatures"), ae("padding"), ke("signatureOffset"), ke("signatureInstructionIndex"), ke("publicKeyOffset"), ke("publicKeyInstructionIndex"), ke("messageDataOffset"), ke("messageDataSize"), ke("messageInstructionIndex")]);
new gt("Ed25519SigVerify111111111111111111111111111");
ho.utils.isValidPrivateKey;
ho.getPublicKey;
et([ae("numSignatures"), ke("signatureOffset"), ae("signatureInstructionIndex"), ke("ethAddressOffset"), ae("ethAddressInstructionIndex"), ke("messageDataOffset"), ke("messageDataSize"), ae("messageInstructionIndex"), rr(20, "ethAddress"), rr(64, "signature"), ae("recoveryId")]);
new gt("KeccakSecp256k11111111111111111111111111111");
var kc;
new gt("StakeConfig11111111111111111111111111111111");
class Oc {
  /**
   * Create a new Lockup object
   */
  constructor(t, n, r) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = t, this.epoch = n, this.custodian = r;
  }
  /**
   * Default, inactive Lockup value
   */
}
kc = Oc;
Oc.default = new kc(0, 0, gt.default);
Object.freeze({
  Initialize: {
    index: 0,
    layout: et([tt("instruction"), f1(), l1()])
  },
  Authorize: {
    index: 1,
    layout: et([tt("instruction"), xt("newAuthorized"), tt("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: et([tt("instruction")])
  },
  Split: {
    index: 3,
    layout: et([tt("instruction"), Se("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: et([tt("instruction"), Se("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: et([tt("instruction")])
  },
  Merge: {
    index: 7,
    layout: et([tt("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: et([tt("instruction"), xt("newAuthorized"), tt("stakeAuthorizationType"), qn("authoritySeed"), xt("authorityOwner")])
  }
});
new gt("Stake11111111111111111111111111111111111111");
Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: et([tt("instruction"), h1()])
  },
  Authorize: {
    index: 1,
    layout: et([tt("instruction"), xt("newAuthorized"), tt("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: et([tt("instruction"), Se("lamports")])
  },
  UpdateValidatorIdentity: {
    index: 4,
    layout: et([tt("instruction")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: et([tt("instruction"), d1()])
  }
});
new gt("Vote111111111111111111111111111111111111111");
new gt("Va1idator1nfo111111111111111111111111111111");
H({
  name: j(),
  website: it(j()),
  details: it(j()),
  keybaseUsername: it(j())
});
new gt("Vote111111111111111111111111111111111111111");
et([
  xt("nodePubkey"),
  xt("authorizedWithdrawer"),
  ae("commission"),
  de(),
  // votes.length
  Bn(et([de("slot"), tt("confirmationCount")]), Cn(tt(), -8), "votes"),
  ae("rootSlotValid"),
  de("rootSlot"),
  de(),
  // authorizedVoters.length
  Bn(et([de("epoch"), xt("authorizedVoter")]), Cn(tt(), -8), "authorizedVoters"),
  et([Bn(et([xt("authorizedPubkey"), de("epochOfLastAuthorizedSwitch"), de("targetEpoch")]), 32, "buf"), de("idx"), ae("isEmpty")], "priorVoters"),
  de(),
  // epochCredits.length
  Bn(et([de("epoch"), de("credits"), de("prevCredits")]), Cn(tt(), -8), "epochCredits"),
  et([de("slot"), de("timestamp")], "lastTimestamp")
]);
const _1 = "strings/5.7.0", z1 = new Bt(_1);
var si;
(function(e) {
  e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
})(si || (si = {}));
var da;
(function(e) {
  e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
})(da || (da = {}));
function H1(e, t = si.current) {
  t != si.current && (z1.checkNormalize(), e = e.normalize(t));
  let n = [];
  for (let r = 0; r < e.length; r++) {
    const i = e.charCodeAt(r);
    if (i < 128)
      n.push(i);
    else if (i < 2048)
      n.push(i >> 6 | 192), n.push(i & 63 | 128);
    else if ((i & 64512) == 55296) {
      r++;
      const s = e.charCodeAt(r);
      if (r >= e.length || (s & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const o = 65536 + ((i & 1023) << 10) + (s & 1023);
      n.push(o >> 18 | 240), n.push(o >> 12 & 63 | 128), n.push(o >> 6 & 63 | 128), n.push(o & 63 | 128);
    } else
      n.push(i >> 12 | 224), n.push(i >> 6 & 63 | 128), n.push(i & 63 | 128);
  }
  return je(n);
}
const G1 = "solidity/5.7.0", Q1 = new RegExp("^bytes([0-9]+)$"), V1 = new RegExp("^(u?int)([0-9]*)$"), q1 = new RegExp("^(.*)\\[([0-9]*)\\]$"), j1 = "0000000000000000000000000000000000000000000000000000000000000000", Qn = new Bt(G1);
function Fc(e, t, n) {
  switch (e) {
    case "address":
      return n ? Ki(t, 32) : je(t);
    case "string":
      return H1(t);
    case "bytes":
      return je(t);
    case "bool":
      return t = t ? "0x01" : "0x00", n ? Ki(t, 32) : je(t);
  }
  let r = e.match(V1);
  if (r) {
    let i = parseInt(r[2] || "256");
    return (r[2] && String(i) !== r[2] || i % 8 !== 0 || i === 0 || i > 256) && Qn.throwArgumentError("invalid number type", "type", e), n && (i = 256), t = yt.from(t).toTwos(i), Ki(t, i / 8);
  }
  if (r = e.match(Q1), r) {
    const i = parseInt(r[1]);
    return (String(i) !== r[1] || i === 0 || i > 32) && Qn.throwArgumentError("invalid bytes type", "type", e), je(t).byteLength !== i && Qn.throwArgumentError(`invalid value for ${e}`, "value", t), n ? je((t + j1).substring(0, 66)) : t;
  }
  if (r = e.match(q1), r && Array.isArray(t)) {
    const i = r[1];
    parseInt(r[2] || String(t.length)) != t.length && Qn.throwArgumentError(`invalid array length for ${e}`, "value", t);
    const o = [];
    return t.forEach(function(u) {
      o.push(Fc(i, u, !0));
    }), yu(o);
  }
  return Qn.throwArgumentError("invalid type", "type", e);
}
function hn(e, t) {
  e.length != t.length && Qn.throwArgumentError("wrong number of values; expected ${ types.length }", "values", t);
  const n = [];
  return e.forEach(function(r, i) {
    n.push(Fc(r, t[i]));
  }), vn(yu(n));
}
var Z1 = process.env.NODE_ENV === "production", fs = "Invariant failed";
function dr(e, t) {
  if (!e) {
    if (Z1)
      throw new Error(fs);
    var n = typeof t == "function" ? t() : t, r = n ? "".concat(fs, ": ").concat(n) : fs;
    throw new Error(r);
  }
}
function K1(e) {
  return oh(e, 32);
}
function wn(e) {
  return e.replace(/^0x/, "");
}
var pr = yt.from("0xffffffffffffffffffffffffffffffff"), Y1 = class Us {
  // dissuade public instantiation
  constructor() {
    Mt(this, "workerOptions", []);
  }
  /**
   * Create a new options instance.
   */
  static newOptions() {
    return new Us();
  }
  /**
   * Create an options instance from a hex string.
   * @param {string} optionsHex The hex string to decode.
   */
  static fromOptions(t) {
    const n = new Us(), r = je(t), i = yt.from(r.slice(0, 2)).toNumber();
    if (i === 3) {
      let s = 2;
      for (; s < r.byteLength; ) {
        const o = yt.from(r.slice(s, s + 1)).toNumber();
        s += 1;
        const u = yt.from(r.slice(s, s + 2)).toNumber();
        if (s += 2, o === 1) {
          const d = yt.from(r.slice(s, s + 1)).toNumber();
          s += 1;
          const m = r.slice(s, s + u - 1);
          s += u - 1, n.addOption(o, { type: d, params: vn(m) });
        } else if (o === 2) {
          const d = yt.from(r.slice(s, s + 1)).toNumber();
          s += 1;
          const m = yt.from(r.slice(s, s + 1)).toNumber();
          s += 1;
          const w = r.slice(s, s + u - 2);
          s += u - 2, n.addOption(o, {
            type: m,
            index: d,
            params: vn(w)
          });
        }
      }
    } else if (i === 2) {
      const s = yt.from(r.slice(2, 34)).toBigInt(), o = yt.from(r.slice(34, 66)).toBigInt(), u = vn(r.slice(66, r.byteLength));
      n.addExecutorLzReceiveOption(s).addExecutorNativeDropOption(o, u);
    } else if (i === 1) {
      const s = yt.from(r.slice(2, 34)).toBigInt();
      n.addExecutorLzReceiveOption(s);
    }
    return n;
  }
  /**
   * Add ExecutorOptionType.LZ_RECEIVE option.
   * @param {GasLimit} gasLimit
   * @param {NativeDrop} nativeDrop
   */
  addExecutorLzReceiveOption(t, n = 0) {
    const r = yt.from(t);
    dr(r.lte(pr), "gasLimit shouldn't be greater than MAX_UINT_128");
    const i = yt.from(n);
    return dr(i.lte(pr), "value shouldn't be greater than MAX_UINT_128"), this.addOption(1, {
      type: 1,
      params: i.eq(0) ? hn(["uint128"], [r]) : hn(["uint128", "uint128"], [r, i])
    }), this;
  }
  /**
   * Add ExecutorOptionType.NATIVE_DROP option.
   * @param {NativeDrop} nativeDrop
   * @param {string} receiver
   */
  addExecutorNativeDropOption(t, n) {
    const r = yt.from(t);
    return dr(r.lte(pr), "nativeDrop shouldn't be greater than MAX_UINT_128"), this.addOption(1, {
      type: 2,
      params: hn(["uint128", "bytes32"], [r, K1(n)])
    }), this;
  }
  /**
   * Add ExecutorOptionType.COMPOSE option.
   * @param {number} index
   * @param {GasLimit} gasLimit
   * @param {NativeDrop} nativeDrop
   */
  addExecutorComposeOption(t, n, r = 0) {
    const i = yt.from(n);
    dr(i.lte(pr), "gasLimit shouldn't be greater than MAX_UINT_128");
    const s = yt.from(r);
    dr(s.lte(pr), "nativeDrop shouldn't be greater than MAX_UINT_128");
    const o = s.gt(0) ? {
      type: 3,
      params: hn(["uint16", "uint128", "uint128"], [t, i, s])
    } : {
      type: 3,
      params: hn(["uint16", "uint128"], [t, i])
    };
    return this.addOption(1, o), this;
  }
  /**
   * Add ExecutorOptionType.ORDERED option.
   */
  addExecutorOrderedExecutionOption() {
    return this.addOption(1, {
      type: 4,
      params: "0x"
    }), this;
  }
  /**
   * Add VerifierOptionType.PRECRIME option.
   * @param {number} verifierIdx
   */
  addVerifierPrecrimeOption(t) {
    return this.addOption(2, {
      type: 1,
      index: t,
      params: "0x"
    }), this;
  }
  /**
   * Serialize Options to hex string.
   */
  toHex() {
    let t = hn(["uint16"], [
      3
      /* TYPE_3 */
    ]);
    return this.workerOptions.forEach((n) => {
      for (const r of n.options)
        if (n.workerId === 1)
          t += wn(
            hn(
              ["uint8", "uint16", "uint8", "bytes"],
              [n.workerId, wn(r.params).length / 2 + 1, r.type, r.params]
            )
          );
        else if (n.workerId === 2) {
          const i = r;
          t += wn(
            hn(
              ["uint8", "uint16", "uint8", "uint8", "bytes"],
              [
                n.workerId,
                wn(r.params).length / 2 + 2,
                i.index,
                i.type,
                i.params
              ]
            )
          );
        }
    }), t;
  }
  /**
   * Serialize Options to Uint8Array.
   */
  toBytes() {
    return je(this.toHex());
  }
  addOption(t, n) {
    const r = this.workerOptions.find((i) => i.workerId === t);
    r ? r.options.push(n) : this.workerOptions.push({ workerId: t, options: [n] });
  }
  /**
   * Decode ExecutorOptionType.LZ_RECEIVE option.  Returns undefined if the option is not present.
   */
  decodeExecutorLzReceiveOption() {
    const t = this.findOptions(
      1,
      1
      /* LZ_RECEIVE */
    );
    if (!t || t.length === 0)
      return;
    let n = yt.from(0).toBigInt(), r = yt.from(0).toBigInt();
    for (const i of t) {
      const s = Buffer.from(wn(i.params), "hex"), o = yt.from(s.subarray(0, 16)).toBigInt(), u = yt.from(s.length === 16 ? 0 : s.subarray(16, 32)).toBigInt();
      n = n + o, r = r + u;
    }
    return { gas: n, value: r };
  }
  /**
   * Decode ExecutorOptionType.NATIVE_DROP options.  Returns undefined if the options is not present.
   */
  decodeExecutorNativeDropOption() {
    const t = this.findOptions(
      1,
      2
      /* NATIVE_DROP */
    );
    if (!t || t.length === 0)
      return [];
    const n = t.reduce((r, i) => {
      const s = Buffer.from(wn(i.params), "hex"), o = yt.from(s.subarray(0, 16)).toBigInt(), u = vn(s.subarray(16, 48));
      return r[u] ? r[u].amount = r[u].amount + o : r[u] = { amount: o, receiver: u }, r;
    }, {});
    return Object.values(n);
  }
  /**
   * Decode ExecutorOptionType.COMPOSE options.  Returns undefined if the options is not present.
   */
  decodeExecutorComposeOption() {
    const t = this.findOptions(
      1,
      3
      /* COMPOSE */
    );
    if (!t || t.length === 0)
      return [];
    const n = t.reduce(
      (r, i) => {
        const s = Buffer.from(wn(i.params), "hex"), o = yt.from(s.subarray(0, 2)).toNumber(), u = yt.from(s.subarray(2, 18)).toBigInt(), d = (s.length === 34 ? yt.from(s.subarray(18, 34)) : yt.from(0)).toBigInt();
        return r[o] ? (r[o].gas = r[o].gas + u, r[o].value = r[o].value + d) : r[o] = { index: o, gas: u, value: d }, r;
      },
      {}
    );
    return Object.values(n);
  }
  /**
   * Decode ExecutorOptionType.ORDERED options.  Returns undefined if the options is not present.
   */
  decodeExecutorOrderedExecutionOption() {
    return this.findOptions(
      1,
      4
      /* ORDERED */
    ) !== void 0;
  }
  findOptions(t, n) {
    const r = this.workerOptions.find((i) => i.workerId === t);
    if (r)
      return n === 4 ? r.options.find((i) => i.type === n) : r.options.filter((i) => i.type === n);
  }
  /**
   * Find VerifierOption by verifierIdx and optionType.  Returns undefined if the option is not present.
   * @param {number} verifierIdx
   * @param {number} optionType
   */
  findVerifierOption(t, n) {
    const r = this.workerOptions.find(
      (i) => i.workerId === 2
      /* VERIFIER */
    );
    if (r) {
      const i = r.options.find((s) => s.type === n && s.index === t);
      if (i)
        return i;
    }
  }
};
async function J1(e) {
  const { originChainId: t, destinationChainId: n, to: r, value: i, data: s, account: o, publicClient: u } = e, d = Hc([
    "function quote(uint32 eid, address sender, bytes calldata payload, bytes calldata options) external view returns (uint256 nativeFee, uint256 lzTokenFee)",
    "function execute(uint32 eid, bytes calldata payload, bytes calldata options) external payable"
  ]), m = s0[t], w = u0[n], B = Oe({
    abi: fe.IMPLEMENTATION.ABI,
    functionName: "execute",
    args: [r, i, s, 0]
  }), T = Y1.newOptions().addExecutorLzReceiveOption(2e5, 0).toHex(), U = (await u.readContract({
    address: m,
    abi: d,
    functionName: "quote",
    args: [w, o, B, T]
  })).at(0) || 0n, R = Oe({
    abi: d,
    functionName: "execute",
    args: [w, B, T]
  });
  return {
    to: m,
    value: U + 10n,
    data: R
  };
}
const X1 = {
  CALL: 0,
  DELEGATECALL: 1,
  CREATE: 2,
  CREATE2: 3
}, W1 = {
  ERC721: "ERC721",
  ERC1155: "ERC1155"
}, $1 = {
  V2: 2,
  V3: 3
}, pa = "0.5.3";
class fy {
  constructor(t) {
    Mt(this, "chainId");
    Mt(this, "chain");
    Mt(this, "isInitialized", !1);
    Mt(this, "publicClient");
    Mt(this, "supportsV3", !0);
    // Default to V3 implementation
    Mt(this, "signer");
    Mt(this, "walletClient");
    Mt(this, "implementationAddress");
    Mt(this, "registryAddress");
    const {
      chainId: n,
      chain: r,
      signer: i,
      walletClient: s,
      publicClient: o,
      implementationAddress: u,
      registryAddress: d,
      publicClientRPCUrl: m,
      version: w
    } = t;
    if (!n && !r)
      throw new Error("chain or chainId required.");
    if (i && s)
      throw new Error("Only one of `signer` or `walletClient` should be provided.");
    if (o && m)
      throw new Error(
        "Only one of `publicClient` or `publicClientRPCUrl` should be provided."
      );
    if (this.chainId = n ?? r.id, this.chain = r ?? t0(this.chainId), i ? this.signer = i : s && (this.walletClient = s), this.publicClient = o ?? Gc({
      chain: this.chain,
      transport: s && !m ? Qc(s.transport) : Vc(m ?? void 0)
    }), this.registryAddress = d ?? fe.REGISTRY.ADDRESS, this.implementationAddress = u ?? fe.ACCOUNT_PROXY.ADDRESS, (w && w === $1.V2 || u && qc(u, Ae.IMPLEMENTATION.ADDRESS)) && (this.supportsV3 = !1, d || (this.registryAddress = Ae.REGISTRY.ADDRESS)), this.isInitialized = !0, typeof window < "u") {
      const S = c0(u);
      window.tokenboundSDK = `Tokenbound SDK ${pa} - ${S}`;
    }
  }
  /**
   * Returns the SDK's package version.
   * @returns The version of the SDK.
   */
  getSDKVersion() {
    return pa;
  }
  /**
   * Returns the tokenbound account address for a given token contract and token ID.
   * @param {`0x${string}`} params.tokenContract The address of the token contract.
   * @param {string} params.tokenId The token ID.
   * @returns The tokenbound account address.
   */
  getAccount(t) {
    const { tokenContract: n, tokenId: r, salt: i = 0, chainId: s = this.chainId } = t;
    try {
      return (this.supportsV3 ? ji : qi)(
        n,
        r,
        s,
        this.implementationAddress,
        this.registryAddress,
        i
      );
    } catch (o) {
      throw o;
    }
  }
  /**
   * Returns the prepared transaction to create a tokenbound account for a given token contract and token ID.
   * @param {`0x${string}`} params.tokenContract The address of the token contract.
   * @param {string} params.tokenId The token ID.
   * @returns The prepared transaction to create a tokenbound account. Can be sent via `sendTransaction` on an Ethers signer or viem WalletClient.
   */
  async prepareCreateAccount(t) {
    var S;
    const {
      tokenContract: n,
      tokenId: r,
      salt: i = 0,
      chainId: s = this.chainId,
      appendedCalls: o = []
    } = t, d = (this.supportsV3 ? ji : qi)(
      n,
      r,
      s,
      this.implementationAddress,
      this.registryAddress,
      i
    ), m = ![
      fe.ACCOUNT_PROXY.ADDRESS,
      fe.IMPLEMENTATION.ADDRESS
    ].includes(Qt(this.implementationAddress)), B = await (this.supportsV3 ? nh : W0)(
      n,
      r,
      s,
      this.implementationAddress,
      this.registryAddress,
      i
    );
    if (o.length > 0 && (!this.supportsV3 || m))
      throw new Error(
        "Multicall via appendedCalls is not supported using the legacy V2 implementation or custom implementations"
      );
    return m ? B : {
      to: n0,
      value: BigInt(0),
      data: Oe({
        abi: Wc,
        functionName: "aggregate3",
        args: [
          [
            {
              target: this.registryAddress,
              allowFailure: !1,
              callData: B.data
            },
            {
              target: d,
              allowFailure: !1,
              callData: Oe({
                abi: (S = fe.ACCOUNT_PROXY) == null ? void 0 : S.ABI,
                functionName: "initialize",
                args: [fe.IMPLEMENTATION.ADDRESS]
              })
            },
            // Append Multicall3 calls, so the newly-created Tokenbound account
            // can be used to execute calls immediately after creation
            ...o
          ]
        ]
      })
    };
  }
  /**
   * Returns the transaction hash of the transaction that created the tokenbound account for a given token contract and token ID.
   * @param {`0x${string}`} params.tokenContract The address of the token contract.
   * @param {string} params.tokenId The token ID.
   * @returns a Promise that resolves to the account address of the created tokenbound account.
   */
  async createAccount(t) {
    var u, d;
    const {
      tokenContract: n,
      tokenId: r,
      salt: i = 0,
      chainId: s = this.chainId,
      appendedCalls: o = []
    } = t;
    try {
      let m;
      const B = (this.supportsV3 ? ji : qi)(
        n,
        r,
        s,
        this.implementationAddress,
        this.registryAddress,
        i
      ), S = await this.prepareCreateAccount({
        tokenContract: n,
        tokenId: r,
        chainId: s,
        salt: i,
        appendedCalls: o
      });
      if (this.signer ? m = await this.signer.sendTransaction(S).then((T) => T.hash) : this.walletClient && (m = this.supportsV3 ? await this.walletClient.sendTransaction({
        ...S,
        chain: this.chain,
        account: (d = (u = this.walletClient) == null ? void 0 : u.account) == null ? void 0 : d.address
      }) : await $0(
        n,
        r,
        this.walletClient,
        this.implementationAddress,
        this.registryAddress,
        i,
        s
      )), m)
        return {
          account: B,
          txHash: m
        };
      throw new Error("No wallet client or signer available.");
    } catch (m) {
      throw m;
    }
  }
  /**
   * Returns prepared transaction to execute a call on a tokenbound account
   * @param {string} params.account The tokenbound account address
   * @param {string} params.to The recipient address
   * @param {bigint} params.value The value to send, in wei
   * @param {string} params.data The data to send
   * @returns a Promise with prepared transaction to execute a call on a tokenbound account. Can be sent via `sendTransaction` on a viem WalletClient or Ethers signer.
   * @deprecated this method is deprecated, but still available for use with legacy V2 deployments. Use prepareExecute() instead.
   */
  async prepareExecuteCall(t) {
    if (this.supportsV3)
      throw new Error(
        "prepareExecuteCall() is not supported on V3 implementation deployments, use prepareExecute() instead."
      );
    const { account: n, to: r, value: i, data: s } = t;
    return th(n, r, i, s);
  }
  /**
   * Executes a transaction call on a tokenbound account
   * @param {string} params.account The tokenbound account address
   * @param {string} params.to The recipient contract address
   * @param {bigint} params.value The value to send, in wei
   * @param {string} params.data The data to send
   * @returns a Promise that resolves to the transaction hash of the executed call
   * @deprecated this method is deprecated, but still available for use with legacy V2 deployments. Use execute() instead.
   */
  async executeCall(t) {
    const n = await this.prepareExecuteCall(t);
    if (this.supportsV3)
      throw new Error(
        "executeCall() is not supported on V3 implementation deployments, use execute() instead."
      );
    try {
      if (this.signer)
        return await this.signer.sendTransaction(n).then((r) => r.hash);
      if (this.walletClient)
        return await this.walletClient.sendTransaction({
          // chain and account need to be added explicitly
          // because they're optional when instantiating a WalletClient
          chain: this.chain,
          account: this.walletClient.account,
          ...n
        });
      throw new Error("No wallet client or signer available.");
    } catch (r) {
      throw r;
    }
  }
  /**
   * Returns prepared transaction to execute on a tokenbound account
   * @param {string} params.account The tokenbound account address
   * @param {string} params.to The contract address to execute the call on
   * @param {bigint} params.value The value to send, in wei
   * @param {string} params.data The encoded operation calldata to send
   * @returns a Promise with prepared transaction to execute on a tokenbound account. Can be sent via `sendTransaction` on a viem WalletClient or Ethers signer.
   */
  async prepareExecution(t) {
    const { account: n, to: r, value: i, data: s, chainId: o = this.chainId } = t, u = X1.CALL;
    if (!this.supportsV3)
      return await this.prepareExecuteCall(t);
    let d = [r, i, s, u], m = 0n;
    if (this.chainId !== o) {
      const {
        to: B,
        value: S,
        data: T
      } = await J1({
        publicClient: this.publicClient,
        account: n,
        to: r,
        value: i,
        data: s,
        originChainId: this.chainId,
        destinationChainId: o
      });
      d = [B, S, T, u], m = S;
    }
    const w = Oe({
      abi: fe.IMPLEMENTATION.ABI,
      functionName: "execute",
      args: d
    });
    return {
      to: n,
      value: m,
      data: w
    };
  }
  /**
   * Executes a transaction call on a tokenbound account
   * @param {string} params.account The tokenbound account address
   * @param {string} params.to The contract address to execute the call on
   * @param {bigint} params.value The value to send, in wei
   * @param {string} params.data The encoded operation calldata to send
   * @returns a Promise that resolves to the transaction hash of the executed call
   */
  async execute(t) {
    try {
      if (!this.supportsV3)
        return await this.executeCall(t);
      const n = await this.prepareExecution(t);
      if (this.signer)
        return await this.signer.sendTransaction(n).then((r) => r.hash);
      if (this.walletClient)
        return await this.walletClient.sendTransaction({
          // chain and account need to be added explicitly
          // because they're optional when instantiating a WalletClient
          chain: this.chain,
          account: this.walletClient.account,
          ...n
        });
      throw new Error("No wallet client or signer available.");
    } catch (n) {
      throw n;
    }
  }
  /**
   * Check if a tokenbound account is a valid signer for a transaction
   * @param {string} params.account The tokenbound account address
   * @returns a Promise that resolves to true if the account is a valid signer, otherwise false
   */
  async isValidSigner({ account: t }) {
    var u;
    const { signer: n, walletClient: r } = this, i = jc(0, { size: 32 }), s = "0x523e3260", o = ((u = r == null ? void 0 : r.account) == null ? void 0 : u.address) ?? (n == null ? void 0 : n.address);
    try {
      if (!n && !r)
        throw new Error("No signer or wallet client available.");
      if (!this.supportsV3)
        throw new Error("isValidSigner is not supported using the V2 implementation");
      return await this.publicClient.readContract({
        address: t,
        abi: fe.IMPLEMENTATION.ABI,
        functionName: "isValidSigner",
        args: [o, i]
      }) === s;
    } catch (d) {
      throw d;
    }
  }
  /**
   * Check if a tokenbound account has been deployed
   * @param {string} params.accountAddress The tokenbound account address
   * @returns a Promise that resolves to true if the account is deployed, otherwise false
   */
  async checkAccountDeployment({
    accountAddress: t
  }) {
    try {
      return await this.publicClient.getBytecode({ address: t }).then((n) => n ? n.length > 2 : !1);
    } catch (n) {
      throw n;
    }
  }
  /**
   * Deconstructs the bytecode of a tokenbound account into its constituent parts.
   * @param {`0x${string}`} params.accountAddress The address of the tokenbound account.
   * @returns a Promise that resolves to a SegmentedERC6551Bytecode object, or null if the account is not deployed
   */
  async deconstructBytecode({
    accountAddress: t
  }) {
    try {
      const n = await this.publicClient.getBytecode({ address: t }), r = n == null ? void 0 : n.slice(2);
      if (!r || !n || !(n.length > 2))
        return null;
      const [
        i,
        s,
        o,
        u,
        d,
        m,
        w
      ] = X0(r, 10, 20, 15, 32, 32, 32, 32), B = _i(`0x${d}`, { size: 32 }), S = Qt(
        `0x${s}`
      ), T = _i(`0x${u}`, { size: 32 }), O = Qt(
        `0x${m.slice(
          m.length - 40,
          m.length
        )}`
      ), U = _i(`0x${w}`, { size: 32 }).toString();
      return {
        erc1167Header: i,
        implementationAddress: S,
        erc1167Footer: o,
        salt: T,
        tokenId: U,
        tokenContract: O,
        chainId: B
      };
    } catch (n) {
      throw n;
    }
  }
  /**
   * Get NFT information from a tokenbound account
   * @param {`0x${string}`} params.accountAddress The address of the tokenbound account.
   * @returns a Promise that resolves to an object containing the token contract address, token ID, and chain ID
   */
  async getNFT({ accountAddress: t }) {
    try {
      const n = await this.deconstructBytecode({ accountAddress: t });
      if (!n)
        throw new Error("The tokenbound account has not been deployed at this address");
      const { chainId: r, tokenContract: i, tokenId: s } = n;
      return {
        tokenContract: i,
        tokenId: s,
        chainId: r
      };
    } catch (n) {
      throw n;
    }
  }
  /**
   * Executes a transaction call on a tokenbound account
   * @param {string} params.account The tokenbound account address
   * @param {string} params.tokenType The type of token, either 'ERC721' or 'ERC1155'
   * @param {string} params.tokenContract The address of the token contract
   * @param {string} params.tokenId The token ID
   * @param {string} params.recipientAddress The address to which the token should be transferred
   * @param {string} params.amount The amount of tokens to transfer, (eg. 1 NFT = 1). Defaults to 1. 1155 only.
   * @returns a Promise that resolves to the transaction hash of the executed call
   */
  async transferNFT(t) {
    const {
      account: n,
      tokenType: r,
      tokenContract: i,
      tokenId: s,
      amount: o = 1,
      recipientAddress: u,
      chainId: d
    } = t, m = r === W1.ERC1155;
    if (!m && o !== 1)
      throw new Error("ERC721 transfers can only transfer one token at a time.");
    try {
      const w = await Vi(this.publicClient, u), B = [n, w, s], S = m ? [...B, o, "0x"] : B, T = Oe({
        abi: m ? Yc : Jc,
        functionName: "safeTransferFrom",
        args: S
      }), O = {
        account: n,
        to: i,
        value: BigInt(0),
        data: T
      };
      return this.supportsV3 ? await this.execute({
        ...O,
        chainId: d
      }) : await this.executeCall(O);
    } catch (w) {
      throw console.log(w), w;
    }
  }
  /**
   * Executes an ETH transfer call on a tokenbound account
   * @param {string} params.account The tokenbound account address
   * @param {number} params.amount The amount of ETH to transfer, in decimal format (eg. 0.1 ETH = 0.1)
   * @param {string} params.recipientAddress The address to which the ETH should be transferred
   * @returns a Promise that resolves to the transaction hash of the executed call
   */
  async transferETH(t) {
    const { account: n, amount: r, recipientAddress: i, chainId: s } = t, o = Mo(`${r}`, 18);
    try {
      const u = await Vi(this.publicClient, i), d = {
        account: n,
        to: u,
        value: o,
        data: "0x"
      };
      return this.supportsV3 ? await this.execute({
        ...d,
        chainId: s
      }) : await this.executeCall(d);
    } catch (u) {
      throw console.log(u), u;
    }
  }
  /**
   * Executes an ERC-20 transfer call on a tokenbound account
   * @param {string} params.account The tokenbound account address
   * @param {number} params.amount The amount of ERC-20 to transfer, in decimal format (eg. 0.1 USDC = 0.1)
   * @param {string} params.recipientAddress The address to which the ETH should be transferred
   * @param {string} params.erc20tokenAddress The address of the ERC-20 token contract
   * @param {string} params.erc20tokenDecimals The decimal specification of the ERC-20 token
   * @returns a Promise that resolves to the transaction hash of the executed call
   */
  async transferERC20(t) {
    const {
      account: n,
      amount: r,
      recipientAddress: i,
      erc20tokenAddress: s,
      erc20tokenDecimals: o,
      chainId: u
    } = t;
    if (o < 0 || o > 18)
      throw new Error("Decimal value out of range. Should be between 0 and 18.");
    const d = Mo(`${r}`, o);
    try {
      const m = await Vi(this.publicClient, i), w = Oe({
        abi: Xc,
        functionName: "transfer",
        args: [m, d]
      }), B = {
        account: n,
        to: s,
        value: 0n,
        data: w
      };
      return this.supportsV3 ? await this.execute({
        ...B,
        chainId: u
      }) : await this.executeCall(B);
    } catch (m) {
      throw console.log(m), m;
    }
  }
  /**
   * Calculates an Ethereum-specific signature
   * @param {string} params.message The message to be signed
   * @returns a Promise that resolves to a signed Hex string
   */
  async signMessage(t) {
    const { message: n } = t;
    try {
      if (this.signer) {
        if (!f0 && !l0)
          throw new Error("Message is not a valid Ethers signable message.");
        const r = d0(n);
        return await this.signer.signMessage(r);
      } else if (this.walletClient) {
        if (!h0(n))
          throw new Error("Message is not a valid viem signable message.");
        return await this.walletClient.signMessage({
          account: this.walletClient.account,
          message: n
        });
      }
      throw new Error("No wallet client or signer available.");
    } catch (r) {
      throw console.log(r), r;
    }
  }
}
const ly = fe.IMPLEMENTATION.ABI, hy = fe.ACCOUNT_PROXY.ABI, dy = fe.REGISTRY.ABI;
export {
  X1 as CALL_OPERATIONS,
  $1 as TBVersion,
  fy as TokenboundClient,
  qi as computeAccount,
  $0 as createAccount,
  Kc as erc6551AccountAbiV2,
  ly as erc6551AccountAbiV3,
  hy as erc6551AccountProxyAbiV3,
  Zc as erc6551RegistryAbiV2,
  dy as erc6551RegistryAbiV3,
  sy as executeCall,
  iy as getAccount,
  eh as getCreationCode,
  W0 as prepareCreateAccount,
  th as prepareExecuteCall
};
